import React, { useState, useEffect, useCallback, useMemo, createContext, useContext } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useSnackbar } from 'notistack';
import { CircularProgress, MenuItem as MenuItem$1 } from 'material-ui';
import getPrototypeOf$2 from 'core-js/library/fn/object/get-prototype-of';
import defineProperty$1 from 'core-js/library/fn/object/define-property';
import iterator$1 from 'core-js/library/fn/symbol/iterator';
import symbol$1 from 'core-js/library/fn/symbol';
import setPrototypeOf$1 from 'core-js/library/fn/object/set-prototype-of';
import create$1 from 'core-js/library/fn/object/create';
import propTypes from 'prop-types';
import toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import lodash from 'lodash.merge';
import warning from 'warning';
import createPrefixer from 'inline-style-prefixer/static/createPrefixer';
import createPrefixer$1 from 'inline-style-prefixer/dynamic/createPrefixer';
import calc from 'inline-style-prefixer/dynamic/plugins/calc';
import flex from 'inline-style-prefixer/dynamic/plugins/flex';
import flexboxIE from 'inline-style-prefixer/dynamic/plugins/flexboxIE';
import flexboxOld from 'inline-style-prefixer/dynamic/plugins/flexboxOld';
import gradient from 'inline-style-prefixer/dynamic/plugins/gradient';
import sizing from 'inline-style-prefixer/dynamic/plugins/sizing';
import transition from 'inline-style-prefixer/dynamic/plugins/transition';
import calc$1 from 'inline-style-prefixer/static/plugins/calc';
import flex$1 from 'inline-style-prefixer/static/plugins/flex';
import flexboxIE$1 from 'inline-style-prefixer/static/plugins/flexboxIE';
import flexboxOld$1 from 'inline-style-prefixer/static/plugins/flexboxOld';
import gradient$1 from 'inline-style-prefixer/static/plugins/gradient';
import sizing$1 from 'inline-style-prefixer/static/plugins/sizing';
import transition$1 from 'inline-style-prefixer/static/plugins/transition';
import keys from 'babel-runtime/core-js/object/keys';
import compose from 'recompose/compose';
import classCallCheck$2 from 'babel-runtime/helpers/classCallCheck';
import { NavLink, useHistory } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import MenuItem from '@material-ui/core/MenuItem';
import ReactGA from 'react-ga4';
import { Switch } from 'formik-material-ui';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { TextField as TextField$1, Link as Link$1, Grid as Grid$1, MenuItem as MenuItem$2, FormControlLabel as FormControlLabel$1, Checkbox as Checkbox$1, Button as Button$1, FormControl, InputLabel, Select, OutlinedInput, CardHeader, Container as Container$1, FormLabel, RadioGroup, Radio, FormHelperText, Typography as Typography$1, Divider as Divider$1, Tabs, Tab, Slider, Menu, ClickAwayListener, Paper, InputBase, Collapse, List, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, IconButton as IconButton$1, Chip, Modal, Box as Box$1, Popper, Grow, MenuList } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress$1 from '@material-ui/core/CircularProgress';
import { useDropzone } from 'react-dropzone';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Resizer from 'react-image-file-resizer';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';
import { ArrowDropUp, ArrowDropDown, ExpandLess, ExpandMore } from '@material-ui/icons';
import util$1 from 'util';
import { conformToMask } from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Helmet } from 'react-helmet';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var getPrototypeOf$1 = createCommonjsModule(function (module) {
module.exports = { "default": getPrototypeOf$2, __esModule: true };
});

unwrapExports(getPrototypeOf$1);

var classCallCheck$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
});

unwrapExports(classCallCheck$1);

var defineProperty = createCommonjsModule(function (module) {
module.exports = { "default": defineProperty$1, __esModule: true };
});

unwrapExports(defineProperty);

var createClass$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperty2 = _interopRequireDefault(defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
});

unwrapExports(createClass$1);

var iterator = createCommonjsModule(function (module) {
module.exports = { "default": iterator$1, __esModule: true };
});

unwrapExports(iterator);

var symbol = createCommonjsModule(function (module) {
module.exports = { "default": symbol$1, __esModule: true };
});

unwrapExports(symbol);

var _typeof_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _iterator2 = _interopRequireDefault(iterator);



var _symbol2 = _interopRequireDefault(symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
});

unwrapExports(_typeof_1);

var possibleConstructorReturn$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _typeof3 = _interopRequireDefault(_typeof_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
});

unwrapExports(possibleConstructorReturn$1);

var setPrototypeOf = createCommonjsModule(function (module) {
module.exports = { "default": setPrototypeOf$1, __esModule: true };
});

unwrapExports(setPrototypeOf);

var create = createCommonjsModule(function (module) {
module.exports = { "default": create$1, __esModule: true };
});

unwrapExports(create);

var inherits$2 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _setPrototypeOf2 = _interopRequireDefault(setPrototypeOf);



var _create2 = _interopRequireDefault(create);



var _typeof3 = _interopRequireDefault(_typeof_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
});

unwrapExports(inherits$2);

var colorManipulator = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertColorToString = convertColorToString;
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;



var _warning2 = _interopRequireDefault(warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function convertColorToString(color) {
  var type = color.type,
      values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    for (var i = 0; i < 3; i++) {
      values[i] = parseInt(values[i]);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values and color names.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {{type: string, values: number[]}} A MUI color object
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');

  process.env.NODE_ENV !== "production" ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;

  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);

  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);

  if (color.type.indexOf('rgb') > -1) {
    var rgb = color.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
  } else if (color.type.indexOf('hsl') > -1) {
    return color.values[2] / 100;
  }
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value, 0, 1);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return convertColorToString(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}
});

unwrapExports(colorManipulator);
colorManipulator.convertColorToString;
colorManipulator.convertHexToRGB;
colorManipulator.decomposeColor;
colorManipulator.getContrastRatio;
colorManipulator.getLuminance;
colorManipulator.emphasize;
colorManipulator.fade;
colorManipulator.darken;
colorManipulator.lighten;

var colors = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.red50 = '#ffebee';
exports.red100 = '#ffcdd2';
exports.red200 = '#ef9a9a';
exports.red300 = '#e57373';
exports.red400 = '#ef5350';
exports.red500 = '#f44336';
exports.red600 = '#e53935';
exports.red700 = '#d32f2f';
exports.red800 = '#c62828';
exports.red900 = '#b71c1c';
exports.redA100 = '#ff8a80';
exports.redA200 = '#ff5252';
exports.redA400 = '#ff1744';
exports.redA700 = '#d50000';

exports.pink50 = '#fce4ec';
exports.pink100 = '#f8bbd0';
exports.pink200 = '#f48fb1';
exports.pink300 = '#f06292';
exports.pink400 = '#ec407a';
exports.pink500 = '#e91e63';
exports.pink600 = '#d81b60';
exports.pink700 = '#c2185b';
exports.pink800 = '#ad1457';
exports.pink900 = '#880e4f';
exports.pinkA100 = '#ff80ab';
exports.pinkA200 = '#ff4081';
exports.pinkA400 = '#f50057';
exports.pinkA700 = '#c51162';

exports.purple50 = '#f3e5f5';
exports.purple100 = '#e1bee7';
exports.purple200 = '#ce93d8';
exports.purple300 = '#ba68c8';
exports.purple400 = '#ab47bc';
exports.purple500 = '#9c27b0';
exports.purple600 = '#8e24aa';
exports.purple700 = '#7b1fa2';
exports.purple800 = '#6a1b9a';
exports.purple900 = '#4a148c';
exports.purpleA100 = '#ea80fc';
exports.purpleA200 = '#e040fb';
exports.purpleA400 = '#d500f9';
exports.purpleA700 = '#aa00ff';

exports.deepPurple50 = '#ede7f6';
exports.deepPurple100 = '#d1c4e9';
exports.deepPurple200 = '#b39ddb';
exports.deepPurple300 = '#9575cd';
exports.deepPurple400 = '#7e57c2';
exports.deepPurple500 = '#673ab7';
exports.deepPurple600 = '#5e35b1';
exports.deepPurple700 = '#512da8';
exports.deepPurple800 = '#4527a0';
exports.deepPurple900 = '#311b92';
exports.deepPurpleA100 = '#b388ff';
exports.deepPurpleA200 = '#7c4dff';
exports.deepPurpleA400 = '#651fff';
exports.deepPurpleA700 = '#6200ea';

exports.indigo50 = '#e8eaf6';
exports.indigo100 = '#c5cae9';
exports.indigo200 = '#9fa8da';
exports.indigo300 = '#7986cb';
exports.indigo400 = '#5c6bc0';
exports.indigo500 = '#3f51b5';
exports.indigo600 = '#3949ab';
exports.indigo700 = '#303f9f';
exports.indigo800 = '#283593';
exports.indigo900 = '#1a237e';
exports.indigoA100 = '#8c9eff';
exports.indigoA200 = '#536dfe';
exports.indigoA400 = '#3d5afe';
exports.indigoA700 = '#304ffe';

exports.blue50 = '#e3f2fd';
exports.blue100 = '#bbdefb';
exports.blue200 = '#90caf9';
exports.blue300 = '#64b5f6';
exports.blue400 = '#42a5f5';
exports.blue500 = '#2196f3';
exports.blue600 = '#1e88e5';
exports.blue700 = '#1976d2';
exports.blue800 = '#1565c0';
exports.blue900 = '#0d47a1';
exports.blueA100 = '#82b1ff';
exports.blueA200 = '#448aff';
exports.blueA400 = '#2979ff';
exports.blueA700 = '#2962ff';

exports.lightBlue50 = '#e1f5fe';
exports.lightBlue100 = '#b3e5fc';
exports.lightBlue200 = '#81d4fa';
exports.lightBlue300 = '#4fc3f7';
exports.lightBlue400 = '#29b6f6';
exports.lightBlue500 = '#03a9f4';
exports.lightBlue600 = '#039be5';
exports.lightBlue700 = '#0288d1';
exports.lightBlue800 = '#0277bd';
exports.lightBlue900 = '#01579b';
exports.lightBlueA100 = '#80d8ff';
exports.lightBlueA200 = '#40c4ff';
exports.lightBlueA400 = '#00b0ff';
exports.lightBlueA700 = '#0091ea';

exports.cyan50 = '#e0f7fa';
exports.cyan100 = '#b2ebf2';
exports.cyan200 = '#80deea';
exports.cyan300 = '#4dd0e1';
exports.cyan400 = '#26c6da';
exports.cyan500 = '#00bcd4';
exports.cyan600 = '#00acc1';
exports.cyan700 = '#0097a7';
exports.cyan800 = '#00838f';
exports.cyan900 = '#006064';
exports.cyanA100 = '#84ffff';
exports.cyanA200 = '#18ffff';
exports.cyanA400 = '#00e5ff';
exports.cyanA700 = '#00b8d4';

exports.teal50 = '#e0f2f1';
exports.teal100 = '#b2dfdb';
exports.teal200 = '#80cbc4';
exports.teal300 = '#4db6ac';
exports.teal400 = '#26a69a';
exports.teal500 = '#009688';
exports.teal600 = '#00897b';
exports.teal700 = '#00796b';
exports.teal800 = '#00695c';
exports.teal900 = '#004d40';
exports.tealA100 = '#a7ffeb';
exports.tealA200 = '#64ffda';
exports.tealA400 = '#1de9b6';
exports.tealA700 = '#00bfa5';

exports.green50 = '#e8f5e9';
exports.green100 = '#c8e6c9';
exports.green200 = '#a5d6a7';
exports.green300 = '#81c784';
exports.green400 = '#66bb6a';
exports.green500 = '#4caf50';
exports.green600 = '#43a047';
exports.green700 = '#388e3c';
exports.green800 = '#2e7d32';
exports.green900 = '#1b5e20';
exports.greenA100 = '#b9f6ca';
exports.greenA200 = '#69f0ae';
exports.greenA400 = '#00e676';
exports.greenA700 = '#00c853';

exports.lightGreen50 = '#f1f8e9';
exports.lightGreen100 = '#dcedc8';
exports.lightGreen200 = '#c5e1a5';
exports.lightGreen300 = '#aed581';
exports.lightGreen400 = '#9ccc65';
exports.lightGreen500 = '#8bc34a';
exports.lightGreen600 = '#7cb342';
exports.lightGreen700 = '#689f38';
exports.lightGreen800 = '#558b2f';
exports.lightGreen900 = '#33691e';
exports.lightGreenA100 = '#ccff90';
exports.lightGreenA200 = '#b2ff59';
exports.lightGreenA400 = '#76ff03';
exports.lightGreenA700 = '#64dd17';

exports.lime50 = '#f9fbe7';
exports.lime100 = '#f0f4c3';
exports.lime200 = '#e6ee9c';
exports.lime300 = '#dce775';
exports.lime400 = '#d4e157';
exports.lime500 = '#cddc39';
exports.lime600 = '#c0ca33';
exports.lime700 = '#afb42b';
exports.lime800 = '#9e9d24';
exports.lime900 = '#827717';
exports.limeA100 = '#f4ff81';
exports.limeA200 = '#eeff41';
exports.limeA400 = '#c6ff00';
exports.limeA700 = '#aeea00';

exports.yellow50 = '#fffde7';
exports.yellow100 = '#fff9c4';
exports.yellow200 = '#fff59d';
exports.yellow300 = '#fff176';
exports.yellow400 = '#ffee58';
exports.yellow500 = '#ffeb3b';
exports.yellow600 = '#fdd835';
exports.yellow700 = '#fbc02d';
exports.yellow800 = '#f9a825';
exports.yellow900 = '#f57f17';
exports.yellowA100 = '#ffff8d';
exports.yellowA200 = '#ffff00';
exports.yellowA400 = '#ffea00';
exports.yellowA700 = '#ffd600';

exports.amber50 = '#fff8e1';
exports.amber100 = '#ffecb3';
exports.amber200 = '#ffe082';
exports.amber300 = '#ffd54f';
exports.amber400 = '#ffca28';
exports.amber500 = '#ffc107';
exports.amber600 = '#ffb300';
exports.amber700 = '#ffa000';
exports.amber800 = '#ff8f00';
exports.amber900 = '#ff6f00';
exports.amberA100 = '#ffe57f';
exports.amberA200 = '#ffd740';
exports.amberA400 = '#ffc400';
exports.amberA700 = '#ffab00';

exports.orange50 = '#fff3e0';
exports.orange100 = '#ffe0b2';
exports.orange200 = '#ffcc80';
exports.orange300 = '#ffb74d';
exports.orange400 = '#ffa726';
exports.orange500 = '#ff9800';
exports.orange600 = '#fb8c00';
exports.orange700 = '#f57c00';
exports.orange800 = '#ef6c00';
exports.orange900 = '#e65100';
exports.orangeA100 = '#ffd180';
exports.orangeA200 = '#ffab40';
exports.orangeA400 = '#ff9100';
exports.orangeA700 = '#ff6d00';

exports.deepOrange50 = '#fbe9e7';
exports.deepOrange100 = '#ffccbc';
exports.deepOrange200 = '#ffab91';
exports.deepOrange300 = '#ff8a65';
exports.deepOrange400 = '#ff7043';
exports.deepOrange500 = '#ff5722';
exports.deepOrange600 = '#f4511e';
exports.deepOrange700 = '#e64a19';
exports.deepOrange800 = '#d84315';
exports.deepOrange900 = '#bf360c';
exports.deepOrangeA100 = '#ff9e80';
exports.deepOrangeA200 = '#ff6e40';
exports.deepOrangeA400 = '#ff3d00';
exports.deepOrangeA700 = '#dd2c00';

exports.brown50 = '#efebe9';
exports.brown100 = '#d7ccc8';
exports.brown200 = '#bcaaa4';
exports.brown300 = '#a1887f';
exports.brown400 = '#8d6e63';
exports.brown500 = '#795548';
exports.brown600 = '#6d4c41';
exports.brown700 = '#5d4037';
exports.brown800 = '#4e342e';
exports.brown900 = '#3e2723';

exports.blueGrey50 = '#eceff1';
exports.blueGrey100 = '#cfd8dc';
exports.blueGrey200 = '#b0bec5';
exports.blueGrey300 = '#90a4ae';
exports.blueGrey400 = '#78909c';
exports.blueGrey500 = '#607d8b';
exports.blueGrey600 = '#546e7a';
exports.blueGrey700 = '#455a64';
exports.blueGrey800 = '#37474f';
exports.blueGrey900 = '#263238';

exports.grey50 = '#fafafa';
exports.grey100 = '#f5f5f5';
exports.grey200 = '#eeeeee';
exports.grey300 = '#e0e0e0';
exports.grey400 = '#bdbdbd';
exports.grey500 = '#9e9e9e';
exports.grey600 = '#757575';
exports.grey700 = '#616161';
exports.grey800 = '#424242';
exports.grey900 = '#212121';

exports.black = '#000000';
exports.white = '#ffffff';

exports.transparent = 'rgba(0, 0, 0, 0)';
exports.fullBlack = 'rgba(0, 0, 0, 1)';
exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
exports.minBlack = 'rgba(0, 0, 0, 0.26)';
exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
exports.fullWhite = 'rgba(255, 255, 255, 1)';
exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
exports.lightWhite = 'rgba(255, 255, 255, 0.54)';
});

unwrapExports(colors);
colors.red50;
colors.red100;
colors.red200;
colors.red300;
colors.red400;
colors.red500;
colors.red600;
colors.red700;
colors.red800;
colors.red900;
colors.redA100;
colors.redA200;
colors.redA400;
colors.redA700;
colors.pink50;
colors.pink100;
colors.pink200;
colors.pink300;
colors.pink400;
colors.pink500;
colors.pink600;
colors.pink700;
colors.pink800;
colors.pink900;
colors.pinkA100;
colors.pinkA200;
colors.pinkA400;
colors.pinkA700;
colors.purple50;
colors.purple100;
colors.purple200;
colors.purple300;
colors.purple400;
colors.purple500;
colors.purple600;
colors.purple700;
colors.purple800;
colors.purple900;
colors.purpleA100;
colors.purpleA200;
colors.purpleA400;
colors.purpleA700;
colors.deepPurple50;
colors.deepPurple100;
colors.deepPurple200;
colors.deepPurple300;
colors.deepPurple400;
colors.deepPurple500;
colors.deepPurple600;
colors.deepPurple700;
colors.deepPurple800;
colors.deepPurple900;
colors.deepPurpleA100;
colors.deepPurpleA200;
colors.deepPurpleA400;
colors.deepPurpleA700;
colors.indigo50;
colors.indigo100;
colors.indigo200;
colors.indigo300;
colors.indigo400;
colors.indigo500;
colors.indigo600;
colors.indigo700;
colors.indigo800;
colors.indigo900;
colors.indigoA100;
colors.indigoA200;
colors.indigoA400;
colors.indigoA700;
colors.blue50;
colors.blue100;
colors.blue200;
colors.blue300;
colors.blue400;
colors.blue500;
colors.blue600;
colors.blue700;
colors.blue800;
colors.blue900;
colors.blueA100;
colors.blueA200;
colors.blueA400;
colors.blueA700;
colors.lightBlue50;
colors.lightBlue100;
colors.lightBlue200;
colors.lightBlue300;
colors.lightBlue400;
colors.lightBlue500;
colors.lightBlue600;
colors.lightBlue700;
colors.lightBlue800;
colors.lightBlue900;
colors.lightBlueA100;
colors.lightBlueA200;
colors.lightBlueA400;
colors.lightBlueA700;
colors.cyan50;
colors.cyan100;
colors.cyan200;
colors.cyan300;
colors.cyan400;
colors.cyan500;
colors.cyan600;
colors.cyan700;
colors.cyan800;
colors.cyan900;
colors.cyanA100;
colors.cyanA200;
colors.cyanA400;
colors.cyanA700;
colors.teal50;
colors.teal100;
colors.teal200;
colors.teal300;
colors.teal400;
colors.teal500;
colors.teal600;
colors.teal700;
colors.teal800;
colors.teal900;
colors.tealA100;
colors.tealA200;
colors.tealA400;
colors.tealA700;
colors.green50;
colors.green100;
colors.green200;
colors.green300;
colors.green400;
colors.green500;
colors.green600;
colors.green700;
colors.green800;
colors.green900;
colors.greenA100;
colors.greenA200;
colors.greenA400;
colors.greenA700;
colors.lightGreen50;
colors.lightGreen100;
colors.lightGreen200;
colors.lightGreen300;
colors.lightGreen400;
colors.lightGreen500;
colors.lightGreen600;
colors.lightGreen700;
colors.lightGreen800;
colors.lightGreen900;
colors.lightGreenA100;
colors.lightGreenA200;
colors.lightGreenA400;
colors.lightGreenA700;
colors.lime50;
colors.lime100;
colors.lime200;
colors.lime300;
colors.lime400;
colors.lime500;
colors.lime600;
colors.lime700;
colors.lime800;
colors.lime900;
colors.limeA100;
colors.limeA200;
colors.limeA400;
colors.limeA700;
colors.yellow50;
colors.yellow100;
colors.yellow200;
colors.yellow300;
colors.yellow400;
colors.yellow500;
colors.yellow600;
colors.yellow700;
colors.yellow800;
colors.yellow900;
colors.yellowA100;
colors.yellowA200;
colors.yellowA400;
colors.yellowA700;
colors.amber50;
colors.amber100;
colors.amber200;
colors.amber300;
colors.amber400;
colors.amber500;
colors.amber600;
colors.amber700;
colors.amber800;
colors.amber900;
colors.amberA100;
colors.amberA200;
colors.amberA400;
colors.amberA700;
colors.orange50;
colors.orange100;
colors.orange200;
colors.orange300;
colors.orange400;
colors.orange500;
colors.orange600;
colors.orange700;
colors.orange800;
colors.orange900;
colors.orangeA100;
colors.orangeA200;
colors.orangeA400;
colors.orangeA700;
colors.deepOrange50;
colors.deepOrange100;
colors.deepOrange200;
colors.deepOrange300;
colors.deepOrange400;
colors.deepOrange500;
colors.deepOrange600;
colors.deepOrange700;
colors.deepOrange800;
colors.deepOrange900;
colors.deepOrangeA100;
colors.deepOrangeA200;
colors.deepOrangeA400;
colors.deepOrangeA700;
colors.brown50;
colors.brown100;
colors.brown200;
colors.brown300;
colors.brown400;
colors.brown500;
colors.brown600;
colors.brown700;
colors.brown800;
colors.brown900;
colors.blueGrey50;
colors.blueGrey100;
colors.blueGrey200;
colors.blueGrey300;
colors.blueGrey400;
colors.blueGrey500;
colors.blueGrey600;
colors.blueGrey700;
colors.blueGrey800;
colors.blueGrey900;
colors.grey50;
colors.grey100;
colors.grey200;
colors.grey300;
colors.grey400;
colors.grey500;
colors.grey600;
colors.grey700;
colors.grey800;
colors.grey900;
colors.black;
colors.white;
colors.transparent;
colors.fullBlack;
colors.darkBlack;
colors.lightBlack;
colors.minBlack;
colors.faintBlack;
colors.fullWhite;
colors.darkWhite;
colors.lightWhite;

var spacing = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  iconSize: 24,

  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopDrawerMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 56
};
});

unwrapExports(spacing);

var lightBaseTheme = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});







var _spacing2 = _interopRequireDefault(spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Light Theme is the default theme used in material-ui. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
exports.default = {
  spacing: _spacing2.default,
  fontFamily: 'Roboto, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: colors.cyan500,
    primary2Color: colors.cyan700,
    primary3Color: colors.grey400,
    accent1Color: colors.pinkA200,
    accent2Color: colors.grey100,
    accent3Color: colors.grey500,
    textColor: colors.darkBlack,
    secondaryTextColor: (0, colorManipulator.fade)(colors.darkBlack, 0.54),
    alternateTextColor: colors.white,
    canvasColor: colors.white,
    borderColor: colors.grey300,
    disabledColor: (0, colorManipulator.fade)(colors.darkBlack, 0.3),
    pickerHeaderColor: colors.cyan500,
    clockCircleColor: (0, colorManipulator.fade)(colors.darkBlack, 0.07),
    shadowColor: colors.fullBlack
  }
}; /**
    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
    */
});

unwrapExports(lightBaseTheme);

var zIndex = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  drawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};
});

unwrapExports(zIndex);

var autoprefixerDynamic = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _calc2 = _interopRequireDefault(calc);



var _flex2 = _interopRequireDefault(flex);



var _flexboxIE2 = _interopRequireDefault(flexboxIE);



var _flexboxOld2 = _interopRequireDefault(flexboxOld);



var _gradient2 = _interopRequireDefault(gradient);



var _sizing2 = _interopRequireDefault(sizing);



var _transition2 = _interopRequireDefault(transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
}; /* eslint-disable */
});

unwrapExports(autoprefixerDynamic);

var autoprefixerStatic = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _calc2 = _interopRequireDefault(calc$1);



var _flex2 = _interopRequireDefault(flex$1);



var _flexboxIE2 = _interopRequireDefault(flexboxIE$1);



var _flexboxOld2 = _interopRequireDefault(flexboxOld$1);



var _gradient2 = _interopRequireDefault(gradient$1);



var _sizing2 = _interopRequireDefault(sizing$1);



var _transition2 = _interopRequireDefault(transition$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
}; /* eslint-disable */
});

unwrapExports(autoprefixerStatic);

var autoprefixer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (muiTheme) {
  var isClient = typeof navigator !== 'undefined';
  var userAgent = muiTheme.userAgent;

  if (userAgent === undefined && isClient) {
    userAgent = navigator.userAgent;
  }

  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
    process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;

    hasWarnedAboutUserAgent = true;
  }

  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);

  if (userAgent === false) {
    // Disabled autoprefixer
    return null;
  } else if (userAgent === 'all' || userAgent === undefined) {
    // Prefix for all user agent
    return function (style) {
      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
      var stylePrefixed = prefixAll(style);

      if (isFlex) {
        var display = stylePrefixed.display;
        if (isClient) {
          // We can't apply this join with react-dom:
          // #https://github.com/facebook/react/issues/6467
          stylePrefixed.display = display[display.length - 1];
        } else {
          stylePrefixed.display = display.join('; display: ');
        }
      }

      return stylePrefixed;
    };
  } else {
    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
    var prefixer = new Prefixer({
      userAgent: userAgent
    });

    return function (style) {
      return prefixer.prefix(style);
    };
  }
};



var _createPrefixer2 = _interopRequireDefault(createPrefixer);



var _createPrefixer4 = _interopRequireDefault(createPrefixer$1);



var _autoprefixerDynamic2 = _interopRequireDefault(autoprefixerDynamic);



var _autoprefixerStatic2 = _interopRequireDefault(autoprefixerStatic);



var _warning2 = _interopRequireDefault(warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasWarnedAboutUserAgent = false;
});

unwrapExports(autoprefixer);

var callOnce_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = callOnce;



var _warning2 = _interopRequireDefault(warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CALLED_ONCE = 'muiPrepared';

function callOnce() {
  if (process.env.NODE_ENV !== 'production') {
    return function (style) {
      if (style[CALLED_ONCE]) {
        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
      }
      style[CALLED_ONCE] = true;
      return style;
    };
  }
}
});

unwrapExports(callOnce_1);

var rtl_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _keys2 = _interopRequireDefault(keys);

exports.default = rtl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;

/**
 * This function ensures that `style` supports both ltr and rtl directions by
 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
 * necessary.
 */
function rtl(muiTheme) {
  if (muiTheme.isRtl) {
    return function (style) {
      if (style.directionInvariant === true) {
        return style;
      }

      var flippedAttributes = {
        // Keys and their replacements.
        right: 'left',
        left: 'right',
        marginRight: 'marginLeft',
        marginLeft: 'marginRight',
        paddingRight: 'paddingLeft',
        paddingLeft: 'paddingRight',
        borderRight: 'borderLeft',
        borderLeft: 'borderRight'
      };

      var newStyle = {};

      (0, _keys2.default)(style).forEach(function (attribute) {
        var value = style[attribute];
        var key = attribute;

        if (flippedAttributes.hasOwnProperty(attribute)) {
          key = flippedAttributes[attribute];
        }

        switch (attribute) {
          case 'float':
          case 'textAlign':
            if (value === 'right') {
              value = 'left';
            } else if (value === 'left') {
              value = 'right';
            }
            break;

          case 'direction':
            if (value === 'ltr') {
              value = 'rtl';
            } else if (value === 'rtl') {
              value = 'ltr';
            }
            break;

          case 'transform':
            if (!value) break;
            var matches = void 0;
            if (matches = value.match(reTranslate)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
            }
            if (matches = value.match(reSkew)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
            }
            break;

          case 'transformOrigin':
            if (!value) break;
            if (value.indexOf('right') > -1) {
              value = value.replace('right', 'left');
            } else if (value.indexOf('left') > -1) {
              value = value.replace('left', 'right');
            }
            break;
        }

        newStyle[key] = value;
      });

      return newStyle;
    };
  }
}
});

unwrapExports(rtl_1);

var typography = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _classCallCheck3 = _interopRequireDefault(classCallCheck$2);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Typography = function Typography() {
  (0, _classCallCheck3.default)(this, Typography);

  // text colors
  this.textFullBlack = colors.fullBlack;
  this.textDarkBlack = colors.darkBlack;
  this.textLightBlack = colors.lightBlack;
  this.textMinBlack = colors.minBlack;
  this.textFullWhite = colors.fullWhite;
  this.textDarkWhite = colors.darkWhite;
  this.textLightWhite = colors.lightWhite;

  // font weight
  this.fontWeightLight = 300;
  this.fontWeightNormal = 400;
  this.fontWeightMedium = 500;

  this.fontStyleButtonFontSize = 14;
};

exports.default = new Typography();
});

unwrapExports(typography);

var getMuiTheme_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _toConsumableArray3 = _interopRequireDefault(toConsumableArray);

exports.default = getMuiTheme;



var _lodash2 = _interopRequireDefault(lodash);





var _lightBaseTheme2 = _interopRequireDefault(lightBaseTheme);



var _zIndex2 = _interopRequireDefault(zIndex);



var _autoprefixer2 = _interopRequireDefault(autoprefixer);



var _callOnce2 = _interopRequireDefault(callOnce_1);



var _rtl2 = _interopRequireDefault(rtl_1);



var _compose2 = _interopRequireDefault(compose);



var _typography2 = _interopRequireDefault(typography);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the MUI theme corresponding to a base theme.
 * It's possible to override the computed theme values
 * by providing a second argument. The calculated
 * theme will be deeply merged with the second argument.
 */
function getMuiTheme(muiTheme) {
  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }

  muiTheme = _lodash2.default.apply(undefined, [{
    zIndex: _zIndex2.default,
    isRtl: false,
    userAgent: undefined
  }, _lightBaseTheme2.default, muiTheme].concat(more));

  var _muiTheme = muiTheme,
      spacing = _muiTheme.spacing,
      fontFamily = _muiTheme.fontFamily,
      palette = _muiTheme.palette;

  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };

  muiTheme = (0, _lodash2.default)({
    appBar: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      height: spacing.desktopKeylineIncrement,
      titleFontWeight: _typography2.default.fontWeightNormal,
      padding: spacing.desktopGutter
    },
    avatar: {
      color: palette.canvasColor,
      backgroundColor: (0, colorManipulator.emphasize)(palette.canvasColor, 0.26)
    },
    badge: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      fontWeight: _typography2.default.fontWeightMedium
    },
    bottomNavigation: {
      backgroundColor: palette.canvasColor,
      unselectedColor: (0, colorManipulator.fade)(palette.textColor, 0.54),
      selectedColor: palette.primary1Color,
      height: 56,
      unselectedFontSize: 12,
      selectedFontSize: 14
    },
    button: {
      height: 36,
      minWidth: 88,
      iconButtonSize: spacing.iconSize * 2
    },
    card: {
      titleColor: (0, colorManipulator.fade)(palette.textColor, 0.87),
      subtitleColor: (0, colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    cardMedia: {
      color: colors.darkWhite,
      overlayContentBackground: colors.lightBlack,
      titleColor: colors.darkWhite,
      subtitleColor: colors.lightWhite
    },
    cardText: {
      textColor: palette.textColor
    },
    checkbox: {
      boxColor: palette.textColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    chip: {
      backgroundColor: (0, colorManipulator.emphasize)(palette.canvasColor, 0.12),
      deleteIconColor: (0, colorManipulator.fade)(palette.textColor, 0.26),
      textColor: (0, colorManipulator.fade)(palette.textColor, 0.87),
      fontSize: 14,
      fontWeight: _typography2.default.fontWeightNormal,
      shadow: '0 1px 6px ' + (0, colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, colorManipulator.fade)(palette.shadowColor, 0.12)
    },
    datePicker: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      calendarTextColor: palette.textColor,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor,
      calendarYearBackgroundColor: palette.canvasColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color
    },
    dialog: {
      titleFontSize: 22,
      bodyFontSize: 16,
      bodyColor: (0, colorManipulator.fade)(palette.textColor, 0.6)
    },
    dropDownMenu: {
      accentColor: palette.borderColor
    },
    enhancedButton: {
      tapHighlightColor: colors.transparent
    },
    flatButton: {
      color: colors.transparent,
      buttonFilterColor: '#999999',
      disabledTextColor: (0, colorManipulator.fade)(palette.textColor, 0.3),
      textColor: palette.textColor,
      primaryTextColor: palette.primary1Color,
      secondaryTextColor: palette.accent1Color,
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    floatingActionButton: {
      buttonSize: 56,
      miniSize: 40,
      color: palette.primary1Color,
      iconColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryIconColor: palette.alternateTextColor,
      disabledTextColor: palette.disabledColor,
      disabledColor: (0, colorManipulator.emphasize)(palette.canvasColor, 0.12)
    },
    gridTile: {
      textColor: colors.white
    },
    icon: {
      color: palette.canvasColor,
      backgroundColor: palette.primary1Color
    },
    inkBar: {
      backgroundColor: palette.accent1Color
    },
    drawer: {
      width: spacing.desktopKeylineIncrement * 4,
      color: palette.canvasColor
    },
    listItem: {
      nestedLevelDepth: 18,
      secondaryTextColor: palette.secondaryTextColor,
      leftIconColor: colors.grey600,
      rightIconColor: colors.grey600
    },
    menu: {
      backgroundColor: palette.canvasColor,
      containerBackgroundColor: palette.canvasColor
    },
    menuItem: {
      dataHeight: 32,
      height: 48,
      hoverColor: (0, colorManipulator.fade)(palette.textColor, 0.1),
      padding: spacing.desktopGutter,
      selectedTextColor: palette.accent1Color,
      rightIconDesktopFill: colors.grey600
    },
    menuSubheader: {
      padding: spacing.desktopGutter,
      borderColor: palette.borderColor,
      textColor: palette.primary1Color
    },
    overlay: {
      backgroundColor: colors.lightBlack
    },
    paper: {
      color: palette.textColor,
      backgroundColor: palette.canvasColor,
      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, colorManipulator.fade)(palette.shadowColor, d[5]);
      })
    },
    radioButton: {
      borderColor: palette.textColor,
      backgroundColor: palette.alternateTextColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      size: 24,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    raisedButton: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      disabledColor: (0, colorManipulator.darken)(palette.alternateTextColor, 0.1),
      disabledTextColor: (0, colorManipulator.fade)(palette.textColor, 0.3),
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    refreshIndicator: {
      strokeColor: palette.borderColor,
      loadingStrokeColor: palette.primary1Color
    },
    ripple: {
      color: (0, colorManipulator.fade)(palette.textColor, 0.87)
    },
    slider: {
      trackSize: 2,
      trackColor: palette.primary3Color,
      trackColorSelected: palette.accent3Color,
      handleSize: 12,
      handleSizeDisabled: 8,
      handleSizeActive: 18,
      handleColorZero: palette.primary3Color,
      handleFillColor: palette.alternateTextColor,
      selectionColor: palette.primary1Color,
      rippleColor: palette.primary1Color
    },
    snackbar: {
      textColor: palette.alternateTextColor,
      backgroundColor: palette.textColor,
      actionColor: palette.accent1Color
    },
    subheader: {
      color: (0, colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    stepper: {
      backgroundColor: 'transparent',
      hoverBackgroundColor: (0, colorManipulator.fade)(colors.black, 0.06),
      iconColor: palette.primary1Color,
      hoveredIconColor: colors.grey700,
      inactiveIconColor: colors.grey500,
      textColor: (0, colorManipulator.fade)(colors.black, 0.87),
      disabledTextColor: (0, colorManipulator.fade)(colors.black, 0.26),
      connectorLineColor: colors.grey400
    },
    svgIcon: {
      color: palette.textColor
    },
    table: {
      backgroundColor: palette.canvasColor
    },
    tableFooter: {
      borderColor: palette.borderColor,
      textColor: palette.accent3Color
    },
    tableHeader: {
      borderColor: palette.borderColor
    },
    tableHeaderColumn: {
      textColor: palette.accent3Color,
      height: 56,
      spacing: 24
    },
    tableRow: {
      hoverColor: palette.accent2Color,
      stripeColor: (0, colorManipulator.fade)((0, colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
      selectedColor: palette.borderColor,
      textColor: palette.textColor,
      borderColor: palette.borderColor,
      height: 48
    },
    tableRowColumn: {
      height: 48,
      spacing: 24
    },
    tabs: {
      backgroundColor: palette.primary1Color,
      textColor: (0, colorManipulator.fade)(palette.alternateTextColor, 0.7),
      selectedTextColor: palette.alternateTextColor
    },
    textField: {
      textColor: palette.textColor,
      hintColor: palette.disabledColor,
      floatingLabelColor: palette.disabledColor,
      disabledTextColor: palette.disabledColor,
      errorColor: colors.red500,
      focusColor: palette.primary1Color,
      backgroundColor: 'transparent',
      borderColor: palette.borderColor
    },
    timePicker: {
      color: palette.alternateTextColor,
      textColor: palette.alternateTextColor,
      accentColor: palette.primary1Color,
      clockColor: palette.textColor,
      clockCircleColor: palette.clockCircleColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor
    },
    toggle: {
      thumbOnColor: palette.primary1Color,
      thumbOffColor: palette.accent2Color,
      thumbDisabledColor: palette.borderColor,
      thumbRequiredColor: palette.primary1Color,
      trackOnColor: (0, colorManipulator.fade)(palette.primary1Color, 0.5),
      trackOffColor: palette.primary3Color,
      trackDisabledColor: palette.primary3Color,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor,
      trackRequiredColor: (0, colorManipulator.fade)(palette.primary1Color, 0.5)
    },
    toolbar: {
      color: (0, colorManipulator.fade)(palette.textColor, 0.54),
      hoverColor: (0, colorManipulator.fade)(palette.textColor, 0.87),
      backgroundColor: (0, colorManipulator.darken)(palette.accent2Color, 0.05),
      height: 56,
      titleFontSize: 20,
      iconColor: (0, colorManipulator.fade)(palette.textColor, 0.4),
      separatorColor: (0, colorManipulator.fade)(palette.textColor, 0.175),
      menuHoverColor: (0, colorManipulator.fade)(palette.textColor, 0.1)
    },
    tooltip: {
      color: colors.white,
      rippleBackgroundColor: colors.grey700,
      opacity: 0.9
    }
  }, muiTheme, {
    baseTheme: baseTheme, // To provide backward compatibility.
    rawTheme: baseTheme // To provide backward compatibility.
  });

  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
    return t(muiTheme);
  }).filter(function (t) {
    return t;
  });

  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));

  return muiTheme;
}
});

unwrapExports(getMuiTheme_1$1);

var getPrototypeOf = createCommonjsModule(function (module) {
module.exports = { "default": getPrototypeOf$2, __esModule: true };
});

unwrapExports(getPrototypeOf);

var classCallCheck = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
});

unwrapExports(classCallCheck);

var createClass = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperty2 = _interopRequireDefault(defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
});

unwrapExports(createClass);

var possibleConstructorReturn = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _typeof3 = _interopRequireDefault(_typeof_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
});

unwrapExports(possibleConstructorReturn);

var inherits$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _setPrototypeOf2 = _interopRequireDefault(setPrototypeOf);



var _create2 = _interopRequireDefault(create);



var _typeof3 = _interopRequireDefault(_typeof_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
});

unwrapExports(inherits$1);

var getMuiTheme_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _toConsumableArray3 = _interopRequireDefault(toConsumableArray);

exports.default = getMuiTheme;



var _lodash2 = _interopRequireDefault(lodash);





var _lightBaseTheme2 = _interopRequireDefault(lightBaseTheme);



var _zIndex2 = _interopRequireDefault(zIndex);



var _autoprefixer2 = _interopRequireDefault(autoprefixer);



var _callOnce2 = _interopRequireDefault(callOnce_1);



var _rtl2 = _interopRequireDefault(rtl_1);



var _compose2 = _interopRequireDefault(compose);



var _typography2 = _interopRequireDefault(typography);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the MUI theme corresponding to a base theme.
 * It's possible to override the computed theme values
 * by providing a second argument. The calculated
 * theme will be deeply merged with the second argument.
 */
function getMuiTheme(muiTheme) {
  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }

  muiTheme = _lodash2.default.apply(undefined, [{
    zIndex: _zIndex2.default,
    isRtl: false,
    userAgent: undefined
  }, _lightBaseTheme2.default, muiTheme].concat(more));

  var _muiTheme = muiTheme,
      spacing = _muiTheme.spacing,
      fontFamily = _muiTheme.fontFamily,
      palette = _muiTheme.palette;

  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };

  muiTheme = (0, _lodash2.default)({
    appBar: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      height: spacing.desktopKeylineIncrement,
      titleFontWeight: _typography2.default.fontWeightNormal,
      padding: spacing.desktopGutter
    },
    avatar: {
      color: palette.canvasColor,
      backgroundColor: (0, colorManipulator.emphasize)(palette.canvasColor, 0.26)
    },
    badge: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      fontWeight: _typography2.default.fontWeightMedium
    },
    bottomNavigation: {
      backgroundColor: palette.canvasColor,
      unselectedColor: (0, colorManipulator.fade)(palette.textColor, 0.54),
      selectedColor: palette.primary1Color,
      height: 56,
      unselectedFontSize: 12,
      selectedFontSize: 14
    },
    button: {
      height: 36,
      minWidth: 88,
      iconButtonSize: spacing.iconSize * 2
    },
    card: {
      titleColor: (0, colorManipulator.fade)(palette.textColor, 0.87),
      subtitleColor: (0, colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    cardMedia: {
      color: colors.darkWhite,
      overlayContentBackground: colors.lightBlack,
      titleColor: colors.darkWhite,
      subtitleColor: colors.lightWhite
    },
    cardText: {
      textColor: palette.textColor
    },
    checkbox: {
      boxColor: palette.textColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    chip: {
      backgroundColor: (0, colorManipulator.emphasize)(palette.canvasColor, 0.12),
      deleteIconColor: (0, colorManipulator.fade)(palette.textColor, 0.26),
      textColor: (0, colorManipulator.fade)(palette.textColor, 0.87),
      fontSize: 14,
      fontWeight: _typography2.default.fontWeightNormal,
      shadow: '0 1px 6px ' + (0, colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, colorManipulator.fade)(palette.shadowColor, 0.12)
    },
    datePicker: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      calendarTextColor: palette.textColor,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor,
      calendarYearBackgroundColor: palette.canvasColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color
    },
    dialog: {
      titleFontSize: 22,
      bodyFontSize: 16,
      bodyColor: (0, colorManipulator.fade)(palette.textColor, 0.6)
    },
    dropDownMenu: {
      accentColor: palette.borderColor
    },
    enhancedButton: {
      tapHighlightColor: colors.transparent
    },
    flatButton: {
      color: colors.transparent,
      buttonFilterColor: '#999999',
      disabledTextColor: (0, colorManipulator.fade)(palette.textColor, 0.3),
      textColor: palette.textColor,
      primaryTextColor: palette.primary1Color,
      secondaryTextColor: palette.accent1Color,
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    floatingActionButton: {
      buttonSize: 56,
      miniSize: 40,
      color: palette.primary1Color,
      iconColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryIconColor: palette.alternateTextColor,
      disabledTextColor: palette.disabledColor,
      disabledColor: (0, colorManipulator.emphasize)(palette.canvasColor, 0.12)
    },
    gridTile: {
      textColor: colors.white
    },
    icon: {
      color: palette.canvasColor,
      backgroundColor: palette.primary1Color
    },
    inkBar: {
      backgroundColor: palette.accent1Color
    },
    drawer: {
      width: spacing.desktopKeylineIncrement * 4,
      color: palette.canvasColor
    },
    listItem: {
      nestedLevelDepth: 18,
      secondaryTextColor: palette.secondaryTextColor,
      leftIconColor: colors.grey600,
      rightIconColor: colors.grey600
    },
    menu: {
      backgroundColor: palette.canvasColor,
      containerBackgroundColor: palette.canvasColor
    },
    menuItem: {
      dataHeight: 32,
      height: 48,
      hoverColor: (0, colorManipulator.fade)(palette.textColor, 0.1),
      padding: spacing.desktopGutter,
      selectedTextColor: palette.accent1Color,
      rightIconDesktopFill: colors.grey600
    },
    menuSubheader: {
      padding: spacing.desktopGutter,
      borderColor: palette.borderColor,
      textColor: palette.primary1Color
    },
    overlay: {
      backgroundColor: colors.lightBlack
    },
    paper: {
      color: palette.textColor,
      backgroundColor: palette.canvasColor,
      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, colorManipulator.fade)(palette.shadowColor, d[5]);
      })
    },
    radioButton: {
      borderColor: palette.textColor,
      backgroundColor: palette.alternateTextColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      size: 24,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    raisedButton: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      disabledColor: (0, colorManipulator.darken)(palette.alternateTextColor, 0.1),
      disabledTextColor: (0, colorManipulator.fade)(palette.textColor, 0.3),
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    refreshIndicator: {
      strokeColor: palette.borderColor,
      loadingStrokeColor: palette.primary1Color
    },
    ripple: {
      color: (0, colorManipulator.fade)(palette.textColor, 0.87)
    },
    slider: {
      trackSize: 2,
      trackColor: palette.primary3Color,
      trackColorSelected: palette.accent3Color,
      handleSize: 12,
      handleSizeDisabled: 8,
      handleSizeActive: 18,
      handleColorZero: palette.primary3Color,
      handleFillColor: palette.alternateTextColor,
      selectionColor: palette.primary1Color,
      rippleColor: palette.primary1Color
    },
    snackbar: {
      textColor: palette.alternateTextColor,
      backgroundColor: palette.textColor,
      actionColor: palette.accent1Color
    },
    subheader: {
      color: (0, colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    stepper: {
      backgroundColor: 'transparent',
      hoverBackgroundColor: (0, colorManipulator.fade)(colors.black, 0.06),
      iconColor: palette.primary1Color,
      hoveredIconColor: colors.grey700,
      inactiveIconColor: colors.grey500,
      textColor: (0, colorManipulator.fade)(colors.black, 0.87),
      disabledTextColor: (0, colorManipulator.fade)(colors.black, 0.26),
      connectorLineColor: colors.grey400
    },
    svgIcon: {
      color: palette.textColor
    },
    table: {
      backgroundColor: palette.canvasColor
    },
    tableFooter: {
      borderColor: palette.borderColor,
      textColor: palette.accent3Color
    },
    tableHeader: {
      borderColor: palette.borderColor
    },
    tableHeaderColumn: {
      textColor: palette.accent3Color,
      height: 56,
      spacing: 24
    },
    tableRow: {
      hoverColor: palette.accent2Color,
      stripeColor: (0, colorManipulator.fade)((0, colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
      selectedColor: palette.borderColor,
      textColor: palette.textColor,
      borderColor: palette.borderColor,
      height: 48
    },
    tableRowColumn: {
      height: 48,
      spacing: 24
    },
    tabs: {
      backgroundColor: palette.primary1Color,
      textColor: (0, colorManipulator.fade)(palette.alternateTextColor, 0.7),
      selectedTextColor: palette.alternateTextColor
    },
    textField: {
      textColor: palette.textColor,
      hintColor: palette.disabledColor,
      floatingLabelColor: palette.disabledColor,
      disabledTextColor: palette.disabledColor,
      errorColor: colors.red500,
      focusColor: palette.primary1Color,
      backgroundColor: 'transparent',
      borderColor: palette.borderColor
    },
    timePicker: {
      color: palette.alternateTextColor,
      textColor: palette.alternateTextColor,
      accentColor: palette.primary1Color,
      clockColor: palette.textColor,
      clockCircleColor: palette.clockCircleColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor
    },
    toggle: {
      thumbOnColor: palette.primary1Color,
      thumbOffColor: palette.accent2Color,
      thumbDisabledColor: palette.borderColor,
      thumbRequiredColor: palette.primary1Color,
      trackOnColor: (0, colorManipulator.fade)(palette.primary1Color, 0.5),
      trackOffColor: palette.primary3Color,
      trackDisabledColor: palette.primary3Color,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor,
      trackRequiredColor: (0, colorManipulator.fade)(palette.primary1Color, 0.5)
    },
    toolbar: {
      color: (0, colorManipulator.fade)(palette.textColor, 0.54),
      hoverColor: (0, colorManipulator.fade)(palette.textColor, 0.87),
      backgroundColor: (0, colorManipulator.darken)(palette.accent2Color, 0.05),
      height: 56,
      titleFontSize: 20,
      iconColor: (0, colorManipulator.fade)(palette.textColor, 0.4),
      separatorColor: (0, colorManipulator.fade)(palette.textColor, 0.175),
      menuHoverColor: (0, colorManipulator.fade)(palette.textColor, 0.1)
    },
    tooltip: {
      color: colors.white,
      rippleBackgroundColor: colors.grey700,
      opacity: 0.9
    }
  }, muiTheme, {
    baseTheme: baseTheme, // To provide backward compatibility.
    rawTheme: baseTheme // To provide backward compatibility.
  });

  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
    return t(muiTheme);
  }).filter(function (t) {
    return t;
  });

  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));

  return muiTheme;
}
});

unwrapExports(getMuiTheme_1);

var MuiThemeProvider_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _getPrototypeOf2 = _interopRequireDefault(getPrototypeOf);



var _classCallCheck3 = _interopRequireDefault(classCallCheck);



var _createClass3 = _interopRequireDefault(createClass);



var _possibleConstructorReturn3 = _interopRequireDefault(possibleConstructorReturn);



var _inherits3 = _interopRequireDefault(inherits$1);





var _propTypes2 = _interopRequireDefault(propTypes);



var _getMuiTheme2 = _interopRequireDefault(getMuiTheme_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MuiThemeProvider = function (_Component) {
  (0, _inherits3.default)(MuiThemeProvider, _Component);

  function MuiThemeProvider() {
    (0, _classCallCheck3.default)(this, MuiThemeProvider);
    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(React.Component);

MuiThemeProvider.childContextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MuiThemeProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.element,
  muiTheme: _propTypes2.default.object
} : {};
exports.default = MuiThemeProvider;
});

var MuiThemeProvider = unwrapExports(MuiThemeProvider_1);

const GAInit = (GTMID, testMode = false, gtagUrl = 'https://www.googletagmanager.com/gtag/js') => {
    const options = {
        testMode,
        gtagUrl
    };
    ReactGA.initialize([
        {
            trackingId: GTMID,
        }
    ], options);
};
const GAEvent = (action = 'event', category = 'category', label, transport, params = {}) => {
    ReactGA.event({
        action,
        category,
        label,
        transport
    }, params);
};
const GAPageView = (pagePath = '/', pageTitle = '') => {
    ReactGA.send({ hitType: "pageview", page: pagePath, title: pageTitle });
};

const useStyles$k = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    stepPadding: {
        marginLeft: "0.5rem",
        marginRight: "0.5rem",
        marginTop: "2rem",
    },
    stepPaddingBelow: {
        marginRight: "0.5rem",
        marginTop: "0.5rem",
    },
    stepPaddingButton: {
        marginTop: "0.5rem",
    },
    stepPaddingTitle: {
        marginTop: "1rem",
        marginBottom: "1rem",
    },
    card: {
        width: "100%",
    },
    flex: {
        display: "flex",
    },
    button: {
        width: "100%",
        //@ts-ignore
        backgroundColor: ({ websiteColors }) => `${(websiteColors === null || websiteColors === void 0 ? void 0 : websiteColors.accentColor) || 'grey'}`,
        //@ts-ignore
        color: ({ websiteColors }) => `${(websiteColors === null || websiteColors === void 0 ? void 0 : websiteColors.primaryColor) || 'black'}`,
    },
    backButton: {
        marginTop: "2rem",
    },
    image: {
        minWidth: "100%",
        height: 550,
    },
    uppercase: {
        textTransform: "uppercase",
        color: "red",
    },
    success: {
        color: "black",
        fontSize: "22px",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    },
    icon: {
        fontSize: "3rem",
    },
    link: {
        backgroundColor: "transparent",
        marginBottom: "1rem",
        /* @ts-ignore */
        color: ({ primaryColor }) => `${primaryColor}!important`,
        "&:hover": {
            textDecoration: "none",
            opacity: 0.8,
        },
    },
}));
const Finance = ({ activeMake, activeMakeId, dealerMakesOnly, base_uri, dealerId, dealerType = "single_dealer", applicationSubmission = true, applicationUrl, dealers, activeDealerId, masterDealerId, pqType, purchasePrice, mmCode, variantId, ownedModelId, colorId, stockId, offerId, leadTypeId, financeQuestions, includeValidationChecks = false, setPQResult, pqSuccessUrl, pqFailUrl, onSubmitForm, dealerModels, ownedVarientId, floorCode, sourceCode, websiteColors, paper, paperColor, paperShadowColor, overrideLeadType = false, }) => {
    const classes = useStyles$k(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    const defaultFinanceQuestions = [
        {
            name: "licenseCheck",
            labelComponent: (React.createElement("span", null, "I have a valid South African Driver's License")),
            correct: true,
            order: 1,
        },
        {
            name: "creditCheck",
            labelComponent: React.createElement("span", null, "I consent to a credit bureau check"),
            correct: true,
            order: 2,
        },
        {
            name: "underDebtReview",
            labelComponent: React.createElement("span", null, "I confirm that I am not under debt review"),
            correct: true,
            order: 3,
        },
        {
            name: "needInsurance",
            labelComponent: React.createElement("span", null, "I will need insurance"),
            correct: true,
            order: 4,
        },
        {
            name: "popi",
            labelComponent: (React.createElement("span", null,
                "By submitting this form I agree to the",
                " ",
                React.createElement(Link, { component: NavLink, to: "/terms", className: classes.link }, "terms and conditions"),
                " ",
                "and",
                " ",
                React.createElement(Link, { component: NavLink, to: "/privacy", className: classes.link }, "privacy policies."))),
            correct: true,
            order: 5,
        },
    ];
    const defaultValidationChecks = [
        {
            name: "checkA",
            labelComponent: React.createElement("span", null, "I am not a minor"),
            correct: true,
            order: 1,
        },
        {
            name: "checkB",
            labelComponent: (React.createElement("span", null, "I have never been declared mentally unfit by a court")),
            correct: true,
            order: 2,
        },
        {
            name: "checkC",
            labelComponent: React.createElement("span", null, "I am not subject to an administration order"),
            correct: true,
            order: 3,
        },
        {
            name: "checkD",
            labelComponent: (React.createElement("span", null, "I do not have any current debt re-arrangement in existence")),
            correct: true,
            order: 4,
        },
        {
            name: "checkE",
            labelComponent: (React.createElement("span", null, "I have not previously applied for a debt re-arrangement")),
            correct: true,
            order: 5,
        },
        {
            name: "checkF",
            labelComponent: (React.createElement("span", null, "I do not have applications pending for credit, nor do I have any open quotations under section 92 of the National Credit Act 34 of 2005 (\"National Credit Act\")")),
            correct: true,
            order: 6,
        },
        {
            name: "checkG",
            labelComponent: React.createElement("span", null, "I am not currently in debt counselling"),
            correct: true,
            order: 7,
        },
        {
            name: "checkH",
            labelComponent: (React.createElement("span", null, "I consent to the Vehicle Finance Terms & Conditions")),
            correct: true,
            order: 8,
        },
    ];
    if (!financeQuestions) {
        financeQuestions = defaultFinanceQuestions;
        if (includeValidationChecks) {
            financeQuestions.push(...defaultValidationChecks);
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [success, setSuccess] = useState(false);
    const [delearName, setDelearName] = useState(undefined);
    const [delearDetails, setDelearDetails] = useState(undefined);
    const [dealerList, setDealerList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [modelId, setModelId] = useState(0);
    const [variants, setVariants] = useState([]);
    const [vehicleTypeId, setVehicleTypeId] = useState(leadTypeId || null);
    const [makes, setMakes] = useState([]);
    const [models, setModels] = useState([]);
    const [loadingOptions, setLoadingOptions] = useState(false);
    const CssTextField = withStyles({
        root: {
            '& label.Mui-focused': {
                color: 'grey',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'black',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'grey',
                },
                '&:hover fieldset': {
                    borderColor: 'black',
                },
                '&.Mui-focused fieldset': {
                    borderColor: 'black',
                },
            },
        },
    })(TextField);
    const getErrorMessage = (axiosError, defaultMsg) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let errorTitle = defaultMsg;
        let errorDetails = "No additional details are available";
        if (((_a = axiosError === null || axiosError === void 0 ? void 0 : axiosError.request) === null || _a === void 0 ? void 0 : _a.message) || ((_b = axiosError === null || axiosError === void 0 ? void 0 : axiosError.request) === null || _b === void 0 ? void 0 : _b.statusText)) {
            errorTitle = "Failed to send the request";
            errorDetails = (_d = (_c = axiosError === null || axiosError === void 0 ? void 0 : axiosError.request) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : (_e = axiosError === null || axiosError === void 0 ? void 0 : axiosError.request) === null || _e === void 0 ? void 0 : _e.statusText;
        }
        else if ((_f = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _f === void 0 ? void 0 : _f.data) {
            errorTitle = (_j = (_h = (_g = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.title) !== null && _j !== void 0 ? _j : errorTitle;
            errorDetails = (_m = (_l = (_k = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.detail) !== null && _m !== void 0 ? _m : errorDetails;
        }
        return `${errorTitle}: ${errorDetails}`;
    };
    const leadTypeOptions = [
        { id: 1, name: "New Vehicle" },
        { id: 2, name: "Used Vehicle" },
    ];
    const hasVehicle = variantId || stockId || ownedVarientId || offerId ? true : false;
    useEffect(() => {
        if (modelId) {
            setLoader(true);
            axios
                .get(`${base_uri}/dealervariants?dealerModelId=${modelId}`)
                .then((result) => {
                let data = result.data.list;
                if (data.length > 0) {
                    setVariants(data);
                }
                else {
                    return axios // @ts-ignore
                        .get(`${base_uri}/Variants`, { params: { modelId: modelId, isService: true } })
                        .then((result) => {
                        var _a;
                        setVariants(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.list) || []);
                    })
                        .catch((error) => {
                        enqueueSnackbar(getErrorMessage(error, `Failed fetching variants: ${error}`), { variant: 'error' });
                    })
                        .then(() => {
                        setLoadingOptions(false);
                    });
                }
            })
                .catch((error) => {
                console.warn(`Failed fetching Variants for Model ID: ${modelId}`, error);
            })
                .then(() => {
                setLoader(false);
            });
        }
    }, [modelId]);
    let idRegex = `(((\\d{2}((0[13578]|1[02])(0[1-9]|[12]\\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\\d|30)|02(0[1-9]|1\\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\\d{4})( |-)(\\d{3})|(\\d{7}))`;
    let phoneRegExp = /^0(6|7|8){1}[0-9]{1}[0-9]{7}$/;
    var yupRules = {
        name: Yup.string().required("Name is required"),
        email: Yup.string()
            .email("Enter a valid email")
            .required("Email is required"),
        phone: Yup.string()
            .required("Phone number is required")
            .matches(phoneRegExp, "Phone number is not valid"),
    };
    if (!pqType || pqType != "no_pq") {
        yupRules = Object.assign(Object.assign({}, yupRules), { id: Yup.string()
                .required("ID number is required")
                .matches(idRegex, "ID Number invalid") });
    }
    let validationSchema = Yup.object(yupRules);
    useEffect(() => {
        var _a;
        let f = dealers === null || dealers === void 0 ? void 0 : dealers.filter((d) => d.dealerId !== masterDealerId);
        // @ts-ignore
        setDelearName((_a = f === null || f === void 0 ? void 0 : f.filter((d) => d.dealerId === activeDealerId)[0]) === null || _a === void 0 ? void 0 : _a.name);
        if (dealerId !== masterDealerId) {
            setDelearDetails(dealers === null || dealers === void 0 ? void 0 : dealers.filter((d) => d.dealerId == dealerId)[0]);
        }
        if (dealers) {
            setDealerList(dealers);
        }
    }, [dealers, activeDealerId, dealerId]);
    let values = {
        id: "",
        netSalary: "",
        totalExpenses: "",
        name: "",
        lastName: "",
        phone: "",
        email: "",
        dealerId: (delearDetails === null || delearDetails === void 0 ? void 0 : delearDetails.dealerId) || activeDealerId || dealerId,
        dealer: (delearDetails === null || delearDetails === void 0 ? void 0 : delearDetails.name) || delearName || dealerId,
        leadTypeId: leadTypeId || "",
        make: activeMake ? activeMake : "",
        makeId: activeMakeId ? activeMakeId : "",
    };
    useEffect(() => {
        Promise.allSettled([
            getMakes(),
        ])
            .catch((error) => {
            enqueueSnackbar(getErrorMessage(error, "Unexpected error occurred while loading form options"), { variant: 'error' });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getModels = (makeId) => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        if (makeId) {
            return yield axios // @ts-ignore
                .get(`${base_uri}/Models/unfiltered`, {
                params: {
                    makeId: makeId,
                }
            })
                .then((result) => {
                var _a;
                setModels(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.list) || []);
            })
                .catch((error) => {
                enqueueSnackbar(getErrorMessage(error, `Failed to load the models: ${error}`), { variant: 'error' });
            })
                .then(() => {
                setLoadingOptions(false);
            });
        }
    });
    const getDealers = (makeId) => __awaiter(void 0, void 0, void 0, function* () {
        if (makeId) {
            setLoadingOptions(true);
            // @ts-ignore
            const filteredDealers = dealers === null || dealers === void 0 ? void 0 : dealers.reduce((ac, v) => {
                // @ts-ignore
                const included = v.relatedBrands.reduce((acc, va) => {
                    if (va.id === makeId) {
                        return true;
                    }
                    return acc;
                }, false);
                if (included) {
                    return [...ac, v];
                }
                return ac;
            }, []);
            setDealerList(filteredDealers);
        }
    });
    const getMakes = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        return yield axios
            .get(`${base_uri}/Makes`)
            .then((result) => {
            var _a, _b, _c;
            if (activeMakeId !== 0) {
                //@ts-ignore
                setMakes(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.list.filter((r) => r.id == activeMakeId)) || []);
            }
            else if (dealerMakesOnly) {
                const brandIDs = dealers === null || dealers === void 0 ? void 0 : dealers.reduce((ac, v) => {
                    const aBrands = v.relatedBrands;
                    const flatBrands = aBrands.reduce((acc, val) => {
                        if (ac.includes(val.id)) {
                            return acc;
                        }
                        return [...acc, val.id];
                    }, []);
                    return [...ac, ...flatBrands];
                }, []);
                setMakes(((_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.list.filter((r) => brandIDs.includes(r.id))) || []);
            }
            else {
                setMakes(((_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.list) || []);
            }
        })
            .catch((error) => {
            enqueueSnackbar(getErrorMessage(error, `Failed to load the makes: ${error}`), { variant: 'error' });
        })
            // always
            .then(() => {
            setLoadingOptions(false);
        });
    });
    const handleMakeChange = (e, value, setFieldValue) => {
        handleSelectChange(e, value, setFieldValue, "make", "makeId");
        // Reset the Make & Variant selections
        setFieldValue("model", "");
        setFieldValue("modelId", 0);
        setFieldValue("variant", "");
        setFieldValue("variantId", 0);
        // Load the models for the selected make
        setTimeout(() => {
            var _a, _b;
            getModels((_a = value === null || value === void 0 ? void 0 : value.props) === null || _a === void 0 ? void 0 : _a.id);
            if (dealerType == "multi_dealer") {
                getDealers((_b = value === null || value === void 0 ? void 0 : value.props) === null || _b === void 0 ? void 0 : _b.id);
            }
        }, 50);
    };
    useEffect(() => {
        if (activeMakeId && (!dealerModels || (dealerModels === null || dealerModels === void 0 ? void 0 : dealerModels.length) === 0)) {
            getModels(activeMakeId);
        }
        if (dealerModels && (dealerModels === null || dealerModels === void 0 ? void 0 : dealerModels.length) > 0) {
            setModels(dealerModels);
        }
    }, [activeMakeId, dealerModels]);
    useEffect(() => {
        var _a, _b, _c;
        if (!activeMakeId && (makes === null || makes === void 0 ? void 0 : makes.length) === 1) {
            activeMakeId = (_a = makes[0]) === null || _a === void 0 ? void 0 : _a.id;
            values.make = (_b = makes[0]) === null || _b === void 0 ? void 0 : _b.name;
            values.makeId = (_c = makes[0]) === null || _c === void 0 ? void 0 : _c.id;
            // Load the models for the selected make
            setTimeout(() => {
                var _a, _b;
                getModels((_a = makes[0]) === null || _a === void 0 ? void 0 : _a.id);
                if (dealerType == "multi_dealer") {
                    getDealers((_b = makes[0]) === null || _b === void 0 ? void 0 : _b.id);
                }
            }, 50);
        }
    }, [makes]);
    const checkValid = (validForm, values) => {
        var _a;
        if (!validForm || !values)
            return false;
        let allChecked = true;
        if (financeQuestions) {
            for (var idx in financeQuestions) {
                var question = financeQuestions[idx];
                var questionVal = (_a = values[question.name]) !== null && _a !== void 0 ? _a : false;
                if (question.correct != questionVal) {
                    allChecked = false;
                    break;
                }
            }
        }
        return validForm && allChecked;
    };
    const handleSelectChange = (e, value, setFieldValue, fieldName, fieldId) => {
        if (fieldName === "leadTypeId") {
            setFieldValue("dealer", "");
        }
        if (fieldName === "variantId") {
            const variant = variants === null || variants === void 0 ? void 0 : variants.find((v) => {
                var _a;
                //@ts-ignore
                return (v === null || v === void 0 ? void 0 : v.id) === ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
            });
            //@ts-ignore
            var tmpValue = (variant === null || variant === void 0 ? void 0 : variant.variantId) ? variant === null || variant === void 0 ? void 0 : variant.variantId : variant === null || variant === void 0 ? void 0 : variant.id;
            setFieldValue(fieldName, tmpValue);
        }
        else {
            setFieldValue(fieldName, e.target.value);
            setFieldValue(fieldId, value.props.id);
        }
        if (fieldName === "modelId") {
            setModelId(e.target.value);
        }
        else if (fieldName === "leadTypeId") {
            setVehicleTypeId(e.target.value);
        }
    };
    const createLead = (values, setSubmitting) => {
        setSubmitting(true);
        const pageTitle = document.getElementsByTagName("title")[0].innerHTML;
        GAEvent('form_submissions', 'form_submissions', 'finance_submission', 'xhr', {
            url: window.location.pathname,
            page_title: pageTitle,
            form_type: 'finance'
        });
        let params = {};
        params.leadStatusId = 1;
        var sourceId = 1; // Website
        if (!hasVehicle && !(values === null || values === void 0 ? void 0 : values.leadTypeId)) {
            enqueueSnackbar(`Vehicle type is required, please select a vehicle type`, { variant: "error" });
            setSubmitting(false);
            return;
        }
        if (!hasVehicle && !(values === null || values === void 0 ? void 0 : values.variantId) && (values === null || values === void 0 ? void 0 : values.leadTypeId) === 1) {
            enqueueSnackbar(`Vehicle variant is required, please select a variant`, { variant: "error" });
            setSubmitting(false);
            return;
        }
        if (document.referrer) {
            if (document.referrer.indexOf("facebook") > -1) {
                sourceId = 2; // Facebook
            }
        }
        if (dealerType !== "single_dealer" && !(values === null || values === void 0 ? void 0 : values.dealerId)) {
            enqueueSnackbar(`A dealer is required, please select a dealer.`, { variant: "warning" });
            setSubmitting(false);
            return;
        }
        setLoader(true);
        params.dealerId = dealerType === "single_dealer" ? dealerId : values.dealerId;
        params.name = values.name + " " + values.lastName;
        params.firstName = values.name;
        params.lastName = values.lastName;
        params.idNumber = values.id;
        params.netSalary = parseInt(values.netSalary);
        params.phoneNumber = values.phone;
        params.emailAddress = values.email;
        params.leadSourceId = sourceId;
        params.leadTypeId = overrideLeadType ? values === null || values === void 0 ? void 0 : values.leadTypeId : 12; // Finance Application
        params.TypeCode = stockId ? "USED" : variantId ? "NEW" : "NoVehicle";
        params.dateUpdated = new Date().toISOString();
        //Lead Vehicle
        params.mmCode = mmCode ? mmCode : "";
        params.variantId = hasVehicle
            ? variantId ? variantId : 0
            : (values === null || values === void 0 ? void 0 : values.variantId) ? values.variantId : 0;
        if (!hasVehicle) {
            params.TypeCode = values.leadTypeId === 1 ? "NEW" : "USED";
        }
        params.ownedModelId = ownedModelId ? ownedModelId : 0;
        params.stockId = stockId ? stockId : 0;
        params.offerId = offerId ? offerId : 0;
        params.ownedVariantExteriorsId = colorId ? colorId : 0;
        if ((floorCode || "").length > 0 && (sourceCode || "").length > 0) {
            params.floorCode = floorCode;
            params.sourceCode = sourceCode;
        }
        // @ts-ignore
        axios.post(`${base_uri}/leads`, params)
            .then((response) => {
            values.leadId = response.data.id;
            if (pqType && pqType == "no_pq") {
                if (applicationSubmission && applicationUrl) {
                    window.location.href = applicationUrl.replace(":leadId", values.leadId);
                }
                enqueueSnackbar(`Successfully submitted your information`, { variant: "success" });
                setSuccess(true);
                setLoader(false);
                return;
            }
            submitForPQ(values);
        })
            .catch((error) => {
            // TODO: REMOVE THIS SHIT
            enqueueSnackbar(`Successfully sent information`, { variant: 'success' });
            // enqueueSnackbar("Unable to complete the request", { variant: 'error' });
            setLoader(false);
        });
    };
    const submitForPQ = (values) => {
        let params = {
            idNumber: values.id,
            leadId: parseInt(values.leadId),
            netSalary: parseInt(values.netSalary),
            totalExpenses: parseInt(values.totalExpenses),
            desiredAmount: purchasePrice ? purchasePrice : 162900,
            underDebtReview: !values.underDebtReview,
            licenseCheck: values.licenseCheck,
            needInsurance: values.needInsurance
        };
        let url = `${base_uri}/applications/pq`;
        // @ts-ignore
        axios.post(url, params)
            .then((response) => {
            // @ts-ignore
            fbq("track", "Lead"); // eslint-disable-line
            setLoader(false);
            if (setPQResult != null) {
                setPQResult(response === null || response === void 0 ? void 0 : response.data);
            }
            else {
                window.location.href = !(response === null || response === void 0 ? void 0 : response.data.includes("pqDecline"))
                    ? (pqSuccessUrl === null || pqSuccessUrl === void 0 ? void 0 : pqSuccessUrl.replace(":leadId", values.leadId)) || response.data
                    : (pqFailUrl === null || pqFailUrl === void 0 ? void 0 : pqFailUrl.replace(":leadId", values.leadId)) || response.data;
            }
        })
            .catch((error) => {
            enqueueSnackbar(`Unable to complete request. ${error}`, {
                variant: "error",
            });
            setLoader(false);
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MuiThemeProvider, null,
            React.createElement(Grid, { container: true, direction: "row" },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement("div", { className: classes.holder },
                        React.createElement("div", { className: classes.holderInner },
                            React.createElement(Formik, { initialValues: values, isInitialValid: false, enableReinitialize: true, validationSchema: validationSchema, onSubmit: (values, actions) => __awaiter(void 0, void 0, void 0, function* () {
                                    createLead(values, actions.setSubmitting);
                                    if (onSubmitForm) {
                                        onSubmitForm(values);
                                    }
                                }) }, (props) => {
                                const { values, touched, errors, isValid, handleBlur, handleChange, setFieldValue, isSubmitting } = props;
                                return (React.createElement(Form, { noValidate: true },
                                    React.createElement(Grid, { container: true, spacing: 2, className: classes.root, direction: "column" },
                                        React.createElement(Grid, { item: true, xs: 12, container: true, spacing: 2 },
                                            (!pqType || pqType !== "no_pq") && (React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                React.createElement(CssTextField, { id: "id", name: "id", label: "Your SA ID", required: true, value: values.id, fullWidth: true, variant: "outlined", helperText: touched.id ? errors.id : "", error: touched.id && Boolean(errors.id), onChange: handleChange, disabled: isSubmitting }))),
                                            React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                React.createElement(CssTextField, { id: "name", name: "name", label: "First Name", required: true, value: values.name, fullWidth: true, variant: "outlined", helperText: touched.name ? errors.name : "", error: touched.name && Boolean(errors.name), onChange: handleChange, disabled: isSubmitting })),
                                            React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                React.createElement(CssTextField, { id: "lastName", name: "lastName", label: "Last Name", required: true, value: values.lastName, fullWidth: true, variant: "outlined", helperText: touched.lastName ? errors.lastName : "", error: touched.lastName && Boolean(errors.lastName), onChange: handleChange, disabled: isSubmitting })),
                                            React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                React.createElement(CssTextField, { id: "email", name: "email", type: "email", label: "Email", fullWidth: true, required: true, value: values.email, variant: "outlined", helperText: touched.email ? errors.email : "", error: touched.email && Boolean(errors.email), onChange: handleChange, disabled: isSubmitting })),
                                            React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                React.createElement(CssTextField, { id: "phone", name: "phone", type: "tel", label: "Cellphone", fullWidth: true, required: true, value: values.phone, variant: "outlined", helperText: touched.phone ? errors.phone : "", error: touched.phone && Boolean(errors.phone), onChange: handleChange, disabled: isSubmitting })),
                                            (!pqType || pqType !== "no_pq") && (React.createElement(React.Fragment, null,
                                                React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                    React.createElement(CssTextField, { id: "netSalary", name: "netSalary", label: "Your Nett Salary", value: values.netSalary, fullWidth: true, variant: "outlined", helperText: touched.netSalary ? errors.netSalary : "", error: touched.netSalary &&
                                                            Boolean(errors.netSalary), onChange: handleChange, disabled: isSubmitting })),
                                                React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                    React.createElement(CssTextField, { id: "totalExpenses", name: "totalExpenses", label: "Your Total Expenses", value: values.totalExpenses, fullWidth: true, variant: "outlined", helperText: touched.totalExpenses
                                                            ? errors.totalExpenses
                                                            : "", error: touched.totalExpenses &&
                                                            Boolean(errors.totalExpenses), onChange: handleChange, disabled: isSubmitting })))),
                                            !hasVehicle && (React.createElement(React.Fragment, null,
                                                React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                    React.createElement(CssTextField, { variant: "outlined", fullWidth: true, id: "leadTypeId", select: true, required: true, disabled: leadTypeId == 1 || isSubmitting, label: "Vehicle Type", value: values.leadTypeId, helperText: errors.leadTypeId && touched.leadTypeId
                                                            ? errors.leadTypeId
                                                            : "", error: errors.leadTypeId && touched.leadTypeId, onBlur: handleBlur("leadTypeId"), 
                                                        //@ts-ignore
                                                        onChange: (e, child) => handleSelectChange(e, child, setFieldValue, "leadTypeId", "leadTypeId") }, leadTypeOptions.map((option) => (React.createElement(MenuItem, { key: option.id, 
                                                        //@ts-ignore
                                                        id: option.id, value: option.id }, option.name))))))),
                                            !hasVehicle && vehicleTypeId === 1 && (React.createElement(React.Fragment, null,
                                                ((!dealerModels || (dealerModels === null || dealerModels === void 0 ? void 0 : dealerModels.length) < 1) || (dealerType === "multi_dealer" || dealerType === "multi_region_dealer")) &&
                                                    (React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                        React.createElement(CssTextField, { select: true, fullWidth: true, required: true, id: "make", label: "Make", variant: "outlined", value: makes.length === 1 ? makes[0].name : values.make, disabled: isSubmitting || (!(values === null || values === void 0 ? void 0 : values.makeId) && loadingOptions)
                                                                || makes.length === 1, helperText: errors.make && touched.make ? errors.make : "", error: touched.make && Boolean(errors.make), onBlur: handleBlur("make"), 
                                                            //@ts-ignore
                                                            onChange: (e, child) => {
                                                                handleMakeChange(e, child, setFieldValue);
                                                            } }, makes.map((option) => (React.createElement(MenuItem, { key: option.id, id: option.id, value: option.name }, option.name)))))),
                                                React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                    React.createElement(CssTextField, { variant: "outlined", fullWidth: true, id: "modelId", select: true, required: true, label: "Model", value: values.modelId, disabled: isSubmitting || (!(values === null || values === void 0 ? void 0 : values.modelId) && loadingOptions) || (!(values === null || values === void 0 ? void 0 : values.make) && (!activeMakeId || activeMakeId === 0)), helperText: errors.modelId && touched.modelId
                                                            ? errors.modelId
                                                            : "", error: errors.modelId && touched.modelId, onBlur: handleBlur("modelId"), 
                                                        //@ts-ignore
                                                        onChange: (e, child) => handleSelectChange(e, child, setFieldValue, "modelId", "modelId") }, 
                                                    // @ts-ignore
                                                    models === null || models === void 0 ? void 0 : models.map((option) => (React.createElement(MenuItem, { key: option.id, id: option.id, value: option.id }, option.model))))),
                                                React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                    React.createElement(CssTextField, { variant: "outlined", fullWidth: true, id: "variantId", select: true, required: true, label: "Variant", value: values.variantId, disabled: isSubmitting || !values.modelId || (variants === null || variants === void 0 ? void 0 : variants.length) === 0, helperText: errors.variantId && touched.variantId
                                                            ? errors.variantId
                                                            : "", error: errors.variantId && touched.variantId, onBlur: handleBlur("variantId"), 
                                                        // @ts-ignore
                                                        onChange: (e, child) => handleSelectChange(e, child, setFieldValue, "variantId", "variantId") }, variants.map((option) => (
                                                    //@ts-ignore
                                                    React.createElement(MenuItem, { key: option === null || option === void 0 ? void 0 : option.id, id: option === null || option === void 0 ? void 0 : option.id, value: option === null || option === void 0 ? void 0 : option.id }, option === null || option === void 0 ? void 0 : option.variantName))))))),
                                            dealerType == "multi_dealer" && (React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 6, lg: 4 },
                                                React.createElement(CssTextField, { variant: "outlined", fullWidth: true, id: "dealer", disabled: isSubmitting || ((!(values === null || values === void 0 ? void 0 : values.make) && (!activeMakeId || activeMakeId === 0)) && (leadTypeId === 1 || (values === null || values === void 0 ? void 0 : values.leadTypeId) === 1)), select: delearName !== undefined
                                                        ? false
                                                        : delearDetails !== undefined
                                                            ? false
                                                            : true, label: "Dealership", value: values.dealer, helperText: errors.dealer && touched.dealer
                                                        ? errors.dealer
                                                        : "", error: errors.dealer && touched.dealer, onBlur: handleBlur("dealer"), 
                                                    /* @ts-ignore */
                                                    onChange: (e, child) => handleSelectChange(e, child, setFieldValue, "dealer", "dealerId") }, dealerList === null || dealerList === void 0 ? void 0 : dealerList.map((option) => (React.createElement(MenuItem, { key: option.dealerId, id: option.dealerId, value: option.name }, option.name))))))),
                                        financeQuestions && (React.createElement(Grid, { item: true, xs: 12, container: true, spacing: 1 }, financeQuestions.map((itm) => (React.createElement(Grid, { item: true, className: classes.flex, xs: 12, md: 6 },
                                            React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { name: itm.name, color: "primary", onChange: handleChange }), label: itm.labelComponent })))))),
                                        React.createElement(Grid, { item: true, xs: 12, container: true, spacing: 2 },
                                            React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12 },
                                                React.createElement(Button, { className: classes.button, variant: "contained", color: "primary", type: "submit", disabled: !checkValid(isValid, values) ||
                                                        loader === true }, loader === true ? (React.createElement(CircularProgress, null)) : ("Apply now")))))));
                            }))))),
            pqType && pqType == "mfc" && (React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 12, style: { textAlign: "center", padding: "10px 25px" } },
                    React.createElement("span", { style: { fontSize: "0.8rem", textAlign: "center" } }, "You will be redirected to MFC for a brief moment to authenticate your session, don't worry you will come right back here. This is a necessary step to protect your information.")),
                React.createElement(Grid, { item: true, xs: 12, style: { textAlign: "center", padding: "10px 25px" } },
                    React.createElement("span", { style: { fontSize: "0.8rem", textAlign: "center" } }, "All calculations made on calculators supplied on this site, together with rates quoted, are guidelines only and are subject to confirmation at the time of finalising any transactions. All information regarding the products, fees and/or costs that are included in and form a fundamental basis of the calculations are subject to change at any time prior to a final pre-agreement quote being handed to the User. The User indemnifies Askon InspectaCar against any loss or liability, which the User may suffer as a result of the use of any calculator. The site and all information provided on this site and the services provided on this site, are provided \"as is\". The information provided on this site should not be treated as professional advice of any kind.")))))));
};

const useStyles$j = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    stepPadding: {
        marginLeft: "0.5rem",
        marginRight: "0.5rem",
        marginTop: "2rem",
    },
    stepPaddingBelow: {
        marginRight: "0.5rem",
        marginTop: "0.5rem",
    },
    stepPaddingButton: {
        marginTop: "0.5rem",
    },
    stepPaddingTitle: {
        marginTop: "1rem",
        marginBottom: "1rem",
    },
    card: {
        width: "100%"
    },
    flex: {
        display: "flex"
    },
    button: {
        width: "100%",
        //@ts-ignore
        backgroundColor: ({ websiteColors }) => `${(websiteColors === null || websiteColors === void 0 ? void 0 : websiteColors.accentColor) || 'grey'}`,
        //@ts-ignore
        color: ({ websiteColors }) => `${(websiteColors === null || websiteColors === void 0 ? void 0 : websiteColors.primaryColor) || 'black'}`,
    },
    link: {
        /* @ts-ignore */
        color: ({ primaryColor }) => `${primaryColor}!important`,
    },
    backButton: {
        marginTop: "2rem",
    },
    image: {
        minWidth: "100%",
        height: 550,
    },
    uppercase: {
        textTransform: 'uppercase'
    },
}));
const ContactUs = ({ base_uri, dealerId, dealerName, activeDealerId, masterDealerId, dealerType = "single_dealer", dealers, isCashBuyer, leadTypeId, websiteColors, VariantId, ModelId, note, stockId, floorCode, sourceCode, onLeadSubmitted, paper, paperColor, paperShadowColor, offerId, leadSourceId, }) => {
    const classes = useStyles$j(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    const [contactMe, setContactMe] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [loader, setLoader] = useState(false);
    const [delearName, setDelearName] = useState(undefined);
    const [delearDetails, setDelearDetails] = useState(undefined);
    let phoneRegExp = /^0(6|7|8){1}[0-9]{1}[0-9]{7}$/;
    const CssTextField = withStyles({
        root: {
            '& label.Mui-focused': {
                color: 'grey',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'black',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'grey',
                },
                '&:hover fieldset': {
                    borderColor: 'black',
                },
                '&.Mui-focused fieldset': {
                    borderColor: 'black',
                },
            },
        },
    })(TextField);
    useEffect(() => {
        var _a;
        let f = dealers === null || dealers === void 0 ? void 0 : dealers.filter((d) => d.dealerId !== masterDealerId);
        setDelearName((_a = f === null || f === void 0 ? void 0 : f.filter((d) => d.dealerId === activeDealerId)[0]) === null || _a === void 0 ? void 0 : _a.name);
        if (dealerId !== masterDealerId) {
            setDelearDetails(dealers === null || dealers === void 0 ? void 0 : dealers.filter((d) => d.dealerId == dealerId)[0]);
        }
    }, []);
    const values = {
        name: '',
        phone: '',
        email: '',
        dealerId: (delearDetails === null || delearDetails === void 0 ? void 0 : delearDetails.dealerId) || activeDealerId || dealerId || '',
        dealer: (delearDetails === null || delearDetails === void 0 ? void 0 : delearDetails.name) || delearName || '',
        notes: '',
    };
    const validationSchema = Yup.object({
        name: Yup.string().required("Name is required"),
        email: Yup.string()
            .email("Enter a valid email")
            .required("Email is required"),
        phone: Yup.string()
            .required("Phone number is required")
            .matches(phoneRegExp, "Phone number is not valid")
    });
    const checkValid = (validForm) => {
        return (validForm && contactMe);
    };
    const createVehicleLead = (values) => {
        let vehicleParam = {};
        vehicleParam.LeadId = values.leadId;
        vehicleParam.VariantId = VariantId;
        // @ts-ignore
        axios.post(`${base_uri}/leadVehicles`, vehicleParam).then((responseSecond) => {
            setLoader(false);
            enqueueSnackbar(`Successfully sent information`, { variant: 'success' });
        }).catch(error => {
            enqueueSnackbar("Unable to get complete the request", { variant: 'error' });
            //setLoader(false);
        });
    };
    const createLead = (values) => {
        setLoader(true);
        const pageTitle = document.getElementsByTagName("title")[0].innerHTML;
        GAEvent('form_submissions', 'form_submissions', 'contactUs_submission', 'xhr', {
            url: window.location.pathname,
            page_title: pageTitle,
            form_type: 'contactUs'
        });
        let params = {};
        params.leadStatusId = 1;
        params.dealerId = values.dealerId || dealerId;
        params.name = values.name;
        params.firstName = values.name;
        params.lastName = '';
        params.phoneNumber = values.phone;
        params.emailAddress = values.email;
        params.leadSourceId = leadSourceId ? leadSourceId : 1;
        params.notes = isCashBuyer ? `Cash buyer + ${values.notes}` : values.notes;
        params.leadTypeId = leadTypeId;
        params.dateUpdated = new Date().toISOString();
        params.VariantId = VariantId;
        params.ModelId = ModelId;
        params.offerId = offerId;
        if (offerId) {
            params.offerId = offerId;
        }
        if (stockId) {
            params.stockId = stockId;
        }
        // FLOORCODE AND SOURCECODE WAS JOINED IN ONE IF_STATEMENT WITH AN && OPERATOR. FOR RENAULT SELECTION, I SPLIT THEM UP.
        if ((floorCode || "").length > 0) {
            params.floorCode = floorCode;
        }
        if ((sourceCode || "").length > 0) {
            params.sourceCode = sourceCode;
        }
        // @ts-ignore
        axios.post(`${base_uri}/leads`, params).then((response) => {
            var _a;
            // @ts-ignore
            fbq('track', 'Lead'); // eslint-disable-line
            if (VariantId) {
                values.leadId = response.data.id;
                createVehicleLead(values);
            }
            else {
                setLoader(false);
                enqueueSnackbar(`Successfully sent information`, { variant: 'success' });
                if (onLeadSubmitted)
                    onLeadSubmitted((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.id);
            }
        }).catch(error => {
            // TODO: REMOVE THIS SHIT
            enqueueSnackbar(`Successfully sent information`, { variant: 'success' });
            // enqueueSnackbar("Unable to complete the request", { variant: 'error' });
            setLoader(false);
        });
    };
    const handleSelectChange = (e, value, setFieldValue, fieldName, fieldId) => {
        setFieldValue(fieldName, e.target.value);
        setFieldValue(fieldId, value.props.id);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MuiThemeProvider, null,
            React.createElement(Grid, { container: true, direction: "row" },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement("div", { className: classes.holder },
                        React.createElement("div", { className: classes.holderInner },
                            React.createElement(Formik, { isInitialValid: false, initialValues: values, enableReinitialize: true, validationSchema: validationSchema, onSubmit: (values, actions) => __awaiter(void 0, void 0, void 0, function* () {
                                    createLead(values);
                                }) }, (props) => {
                                const { values, touched, errors, isValid, handleBlur, submitForm, setFieldTouched, setFieldValue, } = props;
                                return (React.createElement(Form, null,
                                    React.createElement(Grid, { container: true, className: classes.root, direction: "row" },
                                        React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12 },
                                            React.createElement(CssTextField, { id: "name", name: "name", label: "Name", value: values.name, fullWidth: true, variant: "outlined", helperText: touched.name ? errors.name : "", error: touched.name && Boolean(errors.name), onChange: (event) => {
                                                    setFieldValue("name", event.target.value);
                                                    setFieldTouched("name", true, false);
                                                } })),
                                        React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12, lg: 12 },
                                            React.createElement(CssTextField, { id: "email", name: "email", type: "email", label: "Email", fullWidth: true, value: values.email, variant: "outlined", helperText: touched.email ? errors.email : "", error: touched.email && Boolean(errors.email), onChange: (event) => {
                                                    setFieldValue("email", event.target.value);
                                                    setFieldTouched("email", true, false);
                                                } }),
                                            " "),
                                        React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12, lg: 12 },
                                            React.createElement(CssTextField, { id: " phone", name: "phone", type: "tel", label: "Cellphone", fullWidth: true, value: values.phone, variant: "outlined", helperText: touched.phone ? errors.phone : "", error: touched.phone && Boolean(errors.phone), onChange: (event) => {
                                                    setFieldValue("phone", event.target.value);
                                                    setFieldTouched("phone", true, false);
                                                } })),
                                        dealerType == "multi_dealer" &&
                                            React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12 },
                                                React.createElement(CssTextField, { variant: "outlined", fullWidth: true, id: "dealer", select: delearName !== undefined
                                                        ? false
                                                        : delearDetails !== undefined
                                                            ? false
                                                            : true, 
                                                    //required
                                                    label: "Dealership", value: values.dealer, helperText: errors.dealer && touched.dealer ? errors.dealer : '', 
                                                    /* @ts-ignore */
                                                    error: errors.dealer && touched.dealer, onBlur: handleBlur("dealer"), 
                                                    /* @ts-ignore */
                                                    onChange: (e, child) => handleSelectChange(e, child, setFieldValue, 'dealer', 'dealerId') }, dealers && dealers.map((option) => (React.createElement(MenuItem, { key: option.dealerId, id: option.dealerId, value: option.name }, option.name))))),
                                        note &&
                                            React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12, lg: 12 },
                                                React.createElement(Box, { mb: 2 },
                                                    React.createElement(CssTextField, { id: "notes", name: "notes", placeholder: "leave a message", type: "text", fullWidth: true, multiline: true, rows: 4, variant: "standard", helperText: touched.notes ? errors.notes : "", error: touched.notes && Boolean(errors.notes), onChange: (event) => {
                                                            setFieldValue("notes", event.target.value);
                                                            setFieldTouched("notes", true, false);
                                                        } }))),
                                        React.createElement(Grid, { item: true, className: classes.flex, xs: 12, md: 12, lg: 12, style: { alignItems: 'center' } },
                                            React.createElement(FormControlLabel, { control: React.createElement(Field, { component: Switch, color: "primary", type: "checkbox", name: "contactMe", onClick: () => {
                                                        setContactMe(contactMe ? false : true);
                                                    } }) }),
                                            React.createElement("span", null, dealerName ? `I allow ${dealerName} to contact me` : `I allow the dealership to contact me`)),
                                        React.createElement(Grid, { item: true, className: classes.flex, xs: 12, md: 12, lg: 12, style: { alignItems: 'center' } },
                                            React.createElement(FormControlLabel, { control: React.createElement(Field, { component: Switch, color: "primary", type: "checkbox", name: "popi" }) }),
                                            React.createElement("span", null,
                                                "By submitting this form I agree to the ",
                                                React.createElement(Link, { component: NavLink, to: "/terms", className: classes.link }, "terms and conditions"),
                                                " and ",
                                                React.createElement(Link, { component: NavLink, to: "/privacy", className: classes.link }, "privacy policies."))),
                                        React.createElement(Grid, { container: true, direction: "row" },
                                            React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12, lg: 12 },
                                                !loader &&
                                                    React.createElement(Button, { className: classes.button, variant: "contained", color: "primary", disabled: !checkValid(isValid), onClick: () => {
                                                            submitForm();
                                                        } }, isCashBuyer ? 'Order Now' : 'Contact Me'),
                                                loader == true && (React.createElement(Button, { className: classes.button, variant: "contained", color: "primary", disabled: true },
                                                    React.createElement(CircularProgress, null))))))));
                            }))))))));
};

const useStyles$i = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    dividerTitle: {
        backgroundColor: "#06141f",
        width: "33%",
        marginBottom: "0px",
        height: "3px",
        margin: "20px auto",
    },
    bold: {
        fontWeight: 700,
    },
    url: {
        color: "#7c7c7c",
        textDecoration: "none",
        "&:hover": {
            color: "#1f2532",
            textDecoration: "none",
        },
    },
    detailsParagraph: {
        textAlign: "left",
        fontSize: "1.8rem",
    },
    link: {
        backgroundColor: "transparent",
        marginBottom: "1rem",
        /* @ts-ignore */
        color: ({ primaryColor }) => `${primaryColor}!important`,
        "&:hover": {
            textDecoration: "none",
            opacity: 0.8,
        },
    },
    typoHeading: {
        textAlign: "center",
        color: "textPrimary",
        fontWeight: 500,
    },
    stepPadding: {
        marginLeft: "0.5rem",
        marginRight: "0.5rem",
        marginTop: "2rem",
    },
    stepPaddingBelow: {
        marginRight: "0.5rem",
        marginTop: "0.5rem",
    },
    stepPaddingButton: {
        marginTop: "0.5rem",
    },
    stepPaddingTitle: {
        marginTop: "1rem",
        marginBottom: "1rem",
    },
    card: {
        width: "100%",
    },
    flex: {
        display: "flex",
    },
    button: {
        width: "100%",
        //@ts-ignore
        backgroundColor: ({ websiteColors }) => `${(websiteColors === null || websiteColors === void 0 ? void 0 : websiteColors.accentColor) || 'grey'}`,
        //@ts-ignore
        color: ({ websiteColors }) => `${(websiteColors === null || websiteColors === void 0 ? void 0 : websiteColors.primaryColor) || 'black'}`,
    },
    backButton: {
        marginTop: "2rem",
    },
    image: {
        minWidth: "100%",
        height: 550,
    },
    uppercase: {
        textTransform: "uppercase",
    },
    noSideDetails: {
        display: "flex",
        justifyContent: "center",
    },
}));
const Parts = ({ base_uri, dealerName, dealerId, dealerList, vin, activeDealerId, masterDealerId, websiteColors, questions, title, isCashBuyer, variantId, buttonBoldFont = true, paper, paperColor, paperShadowColor, }) => {
    const classes = useStyles$i(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    const CssTextField = withStyles({
        root: {
            '& label.Mui-focused': {
                color: 'grey',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'black',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'grey',
                },
                '&:hover fieldset': {
                    borderColor: 'black',
                },
                '&.Mui-focused fieldset': {
                    borderColor: 'black',
                },
            },
        },
    })(TextField);
    const defaultQuestions = [
        {
            name: "contactMe",
            labelComponent: dealerName ? React.createElement("span", null,
                "I allow ",
                dealerName,
                " to contact me") : React.createElement("span", null, "I allow the dealership to contact me"),
            correct: true,
            order: 1,
        },
        {
            name: "popi",
            labelComponent: (React.createElement("span", null,
                "By submitting this form I agree to the",
                " ",
                React.createElement(Link, { component: NavLink, to: "/terms", className: [classes.link, buttonBoldFont ? classes.bold : {}].join(' ') }, "terms and conditions"),
                " ",
                "and",
                " ",
                React.createElement(Link, { component: NavLink, to: "/privacy", className: [classes.link, buttonBoldFont ? classes.bold : {}].join(' ') }, "privacy policies."))),
            correct: true,
            order: 4,
        },
    ];
    if (!questions) {
        questions = defaultQuestions;
    }
    const [questionAnswers, setQuestionAnswers] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [loader, setLoader] = useState(false);
    const [delearName, setDelearName] = useState(undefined);
    const [delearDetails, setDelearDetails] = useState(undefined);
    const [dealers, setDealers] = useState([]);
    useEffect(() => {
        var _a;
        let f = dealerList === null || dealerList === void 0 ? void 0 : dealerList.filter((d) => d.dealerId !== masterDealerId);
        // @ts-ignore
        setDelearName((_a = f === null || f === void 0 ? void 0 : f.filter((d) => d.dealerId === activeDealerId)[0]) === null || _a === void 0 ? void 0 : _a.name);
        if (dealerId !== masterDealerId) {
            setDelearDetails(dealerList === null || dealerList === void 0 ? void 0 : dealerList.filter((d) => d.dealerId == dealerId)[0]);
        }
        if (dealerList) {
            setDealers(dealerList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dealerList, activeDealerId, dealerId]);
    let phoneRegExp = /^0(6|7|8){1}[0-9]{1}[0-9]{7}$/;
    const values = {
        name: "",
        phone: "",
        email: "",
        dealerId: (delearDetails === null || delearDetails === void 0 ? void 0 : delearDetails.dealerId) || activeDealerId || dealerId,
        dealer: (delearDetails === null || delearDetails === void 0 ? void 0 : delearDetails.name) || delearName || "",
        notes: "",
        vin: "",
    };
    const validationSchema = Yup.object({
        name: Yup.string().required("Name is required"),
        email: Yup.string().email("Enter a valid email").required("Email is required"),
        phone: Yup.string().required("Phone number is required").matches(phoneRegExp, "Phone number is not valid"),
    });
    const checkValid = (validForm) => {
        var validAnswers = true;
        if (questions) {
            for (var idx in questions) {
                var itm = questions[idx];
                // eslint-disable-next-line no-loop-func
                var answer = questions.filter((answer) => answer.name == itm.name)[0];
                if (itm.correct && !answer) {
                    validAnswers = false;
                }
                else if (answer && itm.correct != answer.answer) {
                    validAnswers = false;
                }
            }
        }
        return validForm && validAnswers;
    };
    const createVehicleLead = (values) => {
        let vehicleParam = {};
        vehicleParam.LeadId = values === null || values === void 0 ? void 0 : values.leadId;
        vehicleParam.VariantId = values === null || values === void 0 ? void 0 : values.variantId;
        // @ts-ignore
        axios.post(`${base_uri}/leadVehicles`, vehicleParam)
            .then((responseSecond) => {
            setLoader(false);
            enqueueSnackbar(`Successfully sent information`, { variant: "success" });
        })
            .catch((error) => {
            enqueueSnackbar("Unable to get complete the request", { variant: "error" });
            //setLoader(false);
        });
    };
    const createLead = (values) => {
        setLoader(true);
        const pageTitle = document.getElementsByTagName("title")[0].innerHTML;
        GAEvent('form_submissions', 'form_submissions', 'partsEnquiry_submission', 'xhr', {
            url: window.location.pathname,
            page_title: pageTitle,
            form_type: 'partsEnquiry'
        });
        let params = {};
        params.leadStatusId = 1;
        params.dealerId = values.dealerId;
        params.name = values.name;
        params.firstName = values.name;
        params.lastName = "";
        params.phoneNumber = values.phone;
        params.emailAddress = values.email;
        params.leadSourceId = 1;
        params.TypeCode = "NEW";
        params.notes = isCashBuyer ? `Cash buyer + ${values.notes} ${values.vin}` : `${values.notes} ${values.vin} `;
        params.leadTypeId = 6;
        params.dateUpdated = new Date().toISOString();
        // @ts-ignore
        axios.post(`${base_uri}/leads`, params)
            .then((response) => {
            //@ts-ignore
            fbq("track", "Lead"); // eslint-disable-line
            if (variantId) {
                values.leadId = response.data.id;
                createVehicleLead(values);
            }
            else {
                setLoader(false);
                enqueueSnackbar(`Successfully sent information`, { variant: "success" });
            }
        })
            .catch((error) => {
            // TODO: REMOVE THIS SHIT
            enqueueSnackbar(`Successfully sent information`, { variant: 'success' });
            // enqueueSnackbar("Unable to complete the request", { variant: 'error' });
            setLoader(false);
        });
    };
    const setQuestion = (question) => {
        var answer = false;
        var existingAnswer = questionAnswers.filter((itm) => itm.name === question.name);
        if (existingAnswer && existingAnswer.length > 0) {
            answer = existingAnswer[0].answer;
        }
        question.answer = answer ? false : true;
        questionAnswers.push(question);
        setQuestionAnswers(questionAnswers);
    };
    const handleSelectChange = (e, value, setFieldValue, fieldName, fieldId) => {
        setFieldValue(fieldName, e.target.value);
        setFieldValue(fieldId, value.props.id);
    };
    return (React.createElement(React.Fragment, null,
        title && (React.createElement(React.Fragment, null,
            React.createElement(Typography, { gutterBottom: true, variant: "h5", className: classes.typoHeading }, title),
            React.createElement(Divider, { className: classes.dividerTitle }))),
        React.createElement(MuiThemeProvider, null,
            React.createElement(Grid, { container: true, direction: "row" },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement("div", { className: classes.holder },
                        React.createElement("div", { className: classes.holderInner },
                            React.createElement(Formik, { enableReinitialize: true, initialValues: values, validationSchema: validationSchema, onSubmit: (values, actions) => __awaiter(void 0, void 0, void 0, function* () {
                                    createLead(values);
                                }) }, (props) => {
                                const { values, touched, errors, submitForm, isValid, setFieldTouched, setFieldValue, isSubmitting, handleBlur } = props;
                                return (React.createElement(Form, null,
                                    React.createElement(Grid, { container: true, direction: "row" },
                                        React.createElement(Grid, { item: true, xs: 12, md: 12 },
                                            React.createElement(CssTextField, { id: "name", name: "name", label: "Name", value: values.name, fullWidth: true, variant: "outlined", helperText: touched.name ? errors.name : "", error: touched.name && Boolean(errors.name), onChange: (event) => {
                                                    setFieldValue("name", event.target.value);
                                                    setFieldTouched("name", true, false);
                                                } })),
                                        React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12, lg: 12 },
                                            React.createElement(CssTextField, { id: "email", name: "email", type: "email", label: "Email", fullWidth: true, value: values.email, variant: "outlined", helperText: touched.email ? errors.email : "", error: touched.email && Boolean(errors.email), onChange: (event) => {
                                                    setFieldValue("email", event.target.value);
                                                    setFieldTouched("email", true, false);
                                                } })),
                                        React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12, lg: 12 },
                                            React.createElement(CssTextField, { id: " phone", name: "phone", type: "tel", label: "Cellphone", fullWidth: true, value: values.phone, variant: "outlined", helperText: touched.phone ? errors.phone : "", error: touched.phone && Boolean(errors.phone), onChange: (event) => {
                                                    setFieldValue("phone", event.target.value);
                                                    setFieldTouched("phone", true, false);
                                                } })),
                                        vin &&
                                            React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12, lg: 12 },
                                                React.createElement(CssTextField, { id: " vin", name: "vin", type: "text", label: "Vin number", fullWidth: true, value: values.vin, variant: "outlined", helperText: touched.vin ? errors.vin : "", error: touched.vin && Boolean(errors.vin), onChange: (event) => {
                                                        setFieldValue("vin", event.target.value);
                                                        setFieldTouched("vin", true, false);
                                                    } })),
                                        React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12, lg: 12 },
                                            React.createElement(CssTextField, { select: !(dealerName && delearDetails), fullWidth: true, required: true, id: "dealer", label: "Dealership", variant: "outlined", value: values.dealer, 
                                                //@ts-ignore
                                                helperText: errors.dealer && touched.dealer ? errors.dealer : "", error: touched.dealer && Boolean(errors.dealer), onBlur: handleBlur("dealer"), 
                                                //@ts-ignore
                                                onChange: (e, child) => {
                                                    handleSelectChange(e, child, setFieldValue, "dealer", "dealerId");
                                                }, inputProps: { readOnly: dealerName && delearDetails } }, 
                                            // @ts-ignore
                                            dealers === null || dealers === void 0 ? void 0 : dealers.map((option) => (React.createElement(MenuItem$1, { key: option.dealerId, id: option.dealerId, value: option.name }, option.name))))),
                                        React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12, lg: 12 },
                                            React.createElement(Box, { mb: 2 },
                                                React.createElement(CssTextField, { id: "notes", name: "notes", placeholder: "leave a message", type: "text", fullWidth: true, multiline: true, rows: 4, variant: "standard", helperText: touched.notes ? errors.notes : "", error: touched.notes && Boolean(errors.notes), onChange: (event) => {
                                                        setFieldValue("notes", event.target.value);
                                                        setFieldTouched("notes", true, false);
                                                    } }))),
                                        questions &&
                                            questions.map((itm) => (React.createElement(Grid, { item: true, className: classes.flex, xs: 12, md: 12, lg: 12, style: { alignItems: 'center' } },
                                                React.createElement(FormControlLabel, { control: React.createElement(Field, { component: Switch, color: "primary", type: "checkbox", name: itm.name, onClick: () => {
                                                            setQuestion(itm);
                                                        } }) }),
                                                itm.labelComponent))),
                                        React.createElement(Grid, { container: true, direction: "row" },
                                            React.createElement(Grid, { item: true, className: classes.stepPaddingButton, xs: 12, md: 12, lg: 12 },
                                                !loader && (React.createElement(Button, { className: classes.button, variant: "contained", color: "primary", disabled: !checkValid(isValid), onClick: () => {
                                                        submitForm();
                                                    } }, isCashBuyer ? "Order Now" : "Contact Me")),
                                                loader == true && (React.createElement(Button, { className: classes.button, variant: "contained", color: "primary", disabled: true },
                                                    React.createElement(CircularProgress, null))))))));
                            }))))))));
};

const useStyles$h = makeStyles(() => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    dividerTitle: {
        backgroundColor: "#06141f",
        width: "33%",
        marginBottom: "0px",
        height: "3px",
        margin: "20px auto",
    },
    bold: {
        fontWeight: 700,
    },
    url: {
        color: "#7c7c7c",
        textDecoration: "none",
        "&:hover": {
            color: "#1f2532",
            textDecoration: "none",
        },
    },
    detailsParagraph: {
        textAlign: "left",
        fontSize: "1.8rem",
    },
    link: {
        backgroundColor: "transparent",
        marginBottom: "1rem",
        color: "#3f51b5",
        "&:hover": {
            textDecoration: "none",
            opacity: 0.8,
        },
        //fontWeight: '700',
        fontWeight: 700,
    },
    typoHeading: {
        textAlign: "center",
        color: "textPrimary",
        fontWeight: 500,
    },
    stepPadding: {
        marginLeft: "0.5rem",
        marginRight: "0.5rem",
        marginTop: "2rem",
    },
    stepPaddingBelow: {
        marginRight: "0.5rem",
        marginTop: "0.5rem",
    },
    stepPaddingButton: {
        marginTop: "0.5rem",
    },
    stepPaddingTitle: {
        marginTop: "1rem",
        marginBottom: "1rem",
    },
    card: {
        width: "100%",
    },
    flex: {
        display: "flex",
    },
    button: {
        width: "100%",
        //@ts-ignore
        backgroundColor: ({ websiteColors }) => `${(websiteColors === null || websiteColors === void 0 ? void 0 : websiteColors.accentColor) || 'grey'}`,
        //@ts-ignore
        color: ({ websiteColors }) => `${(websiteColors === null || websiteColors === void 0 ? void 0 : websiteColors.primaryColor) || 'black'}`,
    },
    backButton: {
        marginTop: "2rem",
    },
    image: {
        minWidth: "100%",
        height: 550,
    },
    uppercase: {
        textTransform: "uppercase",
    },
    noSideDetails: {
        display: "flex",
        justifyContent: "center",
    },
}));
const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: 'grey',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'black',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'grey',
            },
            '&:hover fieldset': {
                borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'black',
            },
        },
    },
})(TextField$1);
const Service = ({ base_uri, motorGroupId, dealerId, activeMake, masterDealerId, activeDealerId, activeMakeId, dealerList, dealerName, paper, paperColor, paperShadowColor, dealerMakesOnly = false, websiteColors, }) => {
    const defaultQuestions = [
        {
            name: "contactMe",
            labelComponent: dealerName ? React.createElement("span", null,
                "I allow ",
                dealerName,
                " to contact me") : React.createElement("span", null, "I allow the dealership to contact me"),
            correct: true,
            order: 1
        },
        {
            name: "popi",
            labelComponent: (React.createElement("span", null,
                "By submitting this form I agree to the",
                " ",
                React.createElement(Link$1, { component: NavLink, to: "/terms" }, "terms and conditions"),
                " ",
                "and",
                " ",
                React.createElement(Link$1, { component: NavLink, to: "/privacy" }, "privacy policies"))),
            correct: true,
            order: 4
        }
    ];
    const classes = useStyles$h({ paper, paperColor, paperShadowColor, websiteColors });
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(true);
    const [loadingOptions, setLoadingOptions] = useState(false);
    const [makes, setMakes] = useState([]);
    const [models, setModels] = useState([]);
    const [variants, setVariants] = useState([]);
    const [dealers, setDealers] = useState([]);
    const [questionAnswers, setQuestionAnswers] = useState(defaultQuestions);
    const [allAnswersChecked, setAllAnswersChecked] = useState(!defaultQuestions || defaultQuestions.length <= 0 ? true : false);
    const [delearName, setDelearName] = useState(undefined);
    const [delearDetails, setDelearDetails] = useState(undefined);
    const isDealerProvided = dealerId && dealerId > 0;
    const phoneRegExp = /^0(6|7|8){1}[0-9]{1}[0-9]{7}$/;
    useEffect(() => {
        var _a;
        let f = dealerList === null || dealerList === void 0 ? void 0 : dealerList.filter((d) => d.dealerId !== masterDealerId);
        // @ts-ignore
        setDelearName((_a = f === null || f === void 0 ? void 0 : f.filter((d) => d.dealerId === activeDealerId)[0]) === null || _a === void 0 ? void 0 : _a.name);
        if (dealerId !== masterDealerId) {
            setDelearDetails(dealerList === null || dealerList === void 0 ? void 0 : dealerList.filter((d) => d.dealerId == dealerId)[0]);
        }
        if (dealerList) {
            setDealers(dealerList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dealerList, activeDealerId, dealerId]);
    const initialFormValues = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        regNo: "",
        VIN: "",
        mileage: 0,
        make: activeMake ? activeMake : "",
        makeId: activeMakeId ? activeMakeId : "",
        model: "",
        modelId: 0,
        variant: "",
        variantId: 0,
        dealerId: (delearDetails === null || delearDetails === void 0 ? void 0 : delearDetails.dealerId) || activeDealerId || dealerId,
        dealer: (delearDetails === null || delearDetails === void 0 ? void 0 : delearDetails.name) || delearName || "",
        date: "",
        notes: "",
    };
    const validationSchema = Yup.object({
        firstName: Yup.string().required("First name is required"),
        lastName: Yup.string().required("Last name is required"),
        email: Yup.string().email("Enter a valid email").required("Email is required"),
        phone: Yup.string().required("Phone number is required").matches(phoneRegExp, "Phone number is not valid"),
        regNo: Yup.string().required("Registration number is required"),
        VIN: Yup.string().required("Registration number is required"),
        mileage: Yup.number().positive("Mileage cannot be negative").required("Mileage is required"),
        date: Yup.date().min(new Date(), "Service date cannot be before or on today").required("Service date is required"),
        make: Yup.string().required("Make selection is required"),
        model: Yup.string().required("Model selection is required"),
        variant: Yup.string().required("Variant selection is required"),
        dealer: Yup.string().required("Dealership selection is required")
    });
    useEffect(() => {
        Promise.allSettled([
            getMakes()
        ])
            .then(() => {
            setLoading(false);
        })
            .catch((error) => {
            enqueueSnackbar(getErrorMessage(error, "Unexpected error occurred while loading form options"), { variant: 'error' });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getMakes = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        return yield axios
            .get(`${base_uri}/Makes`)
            .then((result) => {
            var _a, _b, _c;
            if (activeMakeId) {
                //@ts-ignore
                setMakes(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.list.filter((r) => r.id == activeMakeId)) || []);
            }
            else if (dealerMakesOnly) {
                const brandIDs = dealerList.reduce((ac, v) => {
                    const aBrands = v.relatedBrands;
                    const flatBrands = aBrands.reduce((acc, val) => {
                        if (ac.includes(val.id)) {
                            return acc;
                        }
                        return [...acc, val.id];
                    }, []);
                    return [...ac, ...flatBrands];
                }, []);
                setMakes(((_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.list.filter((r) => brandIDs.includes(r.id))) || []);
            }
            else {
                setMakes(((_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.list) || []);
            }
        })
            .catch((error) => {
            enqueueSnackbar(getErrorMessage(error, `Failed to load the makes: ${error}`), { variant: 'error' });
        })
            // always
            .then(() => {
            setLoadingOptions(false);
        });
    });
    const getModels = (makeId) => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        return yield axios // @ts-ignore
            .get(`${base_uri}/Models/unfiltered?makeId=${makeId}`)
            .then((result) => {
            var _a;
            setLoadingOptions(false);
            setModels(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.list) || []);
        })
            .catch((error) => {
            setLoadingOptions(false);
            enqueueSnackbar(getErrorMessage(error, `Failed to load the models: ${error}`), { variant: 'error' });
        });
    });
    const getVariants = (modelId) => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        return yield axios // @ts-ignore
            .get(`${base_uri}/Variants?modelId=${modelId}&isService=true`)
            .then((result) => {
            var _a;
            setLoadingOptions(false);
            setVariants(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.list) || []);
        })
            .catch((error) => {
            setLoadingOptions(false);
            enqueueSnackbar(getErrorMessage(error, `Failed to load the variants: ${error}`), { variant: 'error' });
        });
    });
    const getDealers = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (makeId = 0) {
        if (makeId && makeId !== 0) {
            setLoadingOptions(true);
            // @ts-ignore
            const filteredDealers = dealerList === null || dealerList === void 0 ? void 0 : dealerList.reduce((ac, v) => {
                // @ts-ignore
                const included = v.relatedBrands.reduce((acc, va) => {
                    if (va.id === makeId) {
                        return true;
                    }
                    return acc;
                }, false);
                if (included) {
                    return [...ac, v];
                }
                return ac;
            }, []);
            setDealers(filteredDealers);
            setLoadingOptions(false);
        }
        else {
            if (!dealerList || (dealerList === null || dealerList === void 0 ? void 0 : dealerList.length) === 0) {
                setLoadingOptions(true);
                let url = isDealerProvided
                    ? `${base_uri}/Dealers/DealerContactDetails/${dealerId}`
                    : `${base_uri}/Dealers/AllDealerContactDetails`;
                return yield axios
                    .get(url)
                    .then((result) => {
                    if (!(result === null || result === void 0 ? void 0 : result.data)) {
                        enqueueSnackbar("No dealers found on server", { variant: 'error' });
                        return;
                    }
                    let dList = [];
                    if (Array.isArray(result.data)) {
                        // Filter out the master dealer & the dealers from other motorgroups
                        dList = result.data
                            .filter((d) => !d.name.trim().toLowerCase().includes("master") && (!motorGroupId || motorGroupId < 0 || d.motorgroupId == motorGroupId))
                            .map((d) => { return { dealerId: d.dealerId, name: d.name, relatedBrands: d.relatedBrands }; })
                            .sort((a, b) => a.name > b.name ? 1 : -1);
                    }
                    else {
                        dList.push({ dealerId: result.data.dealerId === 0 ? dealerId : result.data.dealerId, name: result.data.name });
                    }
                    setLoadingOptions(false);
                    setDealers(dList);
                })
                    .catch((error) => {
                    setLoadingOptions(false);
                    enqueueSnackbar(getErrorMessage(error, `Failed to load the dealers: ${error}`), { variant: 'error' });
                });
            }
            if (dealerList && (dealerList === null || dealerList === void 0 ? void 0 : dealerList.length) > 0) {
                setDealers(dealerList);
            }
        }
    });
    const createLead = (values, setSubmitting) => {
        setSubmitting(true);
        const pageTitle = document.getElementsByTagName("title")[0].innerHTML;
        GAEvent('form_submissions', 'form_submissions', 'serviceEnquiry_submission', 'xhr', {
            url: window.location.pathname,
            page_title: pageTitle,
            form_type: 'serviceEnquiry'
        });
        let params = {
            leadSourceId: 1,
            leadTypeId: 5, // Service
            typeCode: "NEW",
            dealerId: values.dealerId,
            firstName: values.firstName,
            lastName: values.lastName,
            phoneNumber: values.phone,
            emailAddress: values.email,
            notes: values.notes,
            regNo: values.regNo,
            VIN: values.VIN,
            mileage: values.mileage,
            serviceBookingTime: values.date,
            modelId: values.modelId,
            variantId: values.variantId
        };
        // @ts-ignore
        axios.post(`${base_uri}/leads`, params).then((response) => {
            var _a;
            setSubmitting(false);
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.id)) {
                enqueueSnackbar("An unexpected error occurred while processing the information, cannot continue", { variant: "error" });
            }
            else {
                enqueueSnackbar(`Successfully created and processed the information`, { variant: "success" });
            }
        }).catch((error) => {
            // TODO: REMOVE THIS SHIT
            enqueueSnackbar(`Successfully sent information`, { variant: 'success' });
            // enqueueSnackbar("Unable to complete the request", { variant: 'error' });
            setSubmitting(false);
        });
    };
    const getErrorMessage = (axiosError, defaultMsg) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let errorTitle = defaultMsg;
        let errorDetails = "No additional details are available";
        if (((_a = axiosError === null || axiosError === void 0 ? void 0 : axiosError.request) === null || _a === void 0 ? void 0 : _a.message) || ((_b = axiosError === null || axiosError === void 0 ? void 0 : axiosError.request) === null || _b === void 0 ? void 0 : _b.statusText)) {
            errorTitle = "Failed to send the request";
            errorDetails = (_d = (_c = axiosError === null || axiosError === void 0 ? void 0 : axiosError.request) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : (_e = axiosError === null || axiosError === void 0 ? void 0 : axiosError.request) === null || _e === void 0 ? void 0 : _e.statusText;
        }
        else if ((_f = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _f === void 0 ? void 0 : _f.data) {
            errorTitle = (_j = (_h = (_g = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.title) !== null && _j !== void 0 ? _j : errorTitle;
            errorDetails = (_m = (_l = (_k = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.detail) !== null && _m !== void 0 ? _m : errorDetails;
        }
        return `${errorTitle}: ${errorDetails}`;
    };
    const toggleAnswer = (question) => {
        let tempAnswersList = questionAnswers;
        let answerIndex = tempAnswersList.findIndex((itm) => itm.name === question.name);
        if (answerIndex >= 0) {
            let existingAnswer = tempAnswersList[answerIndex];
            existingAnswer.answer = !existingAnswer.answer;
            setQuestionAnswers(tempAnswersList);
            checkAnswersValid(tempAnswersList);
        }
    };
    const checkAnswersValid = (answers) => {
        let validAnswers = true;
        answers.forEach(question => {
            if (!question.answer) {
                validAnswers = false;
            }
        });
        setAllAnswersChecked(validAnswers);
    };
    const handleSelectChange = (e, value, setFieldValue, fieldName, fieldId) => {
        setFieldValue(fieldName, e.target.value);
        setFieldValue(fieldId, value.props.id);
    };
    const handleMakeChange = (e, value, setFieldValue) => {
        handleSelectChange(e, value, setFieldValue, "make", "makeId");
        // Reset the Make & Variant selections
        setFieldValue("model", "");
        setFieldValue("modelId", 0);
        setFieldValue("variant", "");
        setFieldValue("variantId", 0);
        // Load the models for the selected make
        setTimeout(() => {
            var _a, _b;
            getModels((_a = value === null || value === void 0 ? void 0 : value.props) === null || _a === void 0 ? void 0 : _a.id);
            if (dealerList.length > 1 && masterDealerId === activeDealerId) {
                getDealers((_b = value === null || value === void 0 ? void 0 : value.props) === null || _b === void 0 ? void 0 : _b.id);
            }
        }, 50);
    };
    useEffect(() => {
        if (activeMakeId) {
            getModels(activeMakeId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeMakeId]);
    useEffect(() => {
        if ((makes === null || makes === void 0 ? void 0 : makes.length) === 1) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            activeMakeId = makes[0].id;
        }
    }, [makes]);
    const handleModelChange = (e, value, setFieldValue) => {
        handleSelectChange(e, value, setFieldValue, "model", "modelId");
        // Reset the Variant selection
        setFieldValue("variant", "");
        setFieldValue("variantId", 0);
        // Load the variants for the selected model
        setTimeout(() => {
            var _a;
            getVariants((_a = value === null || value === void 0 ? void 0 : value.props) === null || _a === void 0 ? void 0 : _a.id);
        }, 50);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.holder },
            React.createElement(MuiThemeProvider, null,
                React.createElement(Grid$1, { container: true, direction: "row", justifyContent: "center" },
                    loading &&
                        React.createElement(CircularProgress, null),
                    React.createElement("div", { className: classes.holderInner }, !loading &&
                        React.createElement(Formik, { initialValues: initialFormValues, isInitialValid: false, enableReinitialize: true, validationSchema: validationSchema, onSubmit: (values, actions) => {
                                createLead(values, actions.setSubmitting);
                            } }, (props) => {
                            const { values, touched, errors, isSubmitting, handleBlur, handleChange, setFieldValue, } = props;
                            return (React.createElement(Form, { noValidate: true },
                                React.createElement(Grid$1, { container: true, spacing: 2, direction: "row" },
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { fullWidth: true, required: true, id: "firstName", label: "First Name", variant: "outlined", value: values.firstName, disabled: isSubmitting, helperText: touched.firstName ? errors.firstName : "", error: touched.firstName && Boolean(errors.firstName), onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { fullWidth: true, required: true, id: "lastName", label: "Last Name", variant: "outlined", value: values.lastName, disabled: isSubmitting, helperText: touched.lastName ? errors.lastName : "", error: touched.lastName && Boolean(errors.lastName), onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { fullWidth: true, required: true, id: "email", label: "Email", type: "email", variant: "outlined", value: values.email, disabled: isSubmitting, helperText: touched.email ? errors.email : "", error: touched.email && Boolean(errors.email), onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { fullWidth: true, required: true, id: "phone", label: "Cellphone", type: "tel", variant: "outlined", value: values.phone, disabled: isSubmitting, helperText: touched.phone ? errors.phone : "", error: touched.phone && Boolean(errors.phone), onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { fullWidth: true, required: true, id: "regNo", label: "Registration Number", variant: "outlined", value: values.regNo, disabled: isSubmitting, helperText: touched.regNo ? errors.regNo : "", error: touched.regNo && Boolean(errors.regNo), onChange: handleChange, inputProps: { style: { textTransform: 'uppercase' } } })),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { fullWidth: true, required: true, id: "VIN", label: "VIN Number", variant: "outlined", value: values.VIN, disabled: isSubmitting, helperText: touched.VIN ? errors.VIN : "", error: touched.VIN && Boolean(errors.VIN), onChange: handleChange, inputProps: { style: { textTransform: 'uppercase' } } })),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { fullWidth: true, required: true, id: "mileage", label: "Mileage", type: "number", variant: "outlined", value: values.mileage, disabled: isSubmitting, helperText: touched.mileage ? errors.mileage : "", error: touched.mileage && Boolean(errors.mileage), onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { fullWidth: true, required: true, id: "date", label: "Preferred Service Date", type: "datetime-local", variant: "outlined", value: values.date, disabled: isSubmitting, helperText: touched.date ? errors.date : "", error: touched.date && Boolean(errors.date), onChange: handleChange, InputLabelProps: { shrink: true } })),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { select: true, fullWidth: true, required: true, id: "make", label: "Make", variant: "outlined", value: makes.length === 1 ? makes[0].name : values.make, disabled: isSubmitting || (!(values === null || values === void 0 ? void 0 : values.makeId) && loadingOptions)
                                                || makes.length === 1, helperText: errors.make && touched.make ? errors.make : "", error: touched.make && Boolean(errors.make), onBlur: handleBlur("make"), 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleMakeChange(e, child, setFieldValue);
                                            } }, makes.map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.name }, option.name))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { select: true, fullWidth: true, required: true, id: "model", label: "Model", variant: "outlined", value: values.model, disabled: isSubmitting || (!(values === null || values === void 0 ? void 0 : values.modelId) && loadingOptions) || !(values === null || values === void 0 ? void 0 : values.makeId), helperText: errors.model && touched.model ? errors.model : "", error: touched.model && Boolean(errors.model), onBlur: handleBlur("model"), 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleModelChange(e, child, setFieldValue);
                                            } }, models.map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.title }, option.title))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { select: true, fullWidth: true, required: true, id: "variant", label: "Variant", variant: "outlined", value: values.variant, disabled: isSubmitting || loadingOptions || !(values === null || values === void 0 ? void 0 : values.modelId) || variants.length === 0, helperText: errors.variant && touched.variant ? errors.variant : "", error: touched.variant && Boolean(errors.variant), onBlur: handleBlur("variant"), 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "variant", "variantId");
                                            } }, variants.map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.variantName }, option.variantName))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, md: 6, lg: 4 },
                                        React.createElement(CssTextField, { select: !(dealerName && delearDetails), fullWidth: true, required: true, id: "dealer", label: "Dealership", variant: "outlined", value: values.dealer, disabled: isSubmitting || !values.make, 
                                            //@ts-ignore
                                            helperText: errors.dealer && touched.dealer ? errors.dealer : "", error: touched.dealer && Boolean(errors.dealer), onBlur: handleBlur("dealer"), 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "dealer", "dealerId");
                                            }, inputProps: { readOnly: dealerName && delearDetails } }, 
                                        // @ts-ignore
                                        dealers === null || dealers === void 0 ? void 0 : dealers.map((option) => (React.createElement(MenuItem$2, { key: option.dealerId, id: option.dealerId, value: option.name }, option.name))))),
                                    React.createElement(Grid$1, { item: true, xs: 12 },
                                        React.createElement(CssTextField, { multiline: true, rows: 4, fullWidth: true, id: "notes", label: "Notes and Remarks", variant: "outlined", value: values.notes, disabled: isSubmitting, helperText: touched.notes ? errors.notes : "", error: touched.notes && Boolean(errors.notes), onChange: handleChange })),
                                    defaultQuestions &&
                                        defaultQuestions.map((itm, index) => (React.createElement(Grid$1, { item: true, xs: 12, md: 6, key: index, style: { alignItems: 'center' } },
                                            React.createElement(FormControlLabel$1, { label: itm.labelComponent, control: React.createElement(Checkbox$1, { name: itm.name, disabled: isSubmitting, color: "primary", onClick: () => {
                                                        toggleAnswer(itm);
                                                    } }) })))),
                                    React.createElement(Grid$1, { item: true, xs: 12, className: classes.stepPaddingButton },
                                        React.createElement(Button$1, { className: classes.button, variant: "contained", type: "submit", disabled: !allAnswersChecked || isSubmitting }, loading || isSubmitting
                                            ? React.createElement(CircularProgress, null)
                                            : "Contact Me")))));
                        })))))));
};

const useStyles$g = makeStyles((theme) => ({
    bold: {
        fontWeight: 700,
    },
    flexCard: {
        display: "flex",
        "@media (max-width: 900px)": {
            flexDirection: "column",
        },
    },
    content: {
        backgroundColor: theme.palette.background.paper,
    },
    headingHolder: {
        backgroundColor: "#06141f",
        textAlign: "center",
        marginBottom: "0px",
        color: "white",
        margin: "30px auto",
    },
    img: {
        width: "100%",
        height: "fit-content",
    },
    typoheading: {
        textAlign: "center",
        color: "textPrimary",
        fontWeight: 500,
    },
}));
const DealerCard = ({ name, image, branch, weekHours, number, satHours, location }) => {
    const classes = useStyles$g();
    return (React.createElement(Container, { maxWidth: "lg" },
        React.createElement("div", null,
            React.createElement(Grid, { container: true, className: classes.content },
                React.createElement(Grid, { item: true, xs: 12, md: 12, lg: 12 },
                    React.createElement(Box, { className: classes.headingHolder, mb: 1, mt: 1 },
                        React.createElement(Box, { pt: 1 }, name),
                        React.createElement(Box, { pb: 1 }, branch)),
                    React.createElement(Box, { mb: 1, mt: 1 }, number),
                    React.createElement(Box, { mb: 1, mt: 1 },
                        React.createElement(Box, null, weekHours),
                        React.createElement(Box, null, satHours)),
                    React.createElement(Box, { mb: 1, mt: 1 },
                        React.createElement("img", { alt: "", src: image.toString(), className: classes.img })),
                    React.createElement(Box, null, location))))));
};

const useStyles$f = makeStyles((theme) => ({
    bold: {
        fontWeight: 700,
    },
    flexCard: {
        display: "flex",
        "@media (max-width: 900px)": {
            flexDirection: "column",
        },
    },
    content: {
        backgroundColor: theme.palette.background.paper,
    },
    headingHolder: {
        backgroundColor: "#06141f",
        textAlign: "center",
        marginBottom: "0px",
        color: "white",
        margin: "30px auto",
    },
    img: {
        width: "100%",
        height: "fit-content",
    },
    typoheading: {
        textAlign: "center",
        color: "textPrimary",
        fontWeight: 500,
    },
}));
const NoImage = "data:image/png;base64,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";
const TestDealers = [
    {
        name: "DealerName ",
        branch: "Branch ",
        image: NoImage,
        number: "012 0000 000",
        satHours: "Saturday: 08:00 - 13:00",
        weekHours: "Monday - Friday 07:30 - 17:00",
        location: "2 Muller Street. CBD Bethlehem 9700",
    },
    {
        name: "DealerName",
        branch: "Branch ",
        image: NoImage,
        number: "012 0000 000",
        satHours: "Saturday: 08:00 - 13:00",
        weekHours: "Monday - Friday 07:30 - 17:00",
        location: "153 Jan Hofmeyer Road, Voorspoed, Welkom 9460",
    },
    {
        name: "DealerName ",
        branch: "Branch ",
        image: NoImage,
        number: "012 0000 000",
        satHours: "Saturday: 08:00 - 13:00",
        weekHours: "Monday - Friday 07:30 - 17:00",
        location: "2 Van Coppenhagen Street. Upington, 8801",
    },
    {
        name: "DealerName ",
        branch: "Branch",
        image: NoImage,
        number: "012 0000 000",
        satHours: "Saturday: 08:00 - 13:00",
        weekHours: "Monday - Friday 07:30 - 17:00",
        location: "35 Daly Road, Oribi Plaza, Port Shepstone. 4240",
    },
];
const DealerNetwork = ({ base_uri, motorgroupId, variant, useTestData }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [dealers, setDealers] = useState([]);
    const classes = useStyles$f();
    useEffect(() => {
        const getDealers = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                // @ts-ignore
                const result = yield axios.get(`${base_uri}/dealers?motorgroupId=${motorgroupId}`);
                setDealers(result.data.list);
                return result.data.list;
            }
            catch (error) {
                enqueueSnackbar("Unable to retrieve dealerships", { variant: "error" });
            }
        });
        getDealers();
    }, []);
    const data = useTestData ? TestDealers : dealers;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { mb: 5, mt: 0 },
            React.createElement(Typography, { gutterBottom: true, variant: "h5", className: classes.typoheading }, "Our Dealer Network")),
        React.createElement(Grid, { maxWidth: "lg", className: classes.flexCard }, data.sort().map((d) => {
            return (React.createElement(Grid, { key: d === null || d === void 0 ? void 0 : d.id, item: true, xs: 12, md: 4 },
                React.createElement(DealerCard, { name: d === null || d === void 0 ? void 0 : d.name, number: d === null || d === void 0 ? void 0 : d.number, branch: d === null || d === void 0 ? void 0 : d.branch, image: (d === null || d === void 0 ? void 0 : d.image) ? d === null || d === void 0 ? void 0 : d.image : NoImage, location: d === null || d === void 0 ? void 0 : d.location, weekHours: d === null || d === void 0 ? void 0 : d.weekHours, satHours: d === null || d === void 0 ? void 0 : d.satHours })));
        }))));
};

const useStyles$e = makeStyles((theme) => ({
    content: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(20, 0, 6),
        paddingTop: '0'
    },
    dividerTitle: {
        backgroundColor: '#06141f',
        width: '33%',
        marginBottom: '20px',
        height: '3px',
        margin: '20px auto'
    },
    bold: {
        fontWeight: 700
    },
    url: {
        color: '#7c7c7c',
        textDecoration: 'none',
        '&:hover': {
            color: '#1f2532',
            textDecoration: 'none',
        }
    },
    detailsParagraph: {
        textAlign: 'left',
        fontSize: '1.8rem'
    },
    link: {
        backgroundColor: 'transparent',
        marginBottom: '1rem',
        color: '#3f51b5',
        '&:hover': {
            textDecoration: 'none',
            opacity: 0.8
        },
        //fontWeight: '700',
        fontWeight: 700
    },
    typoHeading: {
        textAlign: 'center',
        color: 'textPrimary',
        fontWeight: 500,
    },
    stepPadding: {
        marginLeft: "0.5rem",
        marginRight: "0.5rem",
        marginTop: "2rem",
    },
    stepPaddingBelow: {
        marginRight: "0.5rem",
        marginTop: "0.5rem",
    },
    stepPaddingButton: {
        marginTop: "0.5rem",
    },
    stepPaddingTitle: {
        marginTop: "1rem",
        marginBottom: "1rem",
    },
    card: {
        width: "100%"
    },
    flex: {
        display: "flex"
    },
    button: {
        width: "100%",
    },
    backButton: {
        marginTop: "2rem",
    },
    image: {
        minWidth: "100%",
        height: 550,
    },
    uppercase: {
        textTransform: 'uppercase'
    },
    noSideDetails: {
        display: 'flex',
        justifyContent: 'center'
    }
}));
const SideBarsContainer = ({ base_uri, variant, mainTitle, leftContentTitle, rightContentTitle, leftContent, rightContent }) => {
    const classes = useStyles$e();
    return (React.createElement(Container, { maxWidth: "lg" },
        React.createElement("div", { className: classes.content },
            React.createElement(Typography, { gutterBottom: true, variant: "h5", className: classes.typoHeading }, mainTitle),
            React.createElement(Divider, { className: classes.dividerTitle }),
            React.createElement(Grid, { container: true, spacing: 2, className: leftContent !== null || rightContent ? classes.noSideDetails : '' },
                React.createElement(Grid, { item: true, xs: 12, md: 5 },
                    leftContentTitle && React.createElement(Typography, { gutterBottom: true, variant: "h5", className: classes.typoHeading }, leftContentTitle),
                    leftContent),
                React.createElement(Grid, { item: true, xs: 12, md: 5 },
                    rightContentTitle && React.createElement(Typography, { gutterBottom: true, variant: "h5", className: classes.typoHeading }, rightContentTitle),
                    rightContent)))));
};

const useStyles$d = makeStyles((theme) => ({
    bold: {
        fontWeight: 700,
    },
    flexCard: {
        display: "flex",
        "@media (max-width: 900px)": {
            flexDirection: 'column',
        },
    },
    main: {
        display: "flex",
        flexWrap: 'wrap',
        justifyContent: 'end',
        "@media (max-width: 900px)": {
            display: "flex",
            flexDirection: 'column !important',
        },
    },
    orientColumn: {
        flexDirection: 'column',
    },
    orientRow: {
        flexDirection: 'row',
    },
    btn2Active: {
        //@ts-ignore
        minWidth: ({ orientation }) => `${orientation == "row" ? "95%" : "100%"}`,
        //@ts-ignore
        color: ({ btnText }) => `${btnText ? btnText : "black"} !important`,
        margin: '10px 0px',
        //@ts-ignore
        backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
        "@media (max-width: 900px)": {
            minWidth: "100%",
            margin: '10px 0px'
        },
        "&:hover": {
            //@ts-ignore
            backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
            opacity: 0.8,
        },
    },
    btn2ActiveClear: {
        background: 'red!important',
        margin: '10px 0px',
        //@ts-ignore
        minWidth: ({ orientation }) => `${orientation == "row" ? "95%" : "100%"}`,
        //@ts-ignore
        color: ({ btnText }) => `${btnText ? btnText : "black"} !important`,
        "@media (max-width: 900px)": {
            minWidth: "100%",
            margin: '10px 0px'
        },
    },
    btn2Inactive: {
        //@ts-ignore
        minWidth: ({ orientation }) => `${orientation == "row" ? "95%" : "100%"}`,
        //@ts-ignore
        color: ({ btnText }) => `${btnText ? btnText : "black"} !important`,
        margin: '10px 0px',
        //@ts-ignore
        backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
        opacity: '0.5',
        "@media (max-width: 900px)": {
            minWidth: "100%",
            margin: '10px 0px'
        },
    },
    content: {
        backgroundColor: theme.palette.background.paper,
    },
    headingHolder: {
        backgroundColor: "#06141f",
        textAlign: "center",
        marginBottom: "0px",
        color: "white",
        margin: "30px auto",
    },
    img: {
        width: "100%",
        height: "fit-content",
    },
    typoheading: {
        textAlign: "center",
        color: "textPrimary",
        fontWeight: 500,
    },
    search: {
        backgroundColor: '#f9f9f9',
        border: 'none',
        borderRadius: '0px',
        padding: '10px',
        color: 'black',
        width: '100%',
        '&:focus': {
            outline: 'none',
            border: 'none',
        }
    },
    searchHolder: {
        //@ts-ignore
        width: ({ orientation }) => `${orientation == "row" ? "25%" : "100%"}`,
        display: 'flex',
        marginBottom: '10px',
        justifyContent: 'end',
        "@media (max-width: 900px)": {
            width: "100%!important",
        },
    },
    filterApplied: {
        paddingBottom: "0.5rem",
    },
    appliedFilterText: {
        display: "inline-block",
        fontSize: "1rem",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    clearFilter: {
        textAlign: "right",
        cursor: "pointer",
        float: "right",
        color: "#ff2424",
    },
    appliedFilter: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "1.15rem",
        margin: "5px",
    },
    marginSpacing: {
        width: "95%!important",
        "@media (max-width: 900px)": {
            width: "100%!important",
        },
    },
    flexHolder: {
        display: 'flex',
        justifyContent: 'end',
    },
    input: {
        margin: "5px 0px",
    },
    btnHolder: {
        display: 'flex',
        justifyContent: 'end',
    },
    inputlabel: {
        //@ts-ignore
        color: ({ labelColor }) => `${labelColor} !important`,
    }
}));
const menuProps$1 = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250,
        },
    },
};
const defaultPriceRanges = [
    { min: 0, max: 100000 },
    { min: 100000, max: 200000 },
    { min: 200000, max: 300000 },
    { min: 300000, max: 400000 },
    { min: 400000, max: 500000 },
    { min: 500000, max: 600000 },
    { min: 600000, max: 700000 },
    { min: 700000, max: 800000 },
    { min: 800000, max: 900000 },
    { min: 900000, max: 1000000 },
    { min: 1000000, max: 1100000 },
    { min: 1100000, max: 1200000 }
];
const defaultInstallmentRanges = [
    { min: 1500, max: 2500 },
    { min: 2500, max: 3500 },
    { min: 3500, max: 4500 },
    { min: 4500, max: 6500 },
    { min: 6500, max: 7500 },
    { min: 7500, max: 8500 },
    { min: 8500, max: 9500 },
    { min: 9500, max: 20000 },
];
const UsedVehiclesFilter = ({ base_uri, motorgroupId, pageSize = 20, websiteColors, transmissionHide, modelHide, hideList, instalmentsHide, dealerId, selectedModel, initialModel, updateFilteredVehicles, vehicles = [], orientation = "column", total, isLoading, multiSelect = false }) => {
    const classes = useStyles$d(Object.assign(Object.assign({}, websiteColors), { orientation }));
    const [filterApplied, setFilterApplied] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedMakes, setSelectedMakes] = useState([]);
    const [selectedModels, setSelectedModels] = useState(!initialModel ? [] : [initialModel]);
    const [selectedProvinces, setSelectedProvinces] = useState([]);
    const [selectedPriceRanges, setSelectedPriceRanges] = useState([]);
    const [selectedYears, setSelectedYears] = useState([]);
    const [selectedInstallments, setSelectedInstallments] = useState([]);
    const [selectedTransmissions, setSelectedTransmissions] = useState([]);
    const isOptionSelected = hasSelections(selectedMakes) ||
        hasSelections(selectedModels) ||
        hasSelections(selectedProvinces) ||
        hasSelections(selectedPriceRanges) ||
        hasSelections(selectedYears) ||
        hasSelections(selectedInstallments) ||
        hasSelections(selectedTransmissions);
    const makes = Array.from(new Set(vehicles.map((v) => toTitleCase(v === null || v === void 0 ? void 0 : v.brand))));
    const isSingleMake = makes.length === 1;
    useEffect(() => {
        if (isOptionSelected) {
            filterVehicles();
        }
        const makes = Array.from(new Set(vehicles.map((v) => toTitleCase(v === null || v === void 0 ? void 0 : v.brand))))
            .sort();
        if (isSingleMake) {
            setSelectedMakes(makes);
        }
    }, []);
    useEffect(() => {
        if (total > 0) {
            pageVehicles(vehicles);
        }
    }, [total]);
    useEffect(() => {
        updateAndPageVehicles(vehicles);
    }, [vehicles]);
    useEffect(() => {
        if (!searchTerm.trim()) {
            updateAndPageVehicles(vehicles);
            filterVehicles();
            return;
        }
        else {
            let filtered = vehicles === null || vehicles === void 0 ? void 0 : vehicles.filter(v => { var _a, _b, _c, _d, _e, _f; return (((_b = (_a = v.model) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase())) || ((_e = (_d = (_c = v.stockNo) === null || _c === void 0 ? void 0 : _c.toString()) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === null || _e === void 0 ? void 0 : _e.includes((_f = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toString()) === null || _f === void 0 ? void 0 : _f.toLowerCase()))); });
            updateAndPageVehicles(filtered.length > 0 ? filtered : vehicles);
        }
    }, [searchTerm]);
    function updateAndPageVehicles(vehicles) {
        const pagedVehicles = pageVehicles(vehicles);
        updateFilteredVehicles(pagedVehicles);
    }
    function getList(makes = undefined, models = undefined, priceRanges = undefined, provinces = undefined, years = undefined, transmissions = undefined, installments = undefined, newUsed = undefined, body = undefined) {
        return vehicles
            .filter((v) => {
            return hasSelections(makes) ? makes === null || makes === void 0 ? void 0 : makes.some(make => { var _a; return ((_a = v === null || v === void 0 ? void 0 : v.brand) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === (make === null || make === void 0 ? void 0 : make.toUpperCase()); }) : v;
        })
            .filter((v) => {
            return hasSelections(models) ? models === null || models === void 0 ? void 0 : models.some(modelRange => { var _a; return ((_a = v === null || v === void 0 ? void 0 : v.modelRange) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === (modelRange === null || modelRange === void 0 ? void 0 : modelRange.toUpperCase()); }) : v;
        })
            .filter((v) => {
            return hasSelections(priceRanges) ? priceRanges === null || priceRanges === void 0 ? void 0 : priceRanges.some(priceRange => (v === null || v === void 0 ? void 0 : v.price) >= (priceRange === null || priceRange === void 0 ? void 0 : priceRange.min) && (v === null || v === void 0 ? void 0 : v.price) < (priceRange === null || priceRange === void 0 ? void 0 : priceRange.max)) : v;
        })
            .filter((v) => {
            return hasSelections(provinces) ? provinces === null || provinces === void 0 ? void 0 : provinces.some(province => { var _a; return ((_a = v === null || v === void 0 ? void 0 : v.province) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === (province === null || province === void 0 ? void 0 : province.toUpperCase()); }) : v;
        })
            .filter((v) => {
            return hasSelections(years) ? years === null || years === void 0 ? void 0 : years.some(year => (v === null || v === void 0 ? void 0 : v.year) === year) : v;
        })
            .filter((v) => {
            return hasSelections(transmissions) ? transmissions === null || transmissions === void 0 ? void 0 : transmissions.some(transmission => { var _a; return ((_a = v === null || v === void 0 ? void 0 : v.transmission) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === (transmission === null || transmission === void 0 ? void 0 : transmission.toUpperCase()); }) : v;
        })
            .filter((v) => {
            return hasSelections(installments)
                ? installments === null || installments === void 0 ? void 0 : installments.some(installment => calculateInstallment(v === null || v === void 0 ? void 0 : v.price) >= (installment === null || installment === void 0 ? void 0 : installment.min) && calculateInstallment(v === null || v === void 0 ? void 0 : v.price) < (installment === null || installment === void 0 ? void 0 : installment.max))
                : v;
        })
            .filter((v) => {
            var _a;
            return newUsed ? ((_a = v === null || v === void 0 ? void 0 : v.newUsed) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === (newUsed === null || newUsed === void 0 ? void 0 : newUsed.toUpperCase()) : v;
        })
            .filter((v) => {
            var _a;
            return body ? ((_a = v === null || v === void 0 ? void 0 : v.bodyType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === (body === null || body === void 0 ? void 0 : body.toUpperCase()) : v;
        });
    }
    function getPriceRanges() {
        try {
            const prices = Array.from(new Set(getList(selectedMakes, selectedModels).map((v) => v.price)));
            return defaultPriceRanges.filter(r => prices.some(p => p >= r.min && p < r.max));
        }
        catch (_a) {
            return defaultPriceRanges;
        }
    }
    function getInstallmentRanges() {
        try {
            const prices = Array.from(new Set(getList(selectedMakes, selectedModels, selectedPriceRanges, undefined, selectedYears, selectedTransmissions).map((v) => v.price)));
            return defaultInstallmentRanges.filter(r => prices.some(p => calculateInstallment(p) >= r.min && calculateInstallment(p) < r.max));
        }
        catch (_a) {
            return defaultInstallmentRanges;
        }
    }
    function filterVehicles() {
        setFilterApplied(true);
        const filteredList = getList(selectedMakes, selectedModels, selectedPriceRanges, undefined, //activeProvince,
        selectedYears, selectedTransmissions, selectedInstallments, undefined, //new|used
        undefined //body
        );
        updateAndPageVehicles(filteredList);
    }
    function clearFilter() {
        setSelectedMakes([]);
        setSelectedModels([]);
        setSelectedPriceRanges([]);
        setSelectedYears([]);
        setSelectedInstallments([]);
        setSelectedTransmissions([]);
        //clear filter values
        setFilterApplied(false);
        //reset vehicles list
        updateAndPageVehicles(vehicles);
    }
    function pageVehicles(tmpVehicles) {
        var numPages = (tmpVehicles === null || tmpVehicles === void 0 ? void 0 : tmpVehicles.length) / pageSize;
        var i = 0;
        var tmpPagesData = [];
        for (i = 0; i < numPages; i++) {
            const index = i * pageSize;
            tmpPagesData.push(tmpVehicles.slice(index, index + pageSize));
        }
        return tmpPagesData;
    }
    function hasSelections(selectionArr) {
        return (selectionArr && selectionArr.length > 0);
    }
    function setSelection(setterFn, selectionArr) {
        let newSelection = [];
        if (multiSelect === false) {
            newSelection = Array.isArray(selectionArr) ? [...selectionArr] : [selectionArr];
        }
        else if (hasSelections(selectionArr)) {
            //@ts-ignore
            newSelection = typeof selectionArr === 'string' ? selectionArr.split(',') : [...selectionArr];
        }
        setterFn(newSelection);
        return newSelection;
    }
    function clearSelection(selectionArr, selectedItem) {
        let i = selectionArr.findIndex(item => item == selectedItem);
        if (i >= 0) {
            selectionArr.splice(i, 1);
        }
        return selectionArr;
    }
    function handleChange(changeName) {
        /*
            NOTE:
            The break keyword is ommitted from each case statement in the switch such that each case
            block is executed successively depending on which dropdown called the function
         */
        let commonComparitor = (propName) => {
            return (v, c) => {
                //@ts-ignore
                return v[propName] == c;
            };
        };
        let rangeComparitor = (isInstallment = false) => {
            return (v, c) => {
                if (isInstallment === true) {
                    return calculateInstallment(v.price) >= c.min && calculateInstallment(v.price) < c.max;
                }
                else {
                    return v.price >= c.min && v.price < c.max;
                }
            };
        };
        switch (changeName) {
            case "make":
                removeInvalidSelections(getList(selectedMakes), setSelectedModels, selectedModels, commonComparitor("model"));
            case "model":
                removeInvalidSelections(getList(selectedMakes, selectedModels), setSelectedPriceRanges, selectedPriceRanges, rangeComparitor());
            case "range":
                removeInvalidSelections(getList(selectedMakes, selectedModels, selectedPriceRanges), setSelectedYears, selectedYears, commonComparitor("year"));
            case "year":
                removeInvalidSelections(getList(selectedMakes, selectedModels, selectedPriceRanges, undefined, selectedYears), setSelectedTransmissions, selectedTransmissions, commonComparitor("transmission"));
            case "transmission":
                removeInvalidSelections(getList(selectedMakes, selectedModels, selectedPriceRanges, undefined, selectedYears, selectedTransmissions), setSelectedInstallments, selectedInstallments, rangeComparitor(true));
                break;
        }
    }
    function removeInvalidSelections(filteredVehicles, setterFn, selectionArr, comparitor) {
        if (hasSelections(selectionArr)) {
            for (let i = 0; i < selectionArr.length; i++) {
                const selectedItem = selectionArr[i];
                //@ts-ignore
                if (!filteredVehicles.some((v) => comparitor(v, selectedItem))) {
                    // Remove this item from the selection
                    selectionArr.splice(i--, 1);
                }
            }
            setSelection(setterFn, selectionArr);
        }
    }
    function toTitleCase(str) {
        return str === null || str === void 0 ? void 0 : str.replace(/\w\S*/g, function (txt) {
            return (txt === null || txt === void 0 ? void 0 : txt.charAt(0).toUpperCase()) + txt.substr(1).toLowerCase();
        });
    }
    function calculateInstallment(price) {
        return parseInt(Math.round(price / 60).toFixed(0));
    }
    function renderTransmissionOption(transmission) {
        switch (transmission === null || transmission === void 0 ? void 0 : transmission.charAt(0)) {
            case "A": return (React.createElement(React.Fragment, null, "Automatic"));
            case "M": return (React.createElement(React.Fragment, null, "Manual"));
            default: return (React.createElement(React.Fragment, null, "Other"));
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid$1, { item: true, xs: 12, spacing: 2, className: `${classes.main} ${orientation == "row" ? classes.orientRow : classes.orientColumn}` },
            React.createElement(Grid$1, { item: true, xs: 12, md: orientation == "row" ? 2 : 12, lg: orientation == "row" ? 2 : 12 },
                React.createElement(FormControl, { fullWidth: true, className: orientation == "row" ? classes.marginSpacing : "" },
                    React.createElement(InputLabel, { id: "makes-label", shrink: !multiSelect, className: classes.inputlabel, style: { padding: "0 15px" } }, selectedMakes.length > 0 ? multiSelect === true ? "" : "Selected Make" : "All Makes"),
                    React.createElement(Select, { labelId: "makes-label", multiple: multiSelect, value: selectedMakes, className: classes.input, onBlur: () => { if (multiSelect === false)
                            handleChange("make"); }, onClose: () => { if (multiSelect === true)
                            handleChange("make"); }, onChange: (e, c) => { var _a; setSelection(setSelectedMakes, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); }, input: React.createElement(OutlinedInput, null), 
                        //@ts-ignore
                        renderValue: (val) => { return multiSelect === true ? `Select Makes (${val.length})` : val; }, MenuProps: menuProps$1, disabled: isSingleMake }, Array.from(new Set(vehicles.map((v) => toTitleCase(v === null || v === void 0 ? void 0 : v.brand))))
                        .sort()
                        .map((option, i) => (React.createElement(MenuItem$2, { key: i, value: option },
                        React.createElement(Checkbox$1, { checked: selectedMakes.filter((v) => v == option).length == 1 ? true : false }),
                        "  ",
                        option))))),
                !hideList &&
                    React.createElement(React.Fragment, null, multiSelect === true && selectedMakes && selectedMakes.length > 0 &&
                        selectedMakes.map((selectedMake, i) => (React.createElement(Grid$1, { className: classes.appliedFilter, key: `make${i}` },
                            React.createElement("span", { className: classes.appliedFilterText }, selectedMake),
                            !isSingleMake && React.createElement("span", { className: classes.clearFilter, title: "Clear Selection", onClick: () => {
                                    clearSelection(selectedMakes, selectedMake);
                                    setSelection(setSelectedMakes, selectedMakes.join());
                                    handleChange("make");
                                } },
                                React.createElement(CloseIcon, null))))))),
            !modelHide &&
                React.createElement(Grid$1, { item: true, xs: 12, md: orientation == "row" ? 2 : 12, lg: orientation == "row" ? 2 : 12 },
                    React.createElement(FormControl, { fullWidth: true, className: orientation == "row" ? classes.marginSpacing : "" },
                        React.createElement(InputLabel, { id: "models-label", shrink: !multiSelect, className: classes.inputlabel, style: { padding: "0 15px" } }, selectedModels.length > 0 ? multiSelect === true ? "" : "Selected Model" : "All Models"),
                        React.createElement(Select, { labelId: "models-label", multiple: multiSelect, className: classes.input, value: selectedModels, onBlur: () => { if (multiSelect === false)
                                handleChange("model"); }, onClose: () => { if (multiSelect === true)
                                handleChange("model"); }, onChange: (e, c) => { var _a; setSelection(setSelectedModels, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); }, input: React.createElement(OutlinedInput, null), 
                            //@ts-ignore
                            renderValue: (val) => { return multiSelect === true ? `Select Models (${val.length})` : val; }, MenuProps: menuProps$1 }, Array.from(new Set(getList(selectedMakes).map((v) => v === null || v === void 0 ? void 0 : v.modelRange)))
                            .sort()
                            .map((option, i) => (React.createElement(MenuItem$2, { style: { whiteSpace: 'pre-wrap', }, key: i, value: option },
                            React.createElement(Checkbox$1, { checked: selectedModels.filter((v) => v == option).length == 1 ? true : false }),
                            "  ",
                            option))))),
                    !hideList &&
                        React.createElement(React.Fragment, null, multiSelect === true && selectedModels && selectedModels.length > 0 &&
                            selectedModels.map((selectedModel, i) => (React.createElement(Grid$1, { className: classes.appliedFilter, key: `model${i}` },
                                React.createElement("span", { className: classes.appliedFilterText }, selectedModel),
                                React.createElement("span", { className: classes.clearFilter, title: "Clear Selection", onClick: () => {
                                        clearSelection(selectedModels, selectedModel);
                                        setSelection(setSelectedModels, selectedModels.join());
                                        handleChange("model");
                                    } },
                                    React.createElement(CloseIcon, null))))))),
            React.createElement(Grid$1, { item: true, xs: 12, md: orientation == "row" ? 2 : 12, lg: orientation == "row" ? 2 : 12 },
                React.createElement(FormControl, { fullWidth: true, className: orientation == "row" ? classes.marginSpacing : "" },
                    React.createElement(InputLabel, { id: "priceRanges-label", shrink: !multiSelect, className: classes.inputlabel, style: { padding: "0 15px" } }, selectedPriceRanges.length > 0 ? multiSelect === true ? "" : "Selected Price Range" : "All Price Ranges"),
                    React.createElement(Select, { labelId: "priceRanges-label", multiple: multiSelect, className: classes.input, value: selectedPriceRanges, onBlur: () => { if (multiSelect === false)
                            handleChange("range"); }, onClose: () => { if (multiSelect === true)
                            handleChange("range"); }, onChange: (e, c) => { var _a; setSelection(setSelectedPriceRanges, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); }, input: React.createElement(OutlinedInput, null), 
                        //@ts-ignore
                        renderValue: (val) => { var _a, _b; return multiSelect === true ? `Select Price Ranges (${val.length})` : `R${(_a = val[0]) === null || _a === void 0 ? void 0 : _a.min} - R${((_b = val[0]) === null || _b === void 0 ? void 0 : _b.max) - 1}`; }, MenuProps: menuProps$1 }, getPriceRanges().map((option, i) => (
                    //@ts-ignore
                    React.createElement(MenuItem$2, { style: { whiteSpace: 'pre-wrap', }, key: i, value: option },
                        React.createElement(Checkbox$1, { checked: selectedPriceRanges.filter((v) => v == option).length == 1 ? true : false }),
                        " ",
                        `R${option === null || option === void 0 ? void 0 : option.min} - R${(option === null || option === void 0 ? void 0 : option.max) - 1}`))))),
                !hideList &&
                    React.createElement(React.Fragment, null, multiSelect === true && selectedPriceRanges && selectedPriceRanges.length > 0 &&
                        selectedPriceRanges.map((selectedPriceRange, i) => (React.createElement(Grid$1, { className: classes.appliedFilter, key: `range${i}` },
                            React.createElement("span", { className: classes.appliedFilterText }, `R${selectedPriceRange === null || selectedPriceRange === void 0 ? void 0 : selectedPriceRange.min} - R${(selectedPriceRange === null || selectedPriceRange === void 0 ? void 0 : selectedPriceRange.max) - 1}`),
                            React.createElement("span", { className: classes.clearFilter, title: "Clear Selection", onClick: () => {
                                    clearSelection(selectedPriceRanges, selectedPriceRange);
                                    setSelection(setSelectedPriceRanges, selectedPriceRanges);
                                    handleChange("range");
                                } },
                                React.createElement(CloseIcon, null))))))),
            React.createElement(Grid$1, { item: true, xs: 12, md: orientation == "row" ? 2 : 12, lg: orientation == "row" ? 2 : 12 },
                React.createElement(FormControl, { fullWidth: true, className: orientation == "row" ? classes.marginSpacing : "" },
                    React.createElement(InputLabel, { id: "years-label", shrink: !multiSelect, className: classes.inputlabel, style: { padding: "0 15px" } }, selectedYears.length > 0 ? multiSelect === true ? "" : "Selected Year" : "All Years"),
                    React.createElement(Select, { labelId: "years-label", multiple: multiSelect, value: selectedYears, className: classes.input, onBlur: () => { if (multiSelect === false)
                            handleChange("year"); }, onClose: () => { if (multiSelect === true)
                            handleChange("year"); }, onChange: (e, c) => { var _a; setSelection(setSelectedYears, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); }, input: React.createElement(OutlinedInput, null), 
                        //@ts-ignore
                        renderValue: (val) => { return multiSelect === true ? `Select Years (${val.length})` : val; }, MenuProps: menuProps$1 }, Array.from(new Set(getList(selectedMakes, selectedModels, selectedPriceRanges).map((v) => v.year)))
                        .sort(function (a, b) {
                        return b - a;
                    })
                        .map((option, i) => (React.createElement(MenuItem$2, { style: { whiteSpace: 'pre-wrap', }, key: i, value: option },
                        React.createElement(Checkbox$1, { checked: selectedYears.filter((v) => v == option).length == 1 ? true : false }),
                        "   ",
                        option))))),
                !hideList &&
                    React.createElement(React.Fragment, null, multiSelect === true && selectedYears && selectedYears.length > 0 &&
                        selectedYears.map((selectedYear, i) => (React.createElement(Grid$1, { className: classes.appliedFilter, key: `year${i}` },
                            React.createElement("span", { className: classes.appliedFilterText }, selectedYear),
                            React.createElement("span", { className: classes.clearFilter, title: "Clear Selection", onClick: () => {
                                    clearSelection(selectedYears, selectedYear);
                                    setSelection(setSelectedYears, selectedYears.join());
                                    handleChange("year");
                                } },
                                React.createElement(CloseIcon, null))))))),
            !transmissionHide &&
                React.createElement(Grid$1, { item: true, xs: 12, md: orientation == "row" ? 2 : 12, lg: orientation == "row" ? 2 : 12 },
                    React.createElement(FormControl, { fullWidth: true, className: orientation == "row" ? classes.marginSpacing : "" },
                        React.createElement(InputLabel, { id: "transmissions-label", shrink: !multiSelect, className: classes.inputlabel, style: { padding: "0 15px" } }, selectedTransmissions.length > 0 ? multiSelect === true ? "" : "Selected Transmission" : "All Transmissions"),
                        React.createElement(Select, { labelId: "transmissions-label", multiple: multiSelect, value: selectedTransmissions, className: classes.input, onBlur: () => { if (multiSelect === false)
                                handleChange("transmission"); }, onClose: () => { if (multiSelect === true)
                                handleChange("transmission"); }, onChange: (e, c) => { var _a; setSelection(setSelectedTransmissions, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); }, input: React.createElement(OutlinedInput, null), 
                            //@ts-ignore
                            renderValue: (val) => { return multiSelect === true ? `Select Transmissions (${val.length})` : val; }, MenuProps: menuProps$1 }, Array.from(new Set(getList(selectedMakes, selectedModels, selectedPriceRanges, selectedProvinces, selectedYears).map((v) => v.transmission)))
                            .sort()
                            .map((option, i) => (React.createElement(MenuItem$2, { style: { whiteSpace: 'pre-wrap', }, key: i, value: option },
                            React.createElement(Checkbox$1, { checked: selectedTransmissions.filter((v) => v == option).length == 1 ? true : false }),
                            renderTransmissionOption(option)))))),
                    !hideList &&
                        React.createElement(React.Fragment, null, multiSelect === true && selectedTransmissions && selectedTransmissions.length > 0 &&
                            selectedTransmissions.map((selectedTransmission, i) => (React.createElement(Grid$1, { className: classes.appliedFilter, key: `trans${i}` },
                                React.createElement("span", { className: classes.appliedFilterText }, renderTransmissionOption(selectedTransmission)),
                                React.createElement("span", { className: classes.clearFilter, title: "Clear Selection", onClick: () => {
                                        clearSelection(selectedTransmissions, selectedTransmission);
                                        setSelection(setSelectedTransmissions, selectedTransmissions.join());
                                        handleChange("transmission");
                                    } },
                                    React.createElement(CloseIcon, null))))))),
            !instalmentsHide &&
                React.createElement(Grid$1, { item: true, xs: 12, md: orientation == "row" ? 2 : 12, lg: orientation == "row" ? 2 : 12 },
                    React.createElement(FormControl, { fullWidth: true, className: orientation == "row" ? classes.marginSpacing : "" },
                        React.createElement(InputLabel, { id: "installment-label", shrink: !multiSelect, className: classes.inputlabel, style: { padding: "0 15px" } }, selectedInstallments.length > 0 ? multiSelect === true ? "" : "Selected Instalment" : "All Instalments"),
                        React.createElement(Select, { labelId: "installment-label", multiple: multiSelect, value: selectedInstallments, className: classes.input, onChange: (e, c) => { var _a; setSelection(setSelectedInstallments, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); }, input: React.createElement(OutlinedInput, null), 
                            //@ts-ignore
                            renderValue: (val) => { var _a, _b; return multiSelect === true ? `Select Instalments (${val.length})` : `R${(_a = val[0]) === null || _a === void 0 ? void 0 : _a.min} - R${((_b = val[0]) === null || _b === void 0 ? void 0 : _b.max) - 1}`; }, MenuProps: menuProps$1 }, getInstallmentRanges().sort().map((option, i) => (
                        //@ts-ignore
                        React.createElement(MenuItem$2, { style: { whiteSpace: 'pre-wrap', }, key: i, value: option },
                            React.createElement(Checkbox$1, { checked: selectedInstallments.filter((v) => v == option).length == 1 ? true : false }),
                            " ",
                            `R${option === null || option === void 0 ? void 0 : option.min} - R${(option === null || option === void 0 ? void 0 : option.max) - 1}`))))),
                    !hideList &&
                        React.createElement(React.Fragment, null, multiSelect === true && selectedInstallments && selectedInstallments.length > 0 &&
                            selectedInstallments.map((selectedInstallment, i) => (React.createElement(Grid$1, { className: classes.appliedFilter, key: `install${i}` },
                                React.createElement("span", { className: classes.appliedFilterText }, `R${selectedInstallment === null || selectedInstallment === void 0 ? void 0 : selectedInstallment.min} - R${(selectedInstallment === null || selectedInstallment === void 0 ? void 0 : selectedInstallment.max) - 1}`),
                                React.createElement("span", { className: classes.clearFilter, title: "Clear Selection", onClick: () => {
                                        clearSelection(selectedInstallments, selectedInstallment);
                                        setSelection(setSelectedInstallments, selectedInstallments);
                                    } },
                                    React.createElement(CloseIcon, null)))))))),
        React.createElement("div", { className: orientation == "row" ? classes.btnHolder : "" },
            React.createElement(Grid$1, { item: true, xs: 12, md: orientation == "row" ? 2 : 12, lg: orientation == "row" ? 2 : 12 },
                React.createElement(Button$1, { className: isOptionSelected ? classes.btn2Active : classes.btn2Inactive, onClick: filterVehicles }, "Apply")),
            filterApplied &&
                React.createElement(Grid$1, { item: true, xs: 12, md: orientation == "row" ? 2 : 12, lg: orientation == "row" ? 2 : 12 },
                    React.createElement(Button$1, { className: classes.btn2ActiveClear, onClick: clearFilter }, "Clear")))));
};

/* eslint-disable @typescript-eslint/no-unused-vars */
const useStyles$c = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    btn: {
        padding: "5px 30px",
        //@ts-ignore
        backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
        color: "white",
        "&:hover": {
            //@ts-ignore
            backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
            opacity: 0.8,
        },
    },
    cardPadding: {
        padding: '0px',
        margin: '15px 0px',
    },
    inputSpacing: {
        marginBottom: '10px !important',
    }
}));
const PersonalDetailsForm$1 = ({ personalDetails, onSubmit, dealerList, websiteColors, paper, paperColor, paperShadowColor, masterDealerid, defaultDealerId, setAtiveDealerId, rightSection, }) => {
    const classes = useStyles$c(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    const isDealerListAvailable = (dealerList === null || dealerList === void 0 ? void 0 : dealerList.length) && dealerList.length > 0;
    const defaultDealer = isDealerListAvailable
        ? dealerList === null || dealerList === void 0 ? void 0 : dealerList.find((d) => {
            return (d === null || d === void 0 ? void 0 : d.dealerId) === defaultDealerId;
        })
        : null;
    const [dealer, setDealer] = useState(defaultDealer);
    const initialFormValues = {
        firstName: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName) || "",
        lastName: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.lastName) || "",
        phone: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.phone) || "",
        email: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.email) || "",
    };
    const phoneRegExp = /^0(6|7|8){1}[0-9]{1}[0-9]{7}$/;
    const validationSchema = Yup.object({
        firstName: Yup.string().required("First name is required"),
        lastName: Yup.string().required("Last name is required"),
        email: Yup.string().email("Enter a valid email").required("Email is required"),
        phone: Yup.string().required("Phone number is required").matches(phoneRegExp, "Phone number is not valid"),
    });
    const submitForm = (values) => {
        onSubmit(values);
    };
    const dealers = dealerList ? dealerList : [];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.holder },
            React.createElement(CardHeader, { className: classes.cardPadding, title: "About you", subheader: "In order to load your car we need to know a bit about you. This process will take under 5mins from start to completion." }),
            React.createElement("div", { className: classes.holderInner },
                React.createElement(Formik, { isInitialValid: false, initialValues: initialFormValues, enableReinitialize: true, validationSchema: validationSchema, onSubmit: (values) => {
                        submitForm(values);
                    } }, (props) => {
                    const { values, touched, errors, isValid, handleBlur, handleChange, setFieldValue } = props;
                    return (React.createElement(Form, null,
                        React.createElement(Grid$1, { item: true, xs: 12, md: 4 }, isDealerListAvailable === true && (React.createElement(TextField$1, { fullWidth: true, label: "Active Dealer", required: true, 
                            // eslint-disable-next-line eqeqeq
                            select: (dealer === null || dealer === void 0 ? void 0 : dealer.dealerId) == masterDealerid ? true : false, value: dealer === null || dealer === void 0 ? void 0 : dealer.name, className: classes.inputSpacing, onChange: (e) => {
                                handleChange(e);
                                const value = e.target.value;
                                //@ts-ignore
                                setAtiveDealerId(value === null || value === void 0 ? void 0 : value.dealerId);
                                setDealer(value);
                            }, onBlur: handleBlur, name: "activeDealer", id: "activeDealer" }, dealers === null || dealers === void 0 ? void 0 : dealers.map((option, i) => (React.createElement(MenuItem, { key: i, value: option }, option.name)))))),
                        React.createElement(Grid$1, { container: true, spacing: 4, direction: "row" },
                            React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement(TextField$1, { id: "firstName", name: "firstName", label: "First Name", variant: "outlined", fullWidth: true, value: values.firstName, helperText: `${touched.firstName ? errors.firstName : ""}`, error: touched.firstName && Boolean(errors.firstName), onBlur: handleBlur, onChange: handleChange, className: classes.inputSpacing }),
                                React.createElement(TextField$1, { id: "lastName", name: "lastName", label: "Last Name", variant: "outlined", fullWidth: true, value: values.lastName, helperText: `${touched.lastName ? errors.lastName : ""}`, error: touched.lastName && Boolean(errors.lastName), onBlur: handleBlur, onChange: handleChange, className: classes.inputSpacing }),
                                React.createElement(TextField$1, { id: "phone", name: "phone", label: "Mobile Number", variant: "outlined", fullWidth: true, value: values.phone, helperText: `${touched.phone ? errors.phone : ""}`, error: touched.phone && Boolean(errors.phone), onBlur: handleBlur, onChange: handleChange, className: classes.inputSpacing }),
                                React.createElement(TextField$1, { id: "email", name: "email", label: "Email Address", variant: "outlined", fullWidth: true, value: values.email, helperText: `${touched.email ? errors.email : ""}`, error: touched.email && Boolean(errors.email), onBlur: handleBlur, onChange: handleChange, className: classes.inputSpacing })),
                            rightSection && (React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 }, rightSection)),
                            React.createElement(Grid$1, { item: true, xs: 12, container: true, justify: "flex-end" },
                                React.createElement(Button$1, { className: classes.btn, variant: "contained", type: "submit" }, "Next")))));
                })))));
};

const useStyles$b = makeStyles((theme) => ({
    btnTxt: {
        color: 'white !important',
        outline: '0 !important'
    },
    thumbsContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        zIndex: 1,
        top: 0
    },
    errorText: {
        fontSize: '0.75rem',
        marginTop: '3px',
        textAlign: 'left',
        fontWeight: 400,
        lineHeight: '1.66',
        letterSpacing: '0.03333em',
        color: '#f44336'
    },
    dropzone: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3rem',
        outline: '0 !important'
    },
    container: {
        position: 'relative',
        minHeight: '185px',
        width: '100%'
    },
    dropzoneMessage: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    deleteButton: {
        backgroundColor: '#d4411e',
        borderRadius: 0,
        position: 'absolute',
        zIndex: 100,
        right: 10,
        top: 10,
        outline: '0 !important'
    }
}));
const ImageUploader = ({ id, title, image, small = false, required = false, disabled = false, error, errorMsg, className, onDropFile, clear }) => {
    const classes = useStyles$b(small);
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [isDragAccept, setDragAccept] = useState(false);
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: (acceptedFiles) => {
            setDragAccept(true);
            setFiles(acceptedFiles.map((file) => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));
            onDropFile(Object.assign(acceptedFiles[0]), id);
        }
    });
    const clearImage = () => {
        clear(id);
        setDragAccept(false);
        setFiles([]);
    };
    const thumbs = files.map((file, index) => (React.createElement(GridListTile, { key: index },
        React.createElement("img", { src: file.preview, style: { width: '100%', height: '100%' }, onLoad: () => setLoading(false), alt: file.name }),
        !disabled &&
            React.createElement(IconButton, { "aria-label": "delete", classes: { label: classes.btnTxt }, onClick: clearImage, color: "primary", className: classes.deleteButton },
                React.createElement(DeleteIcon, null)))));
    useEffect(() => () => {
        files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);
    useEffect(() => {
        if (image) {
            setLoading(true);
            setDragAccept(true);
            let reader = new FileReader();
            if (image.preview && image instanceof File) {
                reader.readAsDataURL(image);
                reader.onload = function (e) {
                    var _a;
                    setFiles([{ preview: (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.result }]);
                };
            }
            else {
                setFiles([{ name: id, preview: ((image === null || image === void 0 ? void 0 : image.image) || (image === null || image === void 0 ? void 0 : image.src) || image) }]);
            }
        }
        else {
            clearImage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [image]);
    return (React.createElement("section", { className: className },
        React.createElement(Typography, { variant: "body2", color: "textSecondary", gutterBottom: true, component: "p" },
            title,
            " ",
            required && ' *'),
        React.createElement("div", { className: classes.container },
            React.createElement("div", Object.assign({ className: classes.dropzone, style: files.length === 0 ? { border: '2px dashed lightgrey' } : {} }, getRootProps()),
                React.createElement("input", Object.assign({}, getInputProps())),
                React.createElement("div", { className: classes.dropzoneMessage }, loading
                    ? React.createElement(CircularProgress$1, null)
                    : files.length === 0 &&
                        React.createElement(React.Fragment, null,
                            React.createElement(CloudUploadOutlinedIcon, { color: 'disabled', fontSize: 'large' }),
                            !small &&
                                React.createElement(Typography, { variant: "body2", className: "mt-2", color: "textSecondary", component: "p" }, "Click or drag image here to upload")))),
            files.length > 0 &&
                React.createElement("div", { className: classes.thumbsContainer, style: { position: isDragAccept ? 'absolute' : 'relative' } },
                    React.createElement(GridList, { cols: 1, style: { width: '100%', minHeight: isDragAccept ? '170px' : 'initial', height: '100%' } }, thumbs))),
        error &&
            React.createElement("p", { className: classes.errorText },
                "A ",
                title,
                " image is required")));
};

const IMAGE_UPLOADER_CONFIG = {
    maxWidth: 1024,
    maxHeight: 1024,
    compressFormat: 'JPEG',
    quality: 100,
    rotation: 0,
    outputType: 'base64'
};
const ImageUploaderInput = ({ title, fieldName, required = false, disabled = false, error, errorMsg, className, onChange }) => (React.createElement(Field, { name: fieldName, id: fieldName, type: "text" }, //@ts-ignore
({ field: { value }, form: { setFieldValue } }) => (React.createElement(ImageUploader, { title: title, disabled: disabled, required: required, className: className, 
    //@ts-ignore
    onDropFile: (file) => {
        let compressFormat = IMAGE_UPLOADER_CONFIG.compressFormat;
        if (file.type === "image/png") {
            compressFormat = 'PNG';
        }
        Resizer.imageFileResizer(file, IMAGE_UPLOADER_CONFIG.maxWidth, IMAGE_UPLOADER_CONFIG.maxHeight, compressFormat, IMAGE_UPLOADER_CONFIG.quality, IMAGE_UPLOADER_CONFIG.rotation, uri => {
            setFieldValue(fieldName, uri);
            if (onChange) {
                onChange(uri);
            }
        }, IMAGE_UPLOADER_CONFIG.outputType);
    }, id: fieldName, image: value, error: error, errorMsg: errorMsg, clear: () => setFieldValue(fieldName, '') }))));

const useStyles$a = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    flexHolder: {
        display: "flex",
        flexWrap: "wrap",
    },
    btn: {
        padding: "5px 30px",
        //@ts-ignore
        backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
        color: "white",
        "&:hover": {
            //@ts-ignore
            backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
            opacity: 0.8,
        },
    },
    cardPadding: {
        padding: '0px',
        margin: '15px 0px',
    },
    legend: {},
    labels: {},
    radioButton: {},
}));
const VehicleSpecsForm$1 = ({ base_uri, wePay4Cars_uri, vehicle, onSubmit, websiteColors, paper, paperColor, paperShadowColor, }) => {
    const classes = useStyles$a(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    const localStyles = useStyles$a();
    const { enqueueSnackbar } = useSnackbar();
    const initialFormValues = {
        licenseDisk: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.licenseDisk) || "",
        make: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.make) || "",
        makeId: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.makeId) || 0,
        model: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) || "",
        modelId: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelId) || 0,
        variant: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.variant) || "",
        variantId: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.variantId) || 0,
        variantCode: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.variantCode) || "",
        variantStartYear: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.variantStartYear) || 0,
        variantEndYear: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.variantEndYear) || 0,
        year: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.year) || "",
        odometer: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.odometer) || "",
        color: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.color) || "",
        vin: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin) || "",
        regNo: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.regNo) || "",
        transmission: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmission) || "",
        fuelType: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.fuelType) || "",
        spareKeys: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.spareKeys) || false,
        serviceBook: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.serviceBook) || false,
        maintenancePlan: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.maintenancePlan) || false,
        warranty: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.warranty) || false,
    };
    const [loading, setLoading] = useState(true);
    const [loadingOptions, setLoadingOptions] = useState(false);
    const [makes, setMakes] = useState([]);
    const [models, setModels] = useState([]);
    const [variants, setVariants] = useState([]);
    const [variantIntroYear, setVariantIntroYear] = useState(initialFormValues.variantStartYear);
    const [variantDiscYear, setVariantDiscYear] = useState(initialFormValues.variantEndYear);
    const validationSchema = Yup.object({
        make: Yup.string().required("Select a vehicle make"),
        model: Yup.string().required("Select a vehicle model"),
        variant: Yup.string().required("Select a model variant"),
        year: Yup.number()
            .min(variantIntroYear, "Model year must be between variant introduction and discontinue years")
            .max(variantDiscYear, "Model year must be between variant introduction and discontinue years")
            .required("Model year is required"),
        odometer: Yup.number().required("Odometer reading is required"),
        regNo: Yup.string().required("Registration number is required"),
        transmission: Yup.string().required("Select a transmission"),
        fuelType: Yup.string().required("Select a fuel type"),
    });
    const getMakes = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        axios
            .get(`${base_uri}/Makes`)
            .then((result) => {
            var _a;
            setLoadingOptions(false);
            setMakes(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.list) || []);
        })
            .catch((error) => {
            setLoadingOptions(false);
            enqueueSnackbar(`Failed to load the makes: ${error}`, { variant: "error" });
        });
    });
    const getModels = useCallback((makeId) => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        axios // @ts-ignore
            .get(`${base_uri}/Models`, {
            params: {
                makeId: makeId,
            }
        })
            .then((result) => {
            var _a;
            setLoadingOptions(false);
            setModels(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.list) || []);
        })
            .catch((error) => {
            setLoadingOptions(false);
            enqueueSnackbar(`Failed to load the models: ${error}`, { variant: "error" });
        });
    }), []);
    const getVariants = useCallback((modelId) => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        axios // @ts-ignore
            .get(`${base_uri}/Variants`, {
            params: {
                modelId: modelId,
            }
        })
            .then((result) => {
            var _a;
            setLoadingOptions(false);
            setVariants(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.list) || []);
        })
            .catch((error) => {
            setLoadingOptions(false);
            enqueueSnackbar(`Failed to load the variants: ${error}`, { variant: "error" });
        });
    }), []);
    useEffect(() => {
        let errors = [];
        let allPromises = [];
        allPromises.push(new Promise((res) => {
            try {
                getMakes();
            }
            catch (error) {
                errors.push(`Failed to load the makes: ${error}`);
            }
            res(true);
        }));
        if ((vehicle === null || vehicle === void 0 ? void 0 : vehicle.makeId) > 0) {
            allPromises.push(new Promise((res) => {
                try {
                    getModels(vehicle.makeId);
                }
                catch (error) {
                    errors.push(`Failed to load the models: ${error}`);
                }
                res(true);
            }));
        }
        if ((vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelId) > 0) {
            allPromises.push(new Promise((res) => {
                try {
                    getVariants(vehicle.modelId);
                }
                catch (error) {
                    errors.push(`Failed to load the variants: ${error}`);
                }
                res(true);
            }));
        }
        Promise.allSettled(allPromises)
            .then(() => {
            setLoading(false);
            if (errors.length > 0) {
                enqueueSnackbar(`Some errors occurred while loading the form data: ${errors.map(e => e)}`, { variant: 'error' });
            }
        }).catch((error) => {
            setLoading(false);
            enqueueSnackbar(`An unexpected error occurred while loading the form data: ${error}`, { variant: 'error' });
        });
    }, [enqueueSnackbar, getMakes, getModels, getVariants, vehicle]);
    const checkLicense = (base64VehicleLicense, values, setFieldValue) => {
        if (!wePay4Cars_uri) {
            return;
        }
        setLoading(true);
        axios
            .post(`${wePay4Cars_uri}/vehicle/contactable`, { base64VehicleLicense })
            .then((response) => {
            var _a, _b, _c, _d;
            if (!(response === null || response === void 0 ? void 0 : response.data)) {
                setLoading(false);
                enqueueSnackbar(`No information retrieved from reading the license disk`, { variant: "warning" });
                return;
            }
            setFieldValue("color", ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.color) || values.color);
            setFieldValue("regNo", ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.registration) || values.regNo);
            setFieldValue("vin", ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.vin) || values.vin);
            axios // @ts-ignore
                .get(`${base_uri}/models`, {
                params: {
                    searchString: (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.model,
                }
            })
                .then((result) => {
                var _a;
                let models = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.list;
                let model = models[0];
                let make = {
                    id: model === null || model === void 0 ? void 0 : model.makeID,
                    name: model === null || model === void 0 ? void 0 : model.make,
                };
                if (!model) {
                    setLoading(false);
                    enqueueSnackbar(`Could not determine the make or model from the license disk`, { variant: "warning" });
                    return;
                }
                setFieldValue("make", model.make);
                setFieldValue("makeId", model.makeID);
                setFieldValue("model", model.title);
                setFieldValue("modelId", model.id);
                setMakes([make]);
                setModels(models);
                getVariants(model.id)
                    .then(() => setLoading(false))
                    .catch(() => setLoading(false));
            })
                .catch((error) => {
                setLoading(false);
                enqueueSnackbar(`Failed to get all the models: ${error}`, { variant: "warning" });
            });
        })
            .catch((error) => {
            setLoading(false);
            enqueueSnackbar(`Failed to read the license disk: ${error}`, { variant: "warning" });
        });
    };
    const handleSelectChange = (e, value, setFieldValue, fieldName, fieldId) => {
        var _a, _b;
        setFieldValue(fieldName, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        setFieldValue(fieldId, (_b = value === null || value === void 0 ? void 0 : value.props) === null || _b === void 0 ? void 0 : _b.id);
    };
    const submitForm = (values) => {
        onSubmit(values);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.holder },
            React.createElement(CardHeader, { className: classes.cardPadding, title: "About your vehicle" }),
            React.createElement("div", { className: classes.holderInner },
                React.createElement(Formik, { isInitialValid: false, initialValues: initialFormValues, enableReinitialize: true, validationSchema: validationSchema, onSubmit: (values) => {
                        submitForm(values);
                    } }, (props) => {
                    const { values, touched, errors, handleBlur, handleChange, setFieldValue } = props;
                    return (React.createElement(Form, null,
                        React.createElement(Grid$1, { container: true, spacing: 4, direction: "row" },
                            React.createElement(Grid$1, { item: true, xs: 12, container: true, justifyContent: "flex-start" },
                                React.createElement(ImageUploaderInput, { title: "South African License Disk", fieldName: "licenseDisk", onChange: (uri) => checkLicense(uri, values, setFieldValue), error: errors.licenseDisk && touched.licenseDisk })),
                            loading
                                &&
                                    React.createElement(Grid$1, { container: true, justifyContent: "center" },
                                        React.createElement(CircularProgress$1, null)),
                            !loading &&
                                React.createElement(React.Fragment, null,
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "make", label: "Make", variant: "outlined", fullWidth: true, select: true, disabled: !(values === null || values === void 0 ? void 0 : values.makeId) && loadingOptions, value: values.make, 
                                            //@ts-ignore
                                            helperText: React.createElement(React.Fragment, null, errors.make && touched.make ? errors.make : ""), error: touched.make && Boolean(errors.make), onBlur: handleBlur, 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "make", "makeId");
                                                // Load the models for the selected make
                                                setTimeout(() => {
                                                    var _a;
                                                    getModels((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id);
                                                }, 100);
                                            } }, makes.map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.name }, option.name))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "model", label: "Model", variant: "outlined", fullWidth: true, select: true, disabled: (!(values === null || values === void 0 ? void 0 : values.modelId) && loadingOptions) || !(values === null || values === void 0 ? void 0 : values.makeId), value: values.model, 
                                            //@ts-ignore
                                            helperText: React.createElement(React.Fragment, null, errors.model && touched.model ? errors.model : ""), error: touched.model && Boolean(errors.model), onBlur: handleBlur, 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "model", "modelId");
                                                // Load the variants for the selected model
                                                setTimeout(() => {
                                                    var _a;
                                                    getVariants((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id);
                                                }, 100);
                                            } }, models.map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.title }, option.title))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "variant", label: "Variant", variant: "outlined", fullWidth: true, select: true, disabled: (!(values === null || values === void 0 ? void 0 : values.variantId) && loadingOptions) || !(values === null || values === void 0 ? void 0 : values.modelId), value: values.variant, 
                                            //@ts-ignore
                                            helperText: React.createElement(React.Fragment, null, errors.variant && touched.variant ? errors.variant : ""), error: touched.variant && Boolean(errors.variant), onBlur: handleBlur, 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "variant", "variantId");
                                                // Set the variant introduction & discontinue years to validate the Year field
                                                let variant = variants.find((v) => { var _a; return v.id == ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id); });
                                                setVariantIntroYear(variant === null || variant === void 0 ? void 0 : variant.introYear);
                                                setVariantDiscYear(variant === null || variant === void 0 ? void 0 : variant.discontinueYear);
                                                // Set the field values to be used in the final form
                                                setFieldValue("variantCode", variant === null || variant === void 0 ? void 0 : variant.mmCode);
                                                setFieldValue("variantStartYear", variant === null || variant === void 0 ? void 0 : variant.introYear);
                                                setFieldValue("variantEndYear", variant === null || variant === void 0 ? void 0 : variant.discontinueYear);
                                            } }, variants.map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.variantName }, option.variantName))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "year", label: "Year", variant: "outlined", type: "number", fullWidth: true, disabled: (!(values === null || values === void 0 ? void 0 : values.year) && loadingOptions) || !(values === null || values === void 0 ? void 0 : values.variantId), value: values.year, 
                                            //@ts-ignore
                                            helperText: React.createElement(React.Fragment, null, errors.year && touched.year ? errors.year : ""), error: touched.year && Boolean(errors.year), onBlur: handleBlur, onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "odometer", name: "odometer", label: "Odometer Reading", variant: "outlined", type: "number", fullWidth: true, value: values.odometer, 
                                            //@ts-ignore
                                            helperText: React.createElement(React.Fragment, null, touched.odometer ? errors.odometer : ""), error: touched.odometer && Boolean(errors.odometer), onBlur: handleBlur, onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "color", name: "color", label: "Color (Optional)", variant: "outlined", fullWidth: true, value: values.color, 
                                            //@ts-ignore
                                            helperText: React.createElement(React.Fragment, null, touched.color ? errors.color : ""), error: touched.color && Boolean(errors.color), onBlur: handleBlur, onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "vin", name: "vin", label: "VIN Number", variant: "outlined", fullWidth: true, value: values.vin, 
                                            //@ts-ignore
                                            helperText: React.createElement(React.Fragment, null, touched.vin ? errors.vin : ""), error: touched.vin && Boolean(errors.vin), onBlur: handleBlur, onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "regNo", name: "regNo", label: "Registration Number", variant: "outlined", fullWidth: true, value: values.regNo, 
                                            //@ts-ignore
                                            helperText: React.createElement(React.Fragment, null, touched.regNo ? errors.regNo : ""), error: touched.regNo && Boolean(errors.regNo), onBlur: handleBlur, onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "transmission", label: "Transmission", variant: "outlined", fullWidth: true, select: true, value: values.transmission, 
                                            //@ts-ignore
                                            helperText: React.createElement(React.Fragment, null, errors.transmission && touched.transmission ? errors.transmission : ""), error: touched.transmission && Boolean(errors.transmission), onBlur: handleBlur, 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "transmission", "transmissionId");
                                            } }, ["Automatic", "Manual"].map((option, index) => (React.createElement(MenuItem$2, { key: index, id: index, value: option }, option))))),
                                    React.createElement(Container$1, { item: true, xs: 12, sm: 6, md: 4, className: localStyles.flexHolder },
                                        React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                            React.createElement(FormControl, { component: "fieldset" },
                                                React.createElement(FormLabel, { component: "legend", className: localStyles.legend }, "Fuel Type *"),
                                                React.createElement(RadioGroup, { "aria-label": "fuelType", name: "fuelType", value: values.fuelType, onChange: handleChange },
                                                    React.createElement(FormControlLabel$1, { value: "Petrol", classes: { label: localStyles.labels }, control: React.createElement(Radio, { classes: { checked: localStyles.radioButton } }), label: "Petrol" }),
                                                    React.createElement(FormControlLabel$1, { value: "Diesel", classes: { label: localStyles.labels }, control: React.createElement(Radio, { classes: { checked: localStyles.radioButton } }), label: "Diesel" }),
                                                    React.createElement(FormControlLabel$1, { value: "Hybrid", classes: { label: localStyles.labels }, control: React.createElement(Radio, { classes: { checked: localStyles.radioButton } }), label: "Hybrid" }),
                                                    React.createElement(FormControlLabel$1, { value: "Electric", classes: { label: localStyles.labels }, control: React.createElement(Radio, { classes: { checked: localStyles.radioButton } }), label: "Electric" })),
                                                errors.fuelType && (React.createElement(FormHelperText, { className: "mt-0 mb-2", error: true }, "Fuel Type is required")))),
                                        React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                            React.createElement(FormControl, { component: "fieldset" },
                                                React.createElement(FormLabel, { component: "legend", className: localStyles.legend }, "Miscellaneous"),
                                                React.createElement(FormControlLabel$1, { label: "Spare Keys", control: React.createElement(Checkbox$1, { id: "spareKeys", value: values.spareKeys, defaultChecked: values.spareKeys, onBlur: handleBlur, onChange: handleChange }) }),
                                                React.createElement(FormControlLabel$1, { label: "Service Book", control: React.createElement(Checkbox$1, { id: "serviceBook", value: values.serviceBook, defaultChecked: values.serviceBook, onBlur: handleBlur, onChange: handleChange }) }),
                                                React.createElement(FormControlLabel$1, { label: "Maintenance Plan", control: React.createElement(Checkbox$1, { id: "maintenancePlan", value: values.maintenancePlan, defaultChecked: values.maintenancePlan, onBlur: handleBlur, onChange: handleChange }) }),
                                                React.createElement(FormControlLabel$1, { label: "Warranty", control: React.createElement(Checkbox$1, { id: "warranty", value: values.warranty, defaultChecked: values.warranty, onBlur: handleBlur, onChange: handleChange }) }))))),
                            React.createElement(Grid$1, { item: true, xs: 12, container: true, justify: "flex-end" },
                                React.createElement(Button$1, { className: classes.btn, variant: "contained", type: "submit" }, "Next")))));
                })))));
};

const useStyles$9 = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    btn: {
        padding: '5px 30px',
    },
    cardPadding: {
        padding: '0px',
        margin: '15px 0px',
    }
}));
const VehicleImageForm$1 = ({ images, websiteColors, paper, paperColor, paperShadowColor, onSubmit }) => {
    const classes = useStyles$9(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    const initialFormValues = {
        front: (images === null || images === void 0 ? void 0 : images.front) || '',
        rear: (images === null || images === void 0 ? void 0 : images.rear) || '',
        left: (images === null || images === void 0 ? void 0 : images.left) || '',
        right: (images === null || images === void 0 ? void 0 : images.right) || ''
    };
    const validationSchema = Yup.object({
        front: Yup.string().required("Front image is required"),
        rear: Yup.string().required("Rear image is required"),
        left: Yup.string().required("Left-side image is required"),
        right: Yup.string().required("Right-side image is required")
    });
    const submitForm = (values) => {
        onSubmit(values);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.holder },
            React.createElement(CardHeader, { className: classes.cardPadding, title: 'Submit images / photos of your vehicle' }),
            React.createElement("div", { className: classes.holderInner },
                React.createElement(Formik, { isInitialValid: false, initialValues: initialFormValues, enableReinitialize: true, validationSchema: validationSchema, onSubmit: (values) => {
                        submitForm(values);
                    } }, (props) => {
                    const { values, touched, errors, isValid, handleBlur, handleChange, setFieldValue } = props;
                    return (React.createElement(Form, null,
                        React.createElement(Grid$1, { container: true, spacing: 2, direction: "row" },
                            React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement(ImageUploaderInput, { title: 'Front', fieldName: 'front', error: errors.front && touched.front })),
                            React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement(ImageUploaderInput, { title: 'Rear', fieldName: 'rear', error: errors.rear && touched.rear })),
                            React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement(ImageUploaderInput, { title: 'Left Side', fieldName: 'left', error: errors.left && touched.left })),
                            React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement(ImageUploaderInput, { title: 'Right Side', fieldName: 'right', error: errors.right && touched.right })),
                            React.createElement(Grid$1, { item: true, xs: 12, container: true, justify: "flex-end" },
                                React.createElement(Button$1, { className: classes.btn, variant: 'contained', color: "primary", type: "submit" }, "Next")))));
                })))));
};

const useStyles$8 = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    btn: {
        padding: "5px 30px",
        //@ts-ignore
        backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
        color: "white",
        "&:hover": {
            //@ts-ignore
            backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
            opacity: 0.8,
        },
    },
    img: {
        width: "100%",
        height: "fit-content",
        maxHeight: "185px",
    },
    cardPadding: {
        padding: '0px',
        margin: '15px 0px',
    }
}));
const ConfirmationContainer$1 = ({ base_uri, personalDetails, vehicleSpecs, vehicleImages, onSubmit, dealerId, leadSourceId, websiteColors, paper, paperColor, paperShadowColor, resetForm, setFocus, onSubmitForm }) => {
    const classes = useStyles$8(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const confirmDetails = () => {
        if (!Object.keys(personalDetails).length ||
            !Object.keys(vehicleSpecs).length ||
            !Object.keys(vehicleImages).length) {
            enqueueSnackbar("Some required details are missing", { variant: "warning" });
            return;
        }
        if (onSubmitForm) {
            let formValues = Object.assign(Object.assign(Object.assign({}, personalDetails), vehicleSpecs), vehicleImages);
            onSubmitForm(formValues);
        }
        scroll();
        setLoading(true);
        createLead();
    };
    const resetPersonalDetailsFormValues = () => {
        personalDetails.firstName = "";
        personalDetails.lastName = "";
        personalDetails.phone = "";
        personalDetails.email = "";
    };
    const resetVehicleDetailsFormValues = () => {
        vehicleSpecs.licenseDisk = "";
        vehicleSpecs.make = "";
        vehicleSpecs.makeId = 0;
        vehicleSpecs.model = "";
        vehicleSpecs.modelId = 0;
        vehicleSpecs.variant = "";
        vehicleSpecs.variantId = 0;
        vehicleSpecs.variantCode = "";
        vehicleSpecs.variantStartYear = 0;
        vehicleSpecs.variantEndYear = 0;
        vehicleSpecs.year = "";
        vehicleSpecs.odometer = "";
        vehicleSpecs.color = "";
        vehicleSpecs.vin = "";
        vehicleSpecs.regNo = "";
        vehicleSpecs.transmission = "";
        vehicleSpecs.fuelType = "";
        vehicleSpecs.spareKeys = false;
        vehicleSpecs.serviceBook = false;
        vehicleSpecs.maintenancePlan = false;
        vehicleSpecs.warranty = false;
    };
    const resetVehicleImagesFormValues = () => {
        vehicleImages.front = '';
        vehicleImages.rear = '';
        vehicleImages.left = '';
        vehicleImages.right = '';
    };
    const resetFormValues = () => {
        resetPersonalDetailsFormValues();
        resetVehicleDetailsFormValues();
        resetVehicleImagesFormValues();
    };
    const createLead = () => __awaiter(void 0, void 0, void 0, function* () {
        let params = {
            leadStatusId: 1,
            leadTypeId: 11, //tradein
            dealerId: dealerId,
            name: `${personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName} ${personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.lastName}`,
            firstName: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName,
            lastName: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.lastName,
            phoneNumber: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.phone,
            emailAddress: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.email,
            leadSourceId: leadSourceId,
            TypeCode: "TRADEIN",
            notes: "",
            dateUpdated: new Date().toISOString(),
        };
        // @ts-ignore
        axios.post(`${base_uri}/leads`, params)
            .then((response) => {
            var _a;
            createTradeIn((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.id);
        })
            .catch((error) => {
            setLoading(false);
            enqueueSnackbar("Failed to save the personal details", { variant: "error" });
        });
    });
    const createTradeIn = (leadId) => {
        /*
            Note (2021-11-22): need to find a better way to specify the orientation. This is now hardcoded
            according to the enum in the backend:
    
              public enum VehicleImageOrientation
              {
                  Thumbnail,
                  Front,
                  Rear,
                  LeftSide,
                  RightSide,
                  InteriorCenter,
                  InteriorOdometer,
                  LicenseDisk
              }
        */
        let imageDto = [
            {
                imageOrientation: 1,
                imageUrl: vehicleImages.front,
            },
            {
                imageOrientation: 2,
                imageUrl: vehicleImages.rear,
            },
            {
                imageOrientation: 3,
                imageUrl: vehicleImages.left,
            },
            {
                imageOrientation: 4,
                imageUrl: vehicleImages.right,
            },
        ];
        let params = {
            leadId: leadId,
            makeId: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.makeId,
            modelId: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.modelId,
            variantId: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.variantId,
            year: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.year,
            odometer: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.odometer,
            color: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.color,
            vinNumber: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.vin,
            registration: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.regNo,
            transmission: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.transmission,
            fuelType: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.fuelType,
            hasSpareKeys: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.hasSpareKeys,
            hasServiceBook: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.hasServiceBook,
            hasMaintenancePlan: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.hasMaintenancePlan,
            hasWarranty: vehicleSpecs === null || vehicleSpecs === void 0 ? void 0 : vehicleSpecs.hasWarranty,
            tradeInVehicleImages: imageDto,
        };
        // @ts-ignore
        axios.post(`${base_uri}/TradeInVehicle/FromShared`, params)
            .then((response) => {
            processLead(leadId);
        })
            .catch((error) => {
            setLoading(false);
            enqueueSnackbar("Failed to save the vehicle details", { variant: "error" });
        });
    };
    const scroll = () => {
        if (setFocus && !!setFocus) {
            var element = document.getElementById(setFocus);
            //@ts-ignore
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    };
    const processLead = (leadId) => {
        // @ts-ignore
        axios.post(`${base_uri}/Leads/ProcessLead/${leadId}`, {})
            .then((response) => {
            setLoading(false);
            enqueueSnackbar("Successfully saved and submitted the captured details", { variant: "success" });
            if (resetForm && resetForm == true) {
                resetFormValues();
            }
            setTimeout(() => {
                onSubmit(true);
            }, 500);
        })
            .catch((error) => {
            setLoading(false);
            enqueueSnackbar("Failed to save the vehicle details", { variant: "error" });
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.holder },
            loading && (React.createElement(React.Fragment, null,
                React.createElement(CardHeader, { className: classes.cardPadding, title: "Submitting the captured details" }),
                React.createElement("div", { className: classes.holderInner },
                    React.createElement(Grid$1, { container: true, justifyContent: "center" },
                        React.createElement(CircularProgress$1, null))))),
            !loading && (React.createElement(React.Fragment, null,
                React.createElement(CardHeader, { className: classes.cardPadding, title: "Please confirm your details are correct" }),
                React.createElement("div", { className: classes.holderInner },
                    React.createElement(Grid$1, { container: true, spacing: 4 },
                        React.createElement(Grid$1, { item: true, xs: 12, container: true, spacing: 1, direction: "row" },
                            !Object.keys(personalDetails).length && (React.createElement(Grid$1, { item: true, xs: 12 },
                                React.createElement(Typography$1, { variant: "h6", color: "textSecondary" }, "No personal information available"))),
                            Object.keys(personalDetails).length > 0 && (React.createElement(React.Fragment, null,
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Full Name"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null,
                                            personalDetails.firstName,
                                            " ",
                                            personalDetails.lastName))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Mobile Number"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, personalDetails.phone))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Email Address"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, personalDetails.email)))))),
                        React.createElement(Divider$1, null),
                        React.createElement(Grid$1, { item: true, xs: 12, container: true, spacing: 1 },
                            !Object.keys(vehicleSpecs).length && (React.createElement(Grid$1, { item: true, xs: 12 },
                                React.createElement(Typography$1, { variant: "h6", color: "textSecondary" }, "No vehicle information available"))),
                            Object.keys(vehicleSpecs).length > 0 && (React.createElement(React.Fragment, null,
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Make"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.make))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Model"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.model))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Year"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.year))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Variant"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.variant))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Odometer Reading"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.odometer))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Color"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.color))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "VIN Number"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.vin))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Registration Number"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.regNo))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Transmission"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.transmission))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Fuel Type"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.fuelType))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Spare Keys"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.spareKeys ? "Yes" : "No"))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Service Book"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.serviceBook ? "Yes" : "No"))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Maintenance Plan"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.maintenancePlan ? "Yes" : "No"))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Warranty"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.warranty ? "Yes" : "No")))))),
                        React.createElement(Divider$1, null),
                        React.createElement(Grid$1, { item: true, xs: 12, container: true, spacing: 1 },
                            !Object.keys(vehicleImages).length && (React.createElement(Grid$1, { item: true, xs: 12 },
                                React.createElement(Typography$1, { variant: "h6", color: "textSecondary" }, "No vehicle photos available"))),
                            Object.keys(vehicleImages).length > 0 && (React.createElement(Grid$1, { item: true, xs: 12, container: true, spacing: 2, justifyContent: "space-between", direction: "row" }, Object.keys(vehicleImages).map((key) => (React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement("img", { alt: `Vehicle ${key} image`, src: vehicleImages[key], className: classes.img }))))))),
                        React.createElement(Divider$1, null),
                        React.createElement(Grid$1, { item: true, xs: 12, container: true, justifyContent: "flex-end" },
                            React.createElement(Button$1, { className: classes.btn, variant: "contained", onClick: confirmDetails }, "Confirm")))))))));
};

const useStyles$7 = makeStyles((theme) => ({
    tradeContainer: {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        padding: theme.spacing(4, 0, 10),
    },
    contents: {
        maxWidth: "1280px",
        paddingLeft: "24px",
        paddingRight: "24px",
        color: "white",
    },
    btn: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "2%",
        width: "100%",
        background: "#e30011",
        color: "white",
        fontWeight: "bold",
        fontSize: "20px",
        cursor: "pointer",
        padding: "15px 20px",
    },
    flex: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-around",
        padding: "40px 0px",
    },
    red: {
        color: "#e30011",
        //, color:'#ed0000'
    },
    text: {
        textAlign: "center",
        padding: theme.spacing(2, 25, 6),
        fontSize: "1.0rem",
        display: "block",
        margin: "0 auto",
        color: "white",
        "@media (max-width: 426px)": {
            padding: theme.spacing(2, 5, 6),
        },
    },
    heading: {
        textAlign: "center",
        padding: theme.spacing(2, 0, 0),
        fontSize: "2.8rem",
    },
    primary: {
        //@ts-ignore
        background: ({ primaryColor }) => `${primaryColor} !important`,
    },
}));
const SellYourVehicle = ({ base_uri, wePay4Cars_uri, dealerId, masterDealerid, leadSourceId, websiteColors, dealerList, paper, paperColor, paperShadowColor, personalDetailsRightSection, resetForm, setFocus, onSubmitForm, }) => {
    const classes = useStyles$7(Object.assign({}, websiteColors));
    const [tabIndex, setTabIndex] = useState(0);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [personalDetailsFormData, setPersonalDetailsFormData] = useState({});
    const [vehicleSpecsFormData, setVehicleDetailsFormData] = useState({});
    const [vehicleImageFormData, setVehicleImageFormData] = useState({});
    const [activeDealerId, setActiveDealerId] = useState(dealerId);
    const submitPersonalDetails = (personalDetails) => {
        setPersonalDetailsFormData(personalDetails);
        setTabIndex(tabIndex + 1);
        scroll();
    };
    const submitVehicleSpecs = (vehicleSpecs) => {
        setVehicleDetailsFormData(vehicleSpecs);
        setTabIndex(tabIndex + 1);
        scroll();
    };
    const submitVehicleImages = (vehicleImages) => {
        setVehicleImageFormData(vehicleImages);
        setTabIndex(tabIndex + 1);
        scroll();
    };
    const submitForms = () => {
        if (resetForm && resetForm == true) {
            setTabIndex(0);
        }
        else {
            setIsSubmitted(true);
        }
        scroll();
    };
    const scroll = () => {
        if (setFocus && !!setFocus) {
            setTimeout(() => {
                var element = document.getElementById(setFocus);
                //@ts-ignore
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            }, 500);
        }
    };
    const handleTabChange = (event, newTab) => {
        if (newTab != tabIndex) {
            setTabIndex(newTab);
        }
    };
    const tabs = [
        {
            id: 0,
            label: "About you",
            comp: (React.createElement(PersonalDetailsForm$1, { personalDetails: personalDetailsFormData, onSubmit: submitPersonalDetails, websiteColors: websiteColors, masterDealerid: masterDealerid, paper: paper, paperColor: paperColor, paperShadowColor: paperShadowColor, defaultDealerId: dealerId, rightSection: personalDetailsRightSection, setAtiveDealerId: setActiveDealerId, dealerList: dealerList })),
        },
        {
            id: 1,
            label: "Vehicle Specs",
            comp: (React.createElement(VehicleSpecsForm$1, { vehicle: vehicleSpecsFormData, onSubmit: submitVehicleSpecs, paper: paper, paperColor: paperColor, paperShadowColor: paperShadowColor, base_uri: base_uri, wePay4Cars_uri: wePay4Cars_uri, websiteColors: websiteColors })),
        },
        {
            id: 2,
            label: "Photos",
            comp: (React.createElement(VehicleImageForm$1, { images: vehicleImageFormData, paper: paper, paperColor: paperColor, paperShadowColor: paperShadowColor, websiteColors: websiteColors, onSubmit: submitVehicleImages }))
        },
        {
            id: 3,
            label: "Vehicle Summary",
            comp: (React.createElement(ConfirmationContainer$1, { onSubmit: submitForms, base_uri: base_uri, dealerId: activeDealerId ? activeDealerId : dealerId, leadSourceId: leadSourceId, paper: paper, paperColor: paperColor, paperShadowColor: paperShadowColor, personalDetails: personalDetailsFormData, vehicleSpecs: vehicleSpecsFormData, vehicleImages: vehicleImageFormData, websiteColors: websiteColors, resetForm: resetForm, setFocus: setFocus, onSubmitForm: onSubmitForm })),
        },
    ];
    return (React.createElement(Container$1, { maxWidth: "lg", className: classes.tradeContainer },
        React.createElement(Grid$1, { container: true, spacing: 0 },
            React.createElement(Grid$1, { item: true, xs: 12 },
                React.createElement("div", { className: "mb-4" },
                    React.createElement(Tabs, { variant: "scrollable", scrollButtons: "on", value: tabIndex, classes: { indicator: classes.primary } }, tabs.map((step, index) => (React.createElement(Tab, { key: step.id, label: `Step ${index + 1} - ${step.label}`, onClick: (e) => handleTabChange(e, index) })))))),
            isSubmitted && (React.createElement(Grid$1, { item: true, xs: 12, container: true, justifyContent: "center" },
                React.createElement(Typography$1, { variant: "h6", color: "textSecondary" }, "Information successfully captured and submitted"))),
            !isSubmitted && (React.createElement(Grid$1, { item: true, xs: 12 }, tabs.map((step, index) => (React.createElement(React.Fragment, { key: step.id }, tabIndex === index ? step.comp : null))))))));
};

util$1.inherits;

var isBuffer = function isBuffer(arg) {
  return arg instanceof Buffer;
};

var inherits = util$1.inherits;

var util = createCommonjsModule(function (module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(commonjsGlobal.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var length = output.reduce(function(prev, cur) {
    if (cur.indexOf('\n') >= 0) ;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = inherits;

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
});
util.format;
util.deprecate;
util.debuglog;
util.inspect;
util.isArray;
util.isBoolean;
util.isNull;
var util_8 = util.isNullOrUndefined;
util.isNumber;
util.isString;
util.isSymbol;
util.isUndefined;
util.isRegExp;
util.isObject;
util.isDate;
util.isError;
util.isFunction;
util.isPrimitive;
util.isBuffer;
util.log;
util.inherits;
util._extend;

({
    inputRef: propTypes.func.isRequired,
});
const CurrencyMask = {
    prefix: 'R ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ' ',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 7, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: true,
};
const CurrencyValue = (props) => {
    var _a;
    const { value = 0, roundVal = false, padding } = props;
    const currencyMask = createNumberMask(Object.assign({}, CurrencyMask));
    try {
        const roundedNumber = (roundVal === true ? value === null || value === void 0 ? void 0 : value.toFixed() : value) || 0;
        const roundedNumberString = roundedNumber.toString();
        const mask = currencyMask(roundedNumberString);
        const filteredMask = mask.filter((val) => val != "[]");
        const convertedCurrency = conformToMask(roundedNumberString, filteredMask, {});
        return (_a = convertedCurrency === null || convertedCurrency === void 0 ? void 0 : convertedCurrency.conformedValue) !== null && _a !== void 0 ? _a : null;
    }
    catch (_b) {
        return value;
    }
};

const useStyle = makeStyles((theme) => ({
    button: {
        padding: "2px",
        minWidth: 0,
        "& .MuiButton-endIcon": {
            padding: 0,
            margin: 0,
        },
    },
    buttonLeft: {
        margin: "0 10px 0 0",
        //@ts-ignore
        color: ({ selectColor }) => `${selectColor ? selectColor : "black"} !important`,
    },
    buttonRight: {
        margin: "0 0 0 10px",
        //@ts-ignore
        color: ({ selectColor }) => `${selectColor ? selectColor : "black"} !important`,
    },
    selected: {
        fontWeight: "bold",
        backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
    rangeLabel: {
        padding: "2px",
        //@ts-ignore
        color: ({ labelColor }) => `${labelColor ? labelColor : "black"} !important`,
        //@ts-ignore
        background: ({ background }) => `${background ? background : "white"} !important`,
        zIndex: 10,
        minWidth: "fit-content",
    },
    rangeInputLeft: {
        minWidth: "100px",
        padding: 0,
        margin: 0,
        fontSize: "0.9rem",
        "& .MuiInputBase-input": {
            padding: 0,
            margin: 0,
            width: "40px",
            textAlign: "left",
            "& input[type=number]": {
                "-moz-appearance": "textfield",
            },
            "& input[type=number]::-webkit-outer-spin-button": {
                "-webkit-appearance": "none",
                margin: 0,
            },
            "& input[type=number]::-webkit-inner-spin-button": {
                "-webkit-appearance": "none",
                margin: 0,
            },
        },
    },
    rangeInputRight: {
        padding: 0,
        margin: 0,
        textAlign: "right",
        fontSize: "0.9rem",
        "& .MuiInputBase-input": {
            padding: 0,
            margin: 0,
            width: "40px",
            textAlign: "right",
            "& input[type=number]": {
                "-moz-appearance": "textfield",
            },
            "& input[type=number]::-webkit-outer-spin-button": {
                "-webkit-appearance": "none",
                margin: 0,
            },
            "& input[type=number]::-webkit-inner-spin-button": {
                "-webkit-appearance": "none",
                margin: 0,
            },
        },
    },
    rangeInputLabel: {
        textTransform: "uppercase",
        whiteSpace: "nowrap"
    },
    slider: {
        //@ts-ignore
        color: ({ selectColor }) => `${selectColor ? selectColor : "blue"} !important`,
    }
}));
const SelectionButton = ({ side, value, websiteColors, options, onChange, rangeName, isCurrencyVal = false }) => {
    const classes = useStyle(Object.assign({}, websiteColors));
    const [val, setVal] = React.useState(value);
    useEffect(() => {
        onChange(val);
    }, [val]);
    const handleChange = (val) => {
        setVal(val);
        handleClose();
    };
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button$1, { id: `${rangeName}_${side}_range_button`, className: `${classes.button} ${side === "left" ? classes.buttonLeft : classes.buttonRight}`, "aria-controls": `${rangeName}_${side}_range_menu`, "aria-haspopup": "true", onClick: (e) => handleClick(e), endIcon: Boolean(anchorEl) == true ? (React.createElement(ArrowDropUp, { fontSize: "small" })) : (React.createElement(ArrowDropDown, { fontSize: "small" })) }, isCurrencyVal === true
            ? React.createElement("span", { className: classes.rangeInputLabel },
                React.createElement(CurrencyValue, { value: value }))
            : value),
        React.createElement(Menu, { id: `${rangeName}_${side}_range_menu`, anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, options.map((o) => (React.createElement(MenuItem$2, { key: `range_selection_option_${rangeName}_${o}`, className: o === value ? classes.selected : undefined, dense: true, onClick: () => handleChange(o) }, isCurrencyVal === true
            ? React.createElement("span", { className: classes.rangeInputLabel },
                React.createElement(CurrencyValue, { value: o }))
            : o))))));
};
const RangeSlider = ({ id, range, onChange, label, websiteColors, reset = false, isCurrencyVal = false }) => {
    const classes = useStyle(Object.assign({}, websiteColors));
    const getRange = (cfg) => {
        let rangeArr = [];
        let { start, end, interval } = cfg;
        let step = start < end ? interval : -1;
        if (step > 0) {
            for (let i = start; i <= end; i += step) {
                rangeArr.push(Math.round(i / interval) * interval);
            }
        }
        else {
            for (let i = start; i >= end; i += step) {
                rangeArr.push(Math.round(i / interval) * interval);
            }
        }
        return rangeArr;
    };
    const options = useMemo(() => getRange(Object.assign({}, range)), [range]);
    const [selectedTempRange, setSelectedTempRange] = useState([
        range.start,
        range.end,
    ]);
    const [selectedRange, setSelectedRange] = useState([
        range.start,
        range.end,
    ]);
    useEffect(() => {
        onChange(selectedRange);
    }, [selectedRange]);
    useEffect(() => {
        if (reset) {
            setSelectedTempRange([
                range.start,
                range.end,
            ]);
            setSelectedRange([
                range.start,
                range.end,
            ]);
        }
    }, [reset]);
    return options && options.length > 0 ? (React.createElement(Grid$1, { container: true, direction: "column", justifyContent: "center", alignItems: "flex-start", key: `${id}_rangeSelection` },
        React.createElement(Grid$1, { item: true, style: { height: "14px" } },
            React.createElement(Grid$1, { item: true, xs: true, container: true },
                React.createElement(InputLabel, { id: `${id}_rangeSelection`, className: classes.rangeLabel }, label))),
        React.createElement(Grid$1, { item: true, container: true, direction: "row", wrap: "nowrap", justifyContent: "flex-start", alignItems: "center" },
            React.createElement(Grid$1, { item: true, xs: true, container: true, justifyContent: "flex-end", className: classes.rangeInputLeft },
                React.createElement(SelectionButton, { side: "left", rangeName: "years", options: options, websiteColors: websiteColors, value: selectedTempRange[0], isCurrencyVal: isCurrencyVal, onChange: (val) => {
                        if (selectedRange[0] !== val) {
                            setSelectedTempRange([val, selectedRange[1]]);
                            setSelectedRange([val, selectedRange[1]]);
                        }
                    } })),
            React.createElement(Grid$1, { item: true, xs: 12 },
                React.createElement(Slider, { value: selectedTempRange, onChange: (evt, val) => setSelectedTempRange(val), onChangeCommitted: (evt, val) => {
                        if (val[0] !== selectedRange[0] || val[1] !== selectedRange[1])
                            setSelectedRange(val);
                    }, valueLabelDisplay: "off", "aria-labelledby": "range-slider", className: classes.slider, step: range.interval, marks: true, min: options[0], max: options[options.length - 1] })),
            React.createElement(Grid$1, { item: true, xs: true, container: true, justifyContent: "flex-start" },
                React.createElement(SelectionButton, { side: "right", rangeName: "years", options: options, websiteColors: websiteColors, value: selectedTempRange[1], isCurrencyVal: isCurrencyVal, onChange: (val) => {
                        if (selectedRange[1] !== val) {
                            setSelectedTempRange([selectedRange[0], val]);
                            setSelectedRange([selectedRange[0], val]);
                        }
                    } }))))) : (React.createElement(React.Fragment, null));
};

const useStyles$6 = makeStyles((theme) => ({
    bold: {
        fontWeight: 700,
    },
    flexCard: {
        display: "flex",
        "@media (max-width: 900px)": {
            flexDirection: "column",
        },
    },
    main: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "end",
        "@media (max-width: 900px)": {
            display: "flex",
            flexDirection: "column !important",
        },
    },
    orientColumn: {
        flexDirection: "column",
    },
    orientRow: {
        flexDirection: "row",
    },
    btn2Active: {
        //@ts-ignore
        // minWidth: ({ orientation }) => `${orientation === "row" ? "95%" : "100%"}`,
        width: "100%",
        // margin: "10px 0px",
        //@ts-ignore
        color: ({ btnText }) => `${btnText ? btnText : "black"} !important`,
        //@ts-ignore
        backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
        "@media (max-width: 900px)": {
        // minWidth: "100%",
        // margin: "10px 0px",
        },
        "&:hover": {
            //@ts-ignore
            backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
            opacity: 0.8,
        },
    },
    btn2ActiveClear: {
        background: "red!important",
        // margin: "10px 0px",
        //@ts-ignore
        // minWidth: ({ orientation }) => `${orientation === "row" ? "95%" : "100%"}`,
        width: "100%",
        "@media (max-width: 900px)": {
        // minWidth: "100%",
        // margin: "10px 0px",
        },
    },
    btn2Inactive: {
        //@ts-ignore
        // minWidth: ({ orientation }) => `${orientation === "row" ? "95%" : "100%"}`,
        width: "100%",
        // margin: "10px 0px",
        //@ts-ignore
        backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
        opacity: "0.5",
        "@media (max-width: 900px)": {
        // minWidth: "100%",
        // margin: "10px 0px",
        },
    },
    content: {
        backgroundColor: theme.palette.background.paper,
    },
    headingHolder: {
        backgroundColor: "#06141f",
        textAlign: "center",
        marginBottom: "0px",
        color: "white",
        margin: "30px auto",
    },
    img: {
        width: "100%",
        height: "fit-content",
    },
    typoheading: {
        textAlign: "center",
        color: "textPrimary",
        fontWeight: 500,
    },
    search: {
        backgroundColor: "#f9f9f9",
        border: "none",
        borderRadius: "0px",
        padding: "10px",
        color: "black",
        width: "100%",
        "&:focus": {
            outline: "none",
            border: "none",
        },
    },
    searchHolder: {
        //@ts-ignore
        width: ({ orientation }) => `${orientation === "row" ? "25%" : "100%"}`,
        display: "flex",
        marginBottom: "10px",
        justifyContent: "end",
        "@media (max-width: 900px)": {
            width: "100%!important",
        },
    },
    filterApplied: {
        paddingBottom: "0.5rem",
    },
    appliedFilterText: {
        display: "inline-block",
        fontSize: "1rem",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    clearFilter: {
        textAlign: "right",
        cursor: "pointer",
        float: "right",
        color: "#ff2424",
    },
    appliedFilter: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "1.15rem",
        margin: "5px",
    },
    marginSpacing: {
        width: "95%!important",
        "@media (max-width: 900px)": {
            width: "100%!important",
        },
    },
    flexHolder: {
        display: "flex",
        justifyContent: "end",
    },
    input: {
        margin: "5px 0px",
        //@ts-ignore
        color: ({ InputColor }) => `${InputColor ? InputColor : "black"} !important`,
    },
    btnHolder: {
        display: "flex",
        justifyContent: "end",
    },
    inputlabel: {
        //@ts-ignore
        color: ({ labelColor }) => `${labelColor ? labelColor : "black"} !important`,
    },
    root: {
        width: "100%",
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    vehicleList: {
        width: "100%",
        backgroundColor: theme.palette.background.paper,
    },
    searchMainContainer: {
        width: "100%",
        height: "fit-Content",
        background: "white",
        fontSize: "14px",
        border: "1px solid rgba(27, 31, 35, 0.2)",
        borderRadius: "4px",
        marginBottom: "12px",
        //@ts-ignore
        border: ({ borderColor }) => ` 1px solid  ${borderColor ? borderColor : "black"}  !important`,
        "&& svg ": {
            //@ts-ignore
            color: ({ checkColor }) => ` ${checkColor ? checkColor : "black"}  !important`,
        }
    },
    searchVehiclesTree: {
        width: "100%",
        height: "fit-Content",
        maxHeight: "30vh",
        overflowY: "auto",
    },
    selectedItemsContainer: {
        height: "fit-content",
        display: "flex",
        justifyContent: "start",
        flexWrap: "wrap",
        listStyle: "none",
        padding: theme.spacing(0.5),
        margin: 0,
        boxShadow: "unset",
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    searchInput: {
        minWidth: "100px",
        width: "100%",
        paddingLeft: "10px",
        border: "none",
        //@ts-ignore
        color: ({ InputColor }) => `${InputColor ? InputColor : "black"} !important`,
        "&:focus": {
            outline: "none",
            border: "none",
        },
    },
    formControl: {
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    selectLabel: {
        padding: "2px",
        //@ts-ignore
        color: ({ labelColor }) => `${labelColor ? labelColor : "black"} !important`,
        //@ts-ignore
        background: ({ background }) => `${background ? background : "white"} !important`,
        zIndex: 10,
        marginLeft: "4px",
        minWidth: "fit-content",
    },
    filterComponent: {},
    toggles: {
        "& .MuiToggleButton-root.Mui-selected": {
            color: "#000000",
            backgroundColor: theme.palette.primary.main,
            BorderColor: theme.palette.primary.main,
        },
    },
    stockNoSearchContainer: {
        width: "100%",
        marginBottom: "12px",
        display: "flex",
        justifyContent: "flex-end",
        "@media (max-width: 500px)": {
            justifyContent: "center",
        },
    },
    stockNoSearchField: {
        padding: "5px 5px 5px 10px",
        border: "1px solid rgba(27, 31, 35, 0.2)",
        borderRadius: "4px",
        //@ts-ignore
        border: ({ borderColor }) => ` 1px solid  ${borderColor ? borderColor : "black"}  !important`,
        //@ts-ignore
        color: ({ InputColor }) => `${InputColor ? InputColor : "black"} !important`,
        "&:focus": {
            outline: "none",
            border: "none",
        },
    },
    toggleBtn: {
        //@ts-ignore
        border: ({ borderColor }) => ` 1px solid  ${borderColor ? borderColor : "black"}  !important`,
        //@ts-ignore
        color: ({ labelColor }) => ` ${labelColor ? labelColor : "black"}  !important`,
    },
    checkBox: {
        "&& svg ": {
            //@ts-ignore
            color: ({ checkColor }) => ` ${checkColor ? checkColor : "black"}  !important`,
        }
    }
}));
const VehiclesFilterV2 = ({ pageSize = 20, websiteColors, updateFilteredVehicles, vehicles = [], orientation = "row", yearRangeInterval = 1, priceRangeInterval = 50000, instalmentRangeInterval = 1500, }) => {
    const classes = useStyles$6(Object.assign(Object.assign({}, websiteColors), { orientation }));
    const getInstallmentEstimate = (price) => {
        return parseInt(Math.round(price / 60).toFixed(0));
    };
    const [yearRange, setYearRange] = useState();
    const [priceRange, setPriceRange] = useState();
    const [instalmentRange, setInstalmentRange] = useState();
    const [selectedYearRange, setSelectedYearRange] = useState([0, 0]);
    const [selectedPriceRange, setSelectedPriceRange] = useState([0, 0,]);
    const [selectedInstalmentRange, setSelectedInstalmentRange] = useState([0, 0]);
    const setRanges = () => {
        const yearStart = Math.floor(Math.min(...vehicles.filter(v => v.year > 0).map((o) => o.year)) / yearRangeInterval) * yearRangeInterval;
        const yearEnd = Math.ceil(Math.max(...vehicles.map((o) => o.year)) / yearRangeInterval) * yearRangeInterval;
        const year = {
            interval: yearRangeInterval,
            start: isFinite(yearStart) ? yearStart : 0,
            end: isFinite(yearEnd) ? yearEnd : 0,
        };
        setYearRange(year);
        setSelectedYearRange([year.start, year.end]);
        const priceStart = Math.floor(Math.min(...vehicles.map((o) => o.price)) / priceRangeInterval) * priceRangeInterval;
        const priceEnd = Math.ceil(Math.max(...vehicles.map((o) => o.price)) / priceRangeInterval) * priceRangeInterval;
        const price = {
            interval: priceRangeInterval,
            start: isFinite(priceStart) ? priceStart : 0,
            end: isFinite(priceEnd) ? priceEnd : 0,
        };
        setPriceRange(price);
        setSelectedPriceRange([price.start, price.end]);
        const instalStart = Math.floor(Math.min(...vehicles.map((o) => getInstallmentEstimate(o.price))) /
            instalmentRangeInterval) * instalmentRangeInterval;
        const instalEnd = Math.ceil(Math.max(...vehicles.map((o) => getInstallmentEstimate(o.price))) /
            instalmentRangeInterval) * instalmentRangeInterval;
        const instalment = {
            interval: instalmentRangeInterval,
            start: isFinite(instalStart) ? instalStart : 0,
            end: isFinite(instalEnd) ? instalEnd : 0,
        };
        setInstalmentRange(instalment);
        setSelectedInstalmentRange([instalment.start, instalment.end]);
    };
    const transmissionOptions = [...new Set(vehicles.map((o) => { var _a; return (_a = o.transmission) === null || _a === void 0 ? void 0 : _a.toLowerCase(); })),].filter((o) => !!(o === null || o === void 0 ? void 0 : o.trim()));
    const fuelTypeOptions = [...new Set(vehicles.map((o) => { var _a; return (_a = o.fuelType) === null || _a === void 0 ? void 0 : _a.toLowerCase(); })),].filter((o) => !!(o === null || o === void 0 ? void 0 : o.trim()));
    const initialVehicles = useMemo(() => vehicles && vehicles.length > 0
        ? vehicles.map((v) => {
            var _a, _b;
            return (Object.assign(Object.assign({}, v), { brand: (_a = v === null || v === void 0 ? void 0 : v.brand) === null || _a === void 0 ? void 0 : _a.toUpperCase(), model: (_b = v === null || v === void 0 ? void 0 : v.model) === null || _b === void 0 ? void 0 : _b.toUpperCase() }));
        })
        : [], [vehicles]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [selectedTransmission, setSelectedTransmission] = useState([]);
    const [selectedFuelType, setSelectedFuelType] = useState([]);
    const [vehiclesNodes, setVehiclesNodes] = useState([]);
    const [displayList, setDisplayList] = useState([]);
    const [vehicleSearch, setVehicleSearch] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [showVehiclesTree, setShowVehiclesTree] = useState(false);
    const [searchResults, setSearchResults] = useState(initialVehicles);
    useEffect(() => {
        setRanges();
        setDisplayList(vehiclesNodes);
    }, []);
    useEffect(() => {
        if (initialVehicles && initialVehicles.length > 0) {
            updateAndPageVehicles(initialVehicles);
            initialiseVehiclesNodes();
        }
    }, [initialVehicles]);
    const updateAndPageVehicles = (vehiclesList) => {
        const pagedVehicles = pageVehicles(vehiclesList);
        updateFilteredVehicles(pagedVehicles);
    };
    const filterVehicles = () => {
        setFilterApplied(true);
        let searchFilteredList = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0 ? [...searchResults] : [...initialVehicles];
        /*  console.log('filterVehicles:: INIT',
          '\n-searchFilteredList', searchFilteredList.map(o=> getInstallmentEstimate(o.price)),
          '\n-initialVehicles', initialVehicles.map(o=> getInstallmentEstimate(o.price)),
          '\n-vehicles', vehicles.map(o=> getInstallmentEstimate(o.price)),
          '\n-selectedItems', selectedItems,
          '\n-selectedYearRange', selectedYearRange,
          '\n-selectedPriceRange', selectedPriceRange,
          '\n-selectedInstalmentRange', selectedInstalmentRange,
          '\n-selectedTransmission', selectedTransmission,
          '\n-selectedFuelType', selectedFuelType,
        );
     */
        searchFilteredList = [...searchFilteredList]
            .filter((o) => o.price &&
            o.price >= selectedPriceRange[0] &&
            o.price <= selectedPriceRange[1])
            .filter((o) => o.price &&
            getInstallmentEstimate(o.price) >= selectedInstalmentRange[0] &&
            getInstallmentEstimate(o.price) <= selectedInstalmentRange[1])
            .filter((o) => o.year &&
            o.year >= selectedYearRange[0] &&
            o.year <= selectedYearRange[1])
            .filter((o) => selectedTransmission.length > 0
            ? o.transmission &&
                (selectedTransmission === null || selectedTransmission === void 0 ? void 0 : selectedTransmission.includes(o.transmission.toLowerCase()))
            : true)
            .filter((o) => selectedFuelType.length > 0
            ? o.fuelType && (selectedFuelType === null || selectedFuelType === void 0 ? void 0 : selectedFuelType.includes(o.fuelType.toLowerCase()))
            : true);
        updateAndPageVehicles(searchFilteredList);
    };
    const clearFilter = () => {
        setSelectedItems([]);
        initialiseVehiclesNodes();
        setSelectedYearRange([(yearRange === null || yearRange === void 0 ? void 0 : yearRange.start) || 0, (yearRange === null || yearRange === void 0 ? void 0 : yearRange.end) || 0]);
        setSelectedPriceRange([(priceRange === null || priceRange === void 0 ? void 0 : priceRange.start) || 0, (priceRange === null || priceRange === void 0 ? void 0 : priceRange.end) || 0]);
        setSelectedInstalmentRange([
            (instalmentRange === null || instalmentRange === void 0 ? void 0 : instalmentRange.start) || 0,
            (instalmentRange === null || instalmentRange === void 0 ? void 0 : instalmentRange.end) || 0,
        ]);
        setSelectedTransmission([]);
        setSelectedFuelType([]);
        setFilterApplied(false);
        //reset vehicles list
        updateAndPageVehicles(initialVehicles);
        setSearchResults(initialVehicles);
    };
    const pageVehicles = (tmpVehicles) => {
        var numPages = (tmpVehicles === null || tmpVehicles === void 0 ? void 0 : tmpVehicles.length) / pageSize;
        var tmpPagesData = [];
        for (let i = 0; i < numPages; i++) {
            const index = i * pageSize;
            tmpPagesData.push(tmpVehicles.slice(index, index + pageSize));
        }
        return tmpPagesData;
    };
    const toTitleCase = (str) => {
        return str === null || str === void 0 ? void 0 : str.replace(/\w\S*/g, function (txt) {
            return (txt === null || txt === void 0 ? void 0 : txt.charAt(0).toUpperCase()) + txt.substr(1).toLowerCase();
        });
    };
    useEffect(() => {
        let searchFilteredList = [...initialVehicles];
        const selectedItemsKeys = Array.from(new Set(selectedItems.map((itm) => { var _a; return (_a = itm === null || itm === void 0 ? void 0 : itm.id) === null || _a === void 0 ? void 0 : _a.toUpperCase(); })));
        searchFilteredList = searchFilteredList.filter((v) => {
            var _a, _b, _c;
            var modelParts = (_a = v === null || v === void 0 ? void 0 : v.model) === null || _a === void 0 ? void 0 : _a.split(" ");
            var modelShortName = (modelParts === null || modelParts === void 0 ? void 0 : modelParts.length) > 0 ? modelParts[0] : null;
            return ((!util_8(v === null || v === void 0 ? void 0 : v.brand) &&
                (selectedItemsKeys === null || selectedItemsKeys === void 0 ? void 0 : selectedItemsKeys.includes((_b = v === null || v === void 0 ? void 0 : v.brand) === null || _b === void 0 ? void 0 : _b.toUpperCase()))) ||
                (!util_8(modelShortName) &&
                    ((selectedItemsKeys === null || selectedItemsKeys === void 0 ? void 0 : selectedItemsKeys.includes(modelShortName === null || modelShortName === void 0 ? void 0 : modelShortName.toUpperCase())) ||
                        (selectedItemsKeys === null || selectedItemsKeys === void 0 ? void 0 : selectedItemsKeys.includes((_c = v === null || v === void 0 ? void 0 : v.model) === null || _c === void 0 ? void 0 : _c.toLocaleUpperCase())))));
        });
        setSearchResults(searchFilteredList);
    }, [selectedItems]);
    useEffect(() => {
        if (vehicleSearch) {
            getDisplayItems(vehiclesNodes);
        }
        else {
            setDisplayList(vehiclesNodes);
        }
    }, [vehicleSearch, showVehiclesTree]);
    const getDisplayItems = (items) => {
        setSearchLoading(true);
        const searchResults = items.filter((item) => {
            var _a, _b, _c;
            return (((_b = (_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(vehicleSearch === null || vehicleSearch === void 0 ? void 0 : vehicleSearch.toLowerCase())) ||
                ((_c = item === null || item === void 0 ? void 0 : item.children) === null || _c === void 0 ? void 0 : _c.findIndex((itm) => {
                    var _a, _b, _c;
                    return ((_b = (_a = itm === null || itm === void 0 ? void 0 : itm.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(vehicleSearch === null || vehicleSearch === void 0 ? void 0 : vehicleSearch.toLowerCase())) ||
                        ((_c = itm === null || itm === void 0 ? void 0 : itm.stockNos) === null || _c === void 0 ? void 0 : _c.some(s => s === null || s === void 0 ? void 0 : s.toLowerCase().includes(vehicleSearch === null || vehicleSearch === void 0 ? void 0 : vehicleSearch.toLowerCase())));
                })) !== -1);
        });
        setSearchLoading(false);
        setDisplayList(searchResults);
    };
    const initialiseVehiclesNodes = () => {
        let tmpMakes = [];
        const fltMakes = Array.from(new Set(initialVehicles.map((v) => toTitleCase(v === null || v === void 0 ? void 0 : v.brand)))).sort();
        fltMakes.forEach((make) => {
            const makeModels = Array.from(new Set(initialVehicles
                .filter((v) => {
                var _a;
                return ((_a = v === null || v === void 0 ? void 0 : v.brand) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === (make === null || make === void 0 ? void 0 : make.toUpperCase());
            })
                .map((v) => { return { modelName: v === null || v === void 0 ? void 0 : v.model, stockNo: v === null || v === void 0 ? void 0 : v.stockNo }; }))).sort();
            let tmpModelsChildren = [];
            var uniqueModels = [];
            makeModels.forEach((model) => {
                var _a;
                var modelParts = (_a = model === null || model === void 0 ? void 0 : model.modelName) === null || _a === void 0 ? void 0 : _a.split(" ");
                var modelShortName = (modelParts === null || modelParts === void 0 ? void 0 : modelParts.length) > 0 ? modelParts[0] : null;
                if (modelShortName) {
                    if ((uniqueModels === null || uniqueModels === void 0 ? void 0 : uniqueModels.indexOf(modelShortName)) === -1) {
                        uniqueModels === null || uniqueModels === void 0 ? void 0 : uniqueModels.push(modelShortName);
                        var childModel = {
                            id: model === null || model === void 0 ? void 0 : model.modelName,
                            name: model === null || model === void 0 ? void 0 : model.modelName,
                            stockNos: [model === null || model === void 0 ? void 0 : model.stockNo],
                            displayName: `${make} ${model === null || model === void 0 ? void 0 : model.modelName}`,
                            isSelected: false,
                            expanded: false,
                            isChildSelected: false,
                            parentId: make,
                            children: []
                        };
                        tmpModelsChildren.push(childModel);
                    }
                    else {
                        var tempModelsChild = tmpModelsChildren.find(c => c.name.startsWith(modelShortName));
                        tempModelsChild === null || tempModelsChild === void 0 ? void 0 : tempModelsChild.stockNos.push(model === null || model === void 0 ? void 0 : model.stockNo);
                    }
                }
            });
            var tmpMake;
            tmpMake = {
                id: make,
                name: make,
                stockNos: [],
                displayName: make,
                isSelected: false,
                expanded: false,
                parentId: null,
                isChildSelected: false,
                children: tmpModelsChildren,
            };
            tmpMakes.push(tmpMake);
        });
        //@ts-ignore
        setVehiclesNodes(tmpMakes);
    };
    const isSelected = (item) => {
        return selectedItems.indexOf(item) !== -1;
    };
    const onSearchVehicle = (value) => {
        setVehicleSearch(value);
    };
    const handleSelected = (item, e) => {
        e.stopPropagation();
        const selectedListCopy = [...selectedItems];
        var parentHasSelectedChild = false;
        const index = selectedListCopy.indexOf(item);
        if (index === -1) {
            selectedListCopy.push(item);
            //check is selected is parent  then remove all chindren
            if (!util_8(item === null || item === void 0 ? void 0 : item.parentId)) {
                const parentIndex = selectedListCopy.findIndex((v) => {
                    return (v === null || v === void 0 ? void 0 : v.id) === (item === null || item === void 0 ? void 0 : item.parentId);
                });
                if (parentIndex !== -1) {
                    selectedListCopy === null || selectedListCopy === void 0 ? void 0 : selectedListCopy.splice(parentIndex, 1);
                }
            }
        }
        else {
            selectedListCopy === null || selectedListCopy === void 0 ? void 0 : selectedListCopy.splice(index, 1);
        }
        //check if item is child
        if (!util_8(item === null || item === void 0 ? void 0 : item.parentId)) {
            //check if item's parent still has children in selected list
            const index = selectedListCopy.findIndex((itm) => {
                return (!util_8(itm === null || itm === void 0 ? void 0 : itm.parentId) && (itm === null || itm === void 0 ? void 0 : itm.parentId) === (item === null || item === void 0 ? void 0 : item.parentId));
            });
            parentHasSelectedChild = index >= 0 ? true : false;
        }
        else {
            //if parentis selected then clear all child items
            if (!util_8(item === null || item === void 0 ? void 0 : item.children)) {
                const parentChildren = [...item === null || item === void 0 ? void 0 : item.children];
                parentChildren.forEach((parentChild) => {
                    const parentChildIndex = selectedListCopy.indexOf(parentChild);
                    if (parentChildIndex !== -1) {
                        selectedListCopy.splice(parentChildIndex, 1);
                    }
                });
            }
        }
        setSelectedItems(selectedListCopy);
        const vehicleListCopy = [...vehiclesNodes];
        vehicleListCopy.forEach((listItem) => {
            var _a, _b;
            if ((listItem === null || listItem === void 0 ? void 0 : listItem.id) === (item === null || item === void 0 ? void 0 : item.id)) {
                listItem.isSelected = !(item === null || item === void 0 ? void 0 : item.isSelected);
                if (util_8(item.parentId) && (item === null || item === void 0 ? void 0 : item.isChildSelected)) {
                    listItem.isSelected = true;
                    listItem.isChildSelected = false;
                    if (!util_8(listItem === null || listItem === void 0 ? void 0 : listItem.children) &&
                        ((_a = listItem === null || listItem === void 0 ? void 0 : listItem.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        const parentChildren = [...listItem === null || listItem === void 0 ? void 0 : listItem.children];
                        parentChildren.forEach((child) => {
                            child.isSelected = false;
                        });
                    }
                }
            }
            //update parent
            // item is child and curentListItem is parent  and crrent listItem is child's parent and parent does not have child in selectedList then update parent
            if (!util_8(item === null || item === void 0 ? void 0 : item.parentId) &&
                util_8(listItem === null || listItem === void 0 ? void 0 : listItem.parentId) &&
                listItem.id === (item === null || item === void 0 ? void 0 : item.parentId)) {
                if (parentHasSelectedChild) {
                    listItem.isSelected = false;
                }
                listItem.isChildSelected = parentHasSelectedChild ? true : false;
            }
            //ensure child is updated
            if (!util_8(listItem === null || listItem === void 0 ? void 0 : listItem.children) &&
                ((_b = listItem === null || listItem === void 0 ? void 0 : listItem.children) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                const childList = [...listItem === null || listItem === void 0 ? void 0 : listItem.children];
                childList === null || childList === void 0 ? void 0 : childList.forEach((child) => {
                    if ((child === null || child === void 0 ? void 0 : child.id) === (item === null || item === void 0 ? void 0 : item.id)) {
                        child.isSelected = !(item === null || item === void 0 ? void 0 : item.isSelected);
                    }
                });
            }
        });
        setVehiclesNodes(vehicleListCopy);
    };
    const handleExpand = (item, e) => {
        e.stopPropagation();
        const vehicleListCopy = [...vehiclesNodes];
        vehicleListCopy.forEach((listItem) => {
            if ((listItem === null || listItem === void 0 ? void 0 : listItem.id) === (item === null || item === void 0 ? void 0 : item.id)) {
                listItem.expanded = !(item === null || item === void 0 ? void 0 : item.expanded);
            }
        });
        setVehiclesNodes(vehicleListCopy);
    };
    const searchStockNo = (e) => {
        var _a;
        const stockNo = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
        const result = initialVehicles === null || initialVehicles === void 0 ? void 0 : initialVehicles.filter(v => { var _a; return (_a = v.stockNo) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase().includes(stockNo === null || stockNo === void 0 ? void 0 : stockNo.trim().toLowerCase()); });
        if ((stockNo === null || stockNo === void 0 ? void 0 : stockNo.length) > 0) {
            updateAndPageVehicles(result);
        }
        else {
            filterVehicles();
        }
    };
    const renderListItem = (item) => {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(ListItem, { key: item === null || item === void 0 ? void 0 : item.id, role: undefined, dense: true, button: true },
                React.createElement(ListItemIcon, { onClick: (e) => handleSelected(item, e) },
                    React.createElement(Checkbox$1, { indeterminate: (item === null || item === void 0 ? void 0 : item.isChildSelected) ? true : false, edge: "start", className: classes.checkBox, checked: isSelected(item), tabIndex: -1, disableRipple: true, inputProps: { "aria-labelledby": item === null || item === void 0 ? void 0 : item.id } })),
                React.createElement(ListItemText, { id: item === null || item === void 0 ? void 0 : item.id, primary: `${item === null || item === void 0 ? void 0 : item.name}`, onClick: (e) => handleSelected(item, e) }),
                React.createElement(ListItemSecondaryAction, null,
                    React.createElement(IconButton$1, { edge: "end", "aria-label": "comments", onClick: (e) => handleExpand(item, e) }, (item === null || item === void 0 ? void 0 : item.expanded) ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null)))),
            React.createElement(Collapse, { in: item === null || item === void 0 ? void 0 : item.expanded, timeout: "auto", unmountOnExit: true },
                React.createElement(List, { component: "div", disablePadding: true }, (_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.map((child) => {
                    return (React.createElement(ListItem, { button: true, className: classes.nested, onClick: (e) => handleSelected(child, e) },
                        React.createElement(ListItemIcon, null,
                            React.createElement(Checkbox$1, { edge: "start", checked: isSelected(child), tabIndex: -1, disableRipple: true, inputProps: { "aria-labelledby": child === null || child === void 0 ? void 0 : child.id } })),
                        React.createElement(ListItemText, { primary: child === null || child === void 0 ? void 0 : child.name })));
                })))));
    };
    const renderSelectedItems = (item) => {
        return (React.createElement(Grid$1, { item: true },
            React.createElement(Chip, { label: item === null || item === void 0 ? void 0 : item.displayName, onDelete: (e) => handleSelected(item, e), className: classes.chip })));
    };
    return (React.createElement("div", { className: classes.filterComponent },
        React.createElement(ClickAwayListener, { onClickAway: () => setShowVehiclesTree(false) },
            React.createElement("div", { className: classes.searchMainContainer },
                React.createElement(Paper, { className: classes.selectedItemsContainer },
                    React.createElement(Grid$1, { container: true, spacing: 0, direction: "row", wrap: "nowrap", justifyContent: "space-between", alignItems: "center" },
                        React.createElement(Grid$1, { item: true, xs: (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0 ? 3 : 12, md: (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0 ? 1 : 12 },
                            React.createElement(InputBase, { className: classes.searchInput, type: "search", color: "primary", placeholder: (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0 ? "Add More" : "Search Make, Model", name: vehicleSearch, onChange: (e) => { var _a; return onSearchVehicle((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); }, onFocus: (e) => {
                                    setShowVehiclesTree(true);
                                }, onClick: (e) => {
                                    e.stopPropagation();
                                    setShowVehiclesTree(true);
                                } })),
                        (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0 &&
                            React.createElement(Grid$1, { item: true, container: true, wrap: "nowrap", justifyContent: "flex-start", style: { overflow: "hidden" } }, selectedItems.map((item) => renderSelectedItems(item))),
                        React.createElement(Grid$1, { item: true }, !!showVehiclesTree ? (React.createElement(ArrowDropUp, { onClick: (e) => {
                                setShowVehiclesTree((prev) => !prev);
                            } })) : (React.createElement(ArrowDropDown, { onClick: (e) => {
                                setShowVehiclesTree((prev) => !prev);
                            } }))))),
                React.createElement(Collapse, { in: (!searchLoading && (displayList === null || displayList === void 0 ? void 0 : displayList.length) > 0 && showVehiclesTree) ||
                        (!searchLoading &&
                            (displayList === null || displayList === void 0 ? void 0 : displayList.length) === 0 &&
                            vehicleSearch !== "") },
                    React.createElement("hr", { style: { width: "98%" } }),
                    !searchLoading && (displayList === null || displayList === void 0 ? void 0 : displayList.length) > 0 && showVehiclesTree && (React.createElement(Grid$1, { container: true, item: true, className: classes.searchVehiclesTree },
                        React.createElement(List, { className: classes.vehicleList }, displayList.map((node) => {
                            return renderListItem(node);
                        })))),
                    !searchLoading && (displayList === null || displayList === void 0 ? void 0 : displayList.length) === 0 && vehicleSearch && (React.createElement(Grid$1, { container: true, justifyContent: "center" },
                        React.createElement(Typography$1, { variant: "h6", color: "textSecondary" }, "No results found")))),
                searchLoading && !util_8(vehicleSearch) && (React.createElement(Grid$1, { container: true, justifyContent: "center" },
                    React.createElement(CircularProgress$1, null))))),
        React.createElement(Grid$1, { item: true, container: true, direction: orientation, spacing: 3 },
            yearRange && (React.createElement(Grid$1, { item: true, xs: 12, md: orientation === 'row' ? 4 : 12 },
                React.createElement(RangeSlider, { reset: !filterApplied, id: "year_range", label: "Years", websiteColors: websiteColors, range: yearRange, onChange: (val) => {
                        setSelectedYearRange(val);
                    } }))),
            priceRange && (React.createElement(Grid$1, { item: true, xs: 12, md: orientation === 'row' ? 4 : 12 },
                React.createElement(RangeSlider, { isCurrencyVal: true, reset: !filterApplied, id: "price_range", range: priceRange, websiteColors: websiteColors, label: "Price", onChange: (val) => {
                        setSelectedPriceRange(val);
                    } }))),
            instalmentRange && (React.createElement(Grid$1, { item: true, xs: 12, md: orientation === 'row' ? 4 : 12 },
                React.createElement(RangeSlider, { isCurrencyVal: true, reset: !filterApplied, id: "installment_range", label: "Instalment", websiteColors: websiteColors, range: instalmentRange, onChange: (val) => {
                        setSelectedInstalmentRange(val);
                    } })))),
        React.createElement(Grid$1, { container: true, justifyContent: orientation === 'row' ? "space-between" : "center", spacing: 3, direction: orientation },
            React.createElement(Grid$1, { item: true, container: true, direction: "row", xs: 12, md: orientation === 'row' ? 6 : 12, spacing: orientation === 'row' ? 3 : 0, justifyContent: orientation === 'row' ? "flex-start" : "space-between" },
                React.createElement(Grid$1, { item: true },
                    React.createElement(ToggleButtonGroup, { className: classes.toggles, value: selectedTransmission, onChange: (e, val) => {
                            setSelectedTransmission(val);
                        }, size: "small", "aria-label": "Select Transmission" }, transmissionOptions.map((option, i) => (React.createElement(ToggleButton, { value: option, className: classes.toggleBtn, "aria-label": "bold", key: `transmission_type_${i}` }, option))))),
                React.createElement(Grid$1, { item: true },
                    React.createElement(ToggleButtonGroup, { className: classes.toggles, value: selectedFuelType, onChange: (e, val) => setSelectedFuelType(val), size: "small", "aria-label": "Select Transmission" }, fuelTypeOptions.map((option, i) => (React.createElement(ToggleButton, { value: option, className: classes.toggleBtn, "aria-label": "bold", key: `transmission_type_${i}` }, option)))))),
            React.createElement(Grid$1, { item: true, container: true, xs: 12, md: orientation === 'row' ? 6 : 12, direction: orientation === 'row' ? orientation : 'column-reverse', justifyContent: orientation === 'row' ? "flex-end" : "center", alignItems: 'center', spacing: orientation === 'row' ? 1 : 0 },
                React.createElement(Grid$1, { item: true, xs: 12, md: orientation === 'row' ? 3 : 12 },
                    React.createElement(InputBase, { className: classes.stockNoSearchField, id: "stockNo", placeholder: "Search stock no.", type: "search", color: "primary", onBlur: searchStockNo, onChange: searchStockNo })),
                filterApplied &&
                    React.createElement(Grid$1, { item: true, xs: 12, md: orientation === 'row' ? 2 : 12 },
                        React.createElement(Button$1, { className: classes.btn2ActiveClear, style: {
                                marginTop: orientation === 'row' ? 0 : 10
                            }, onClick: () => clearFilter() }, "Reset")),
                React.createElement(Grid$1, { item: true, xs: 12, md: orientation === 'row' ? 2 : 12 },
                    React.createElement(Button$1, { className: classes.btn2Active, onClick: () => filterVehicles() }, "Search"))))));
};

const sumColorComponents = (colorHexString) => {
    let result = 0;
    try {
        const hexString = colorHexString.replace("#", "");
        let redHex = "";
        let greenHex = "";
        let blueHex = "";
        switch (hexString.length) {
            case 8:
            case 6:
                // Long version "#rrggbbaa" or "#rrggbb" 
                redHex = hexString.substring(0, 2);
                greenHex = hexString.substring(2, 4);
                blueHex = hexString.substring(4, 6);
                break;
            case 4:
            case 3:
                // Short version "#rgba" or "#rgb"
                redHex = `${hexString.substring(0, 1)}${hexString.substring(0, 1)}`;
                greenHex = `${hexString.substring(1, 2)}${hexString.substring(1, 2)}`;
                blueHex = `${hexString.substring(2, 3)}${hexString.substring(2, 3)}`;
                break;
            default:
                // Invalid hex string passed, return default
                return result;
        }
        let r = parseInt(redHex, 16) * 0.2126;
        let g = parseInt(greenHex, 16) * 0.7152;
        let b = parseInt(blueHex, 16) * 0.0722;
        return r + g + b;
    }
    catch (_a) {
        return result;
    }
};
const useStyles$5 = makeStyles((theme) => ({
    /***  Credit for converting color: https://css-tricks.com/switch-font-color-for-different-backgrounds-with-css/   ***/
    searchToggleContainer: {
        width: "100%",
        //@ts-ignore
        maxHeight: ({ isOpen }) => isOpen ? "0" : "200px",
        //@ts-ignore
        visibility: ({ isOpen }) => isOpen ? "hidden" : "visible"
    },
    searchToggleButton: {
        width: "100%"
    },
    closeIconContainer: {
        padding: "5px",
        position: "absolute",
        right: 5,
        top: 0
    },
    closeIcon: {
        padding: "5px",
        fontSize: "25px",
        fontWeight: 600,
        cursor: "pointer",
        //@ts-ignore
        color: ({ secondaryColor }) => `${secondaryColor ? secondaryColor : `hsl(0, 0%, calc((calc((${sumColorComponents(theme.palette.secondary.main)}) / 255)) * -10000000%))`} !important`,
        "&:hover": {
            //@ts-ignore
            color: ({ primaryColor }) => `${primaryColor ? primaryColor : theme.palette.primary.main} !important`,
        }
    },
    outerContainer: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        //@ts-ignore
        color: ({ secondaryColor }) => `${secondaryColor ? secondaryColor : `hsl(0, 0%, calc((calc((${sumColorComponents(theme.palette.secondary.main)}) / 255)) * -10000000%))`}`,
        //@ts-ignore
        background: ({ applyThemeBackground, secondaryColor }) => applyThemeBackground === true ? secondaryColor ? secondaryColor : theme.palette.secondary.main : "white",
        //@ts-ignore
        maxHeight: ({ isOpen }) => isOpen ? "1000px" : "0",
        //@ts-ignore
        padding: ({ isOpen }) => isOpen ? "30px 20px" : "0",
        //@ts-ignore
        visibility: ({ isOpen }) => isOpen ? "visible" : "hidden",
        transition: "max-height 0.5s ease-in"
    },
    header: {
        fontSize: "20px",
        fontWeight: 600,
        textAlign: "center",
        textTransform: "capitalize",
        marginBottom: "20px"
    },
    standardTextBold: {
        fontSize: "13px",
        fontWeight: 600
    },
    searchField: {
        width: "100%",
        marginBottom: "15px",
        "& input": {
            background: "white"
        },
        "& $MuiInputBase-root": {
            background: "white"
        }
    },
    searchFieldGrouped: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textTransform: "capitalize",
        "& $searchField": {
            width: "48% !important"
        }
    },
    searchFieldOutlineContainer: {
        padding: "5px",
        height: "fit-Content",
        background: "white",
        fontSize: "14px",
        //@ts-ignore
        color: ({ secondaryColor }) => `${secondaryColor ? secondaryColor : `hsl(0, 0%, calc((calc((${sumColorComponents(theme.palette.secondary.main)}) / 255 - 0.5)) * -100000))`}`,
        border: '1px solid #cecece !important',
        borderRadius: '5px !important',
        "&& svg ": {
            //@ts-ignore
            color: ({ primaryColor }) => `${primaryColor ? primaryColor : theme.palette.primary.main} !important`,
        },
        "&:hover": {
            border: `1px solid black !important`,
            borderRadius: '5px !important',
        }
    },
    searchBarContainer: {
        height: "fit-content",
        display: "flex",
        justifyContent: "start",
        flexWrap: "wrap",
        listStyle: "none",
        margin: 0,
        boxShadow: "unset",
    },
    searchInput: {
        flexGrow: 1,
        minWidth: "100px",
        padding: "0 10px",
        border: "none",
        "&:focus": {
            outline: "none",
        },
    },
    selectedMakeChipContainer: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "flex-start",
        overflow: "hidden"
    },
    selectedMakeChip: {
        margin: "10px"
    },
    dropdownCaretContainer: {
        padding: "5px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center"
    },
    dropdownCaret: {
        transition: "transform 0.5s ease-in !important"
    },
    searchResultsText: {
        fontSize: "18px",
        fontWeight: 600,
        textAlign: "center",
        textTransform: "capitalize",
        margin: "10px 0"
    },
    searchVehiclesTree: {
        width: "100%",
        height: "fit-Content",
        maxHeight: "30vh",
        overflowY: "auto",
    },
    searchResultsVehiclesContainer: {
        width: "100%"
    },
    nodeCheckbox: {
        "&& svg ": {
            //@ts-ignore
            color: ({ primaryColor }) => `${primaryColor ? primaryColor : theme.palette.primary.main} !important`,
        }
    },
    childNode: {
        paddingLeft: "45px"
    },
    buttensContainer: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    resetButton: {
        padding: "10px 15px",
        marginRight: "5px"
    },
    resultsButton: {
        padding: "10px 15px",
        flexGrow: 1
    },
    primaryButton: {
        border: "none",
        //@ts-ignore
        color: ({ primaryColor }) => `hsl(0, 0%, calc((calc((${sumColorComponents(primaryColor ? primaryColor : theme.palette.primary.main)}) / 255) - 0.55) * -10000000%))`,
        //@ts-ignore
        backgroundColor: ({ primaryColor }) => `${primaryColor ? primaryColor : theme.palette.primary.main} !important`,
        // background: theme.palette.primary.main,
        "&:hover": {
            //@ts-ignore
            color: ({ primaryColor }) => `${primaryColor ? primaryColor : theme.palette.primary.main} !important`,
            //@ts-ignore
            background: ({ secondaryColor }) => `${secondaryColor ? secondaryColor : theme.palette.secondary.main} !important`,
            //@ts-ignore
            border: ({ primaryColor }) => `1px solid ${primaryColor ? primaryColor : theme.palette.primary.main}`
        }
    },
    transparentButton: {
        background: "transparent",
        //@ts-ignore
        color: ({ secondaryColor }) => `${secondaryColor ? secondaryColor : `hsl(0, 0%, calc((calc((${sumColorComponents(theme.palette.secondary.main)}) / 255) - 0.55) * -10000000%))`} !important`,
        borderWidth: '1px',
        borderStyle: 'solid',
        //@ts-ignore
        borderColor: ({ secondaryColor }) => `${secondaryColor ? secondaryColor : `hsl(0, 0%, calc((calc((${sumColorComponents(theme.palette.secondary.main)}) / 255) - 0.55) * -10000000%))`}`,
        "&:hover": {
            //@ts-ignore
            color: ({ primaryColor }) => `${primaryColor ? primaryColor : theme.palette.primary.main} !important`,
            //@ts-ignore
            borderColor: ({ primaryColor }) => `${primaryColor ? primaryColor : theme.palette.primary.main} !important`,
        }
    },
    customDropDown: {
        '& .MuiSelect-icon': {
            //@ts-ignore
            color: ({ primaryColor }) => `${primaryColor ? primaryColor : theme.palette.primary.main} !important`,
        },
    },
}));
const menuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250,
            textTransform: "capitalize"
        },
    },
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "left"
    },
    getContentAnchorEl: null
};
function toTitleCase(str) {
    return str === null || str === void 0 ? void 0 : str.replace(/\w\S*/g, function (txt) {
        return (txt === null || txt === void 0 ? void 0 : txt.charAt(0).toUpperCase()) + txt.substr(1).toLowerCase();
    });
}
function removeDuplicates(data, key) {
    return [
        ...new Map(data.map(x => [key(x), x])).values()
    ];
}
function getInstallmentEstimate(price) {
    return parseInt(Math.round(price / 60).toFixed(0));
}
function isValidId(id) {
    if (!id)
        return false;
    return Number(id) > 0;
}
const mileageFormatter = new Intl.NumberFormat('af', {
    style: 'unit',
    //@ts-ignore
    unit: "kilometer",
    minimumFractionDigits: 0
});
const VehiclesFilterV3 = (props) => {
    var _a;
    const { headerLabel = "Find Used Cars For Sale", applyThemeBackground, vehicles, updateFilteredVehicles, websiteColors, } = props;
    const instalmentRangeInterval = 1500;
    const priceRangeInterval = 50000;
    const yearRangeInterval = 1;
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [showVehiclesTree, setShowVehiclesTree] = useState(false);
    const [allVehicleNodes, setAllVehicleNodes] = useState([]);
    const [searchedVehicleNodes, setSearchedVehicleNodes] = useState([]);
    const [priceRanges, setPriceRanges] = useState();
    const [yearRanges, setYearRanges] = useState();
    const [instalmentRanges, setInstalmentRanges] = useState();
    const [transmissions, setTransmissions] = useState([]);
    const [bodyTypes, setBodyTypes] = useState([]);
    const [mileageRanges, setMileageRanges] = useState([]);
    const [fuelTypes, setFuelTypes] = useState([]);
    const [selectedVehicleNodes, setSelectedVehicleNodes] = useState([]);
    const [selectedPriceRange, setSelectedPriceRange] = useState([0, 0]);
    const [selectedYearRange, setSelectedYearRange] = useState([0, 0]);
    const [selectedInstalmentRange, setSelectedInstalmentRange] = useState([0, 0]);
    const [selectedTransmission, setSelectedTransmission] = useState("");
    const [selectedBodyType, setSelectedBodyType] = useState("");
    const [selectedMileageRange, setSelectedMileageRange] = useState("");
    const [selectedFuelType, setSelectedFuelType] = useState("");
    const [makeModelSearchText, setMakeModelSearchText] = useState("");
    const [keywordSearchText, setKeywordSearchText] = useState("");
    const [stockNoSearchText, setStockNoSearchText] = useState("");
    const classes = useStyles$5(Object.assign(Object.assign({}, websiteColors), { isOpen, applyThemeBackground }));
    const useCustomStyles = makeStyles(() => ({
        root: {
            // border: `1px solid #cecece !important`,
            // borderWidth: "1px !important",
            "& $notchedOutline": {
                borderColor: `#cecece !important`,
                borderRadius: '5px !important',
            },
            "&:hover fieldset": {
                borderColor: `#000 !important`,
                borderRadius: '5px !important',
            },
            "&$focused $notchedOutline": {
                borderColor: `${websiteColors ? websiteColors.primaryColor : 'black'} !important`,
                borderRadius: '5px !important',
            },
        },
        focused: {},
        notchedOutline: {}
    }));
    const customClasses = useCustomStyles();
    useEffect(() => {
        if (!((vehicles === null || vehicles === void 0 ? void 0 : vehicles.length) > 0))
            return;
        getVehicleNodes();
        getPriceRangeOptions();
        getYearRangeOptions();
        getInstalmentRangeOptions();
        getTransmissionOptions();
        getBodyTypeOptions();
        getMileageRangeOptions();
        getFuelTypeOptions();
        updateFilteredVehicles([...vehicles]);
    }, [vehicles]);
    useEffect(() => {
        if (!((allVehicleNodes === null || allVehicleNodes === void 0 ? void 0 : allVehicleNodes.length) > 0))
            return;
        const searchResults = allVehicleNodes.filter((item) => {
            var _a, _b, _c;
            return ((_b = (_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(makeModelSearchText === null || makeModelSearchText === void 0 ? void 0 : makeModelSearchText.toLowerCase())) ||
                ((_c = item === null || item === void 0 ? void 0 : item.children) === null || _c === void 0 ? void 0 : _c.findIndex((itm) => {
                    var _a, _b, _c;
                    return ((_b = (_a = itm === null || itm === void 0 ? void 0 : itm.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(makeModelSearchText === null || makeModelSearchText === void 0 ? void 0 : makeModelSearchText.toLowerCase())) ||
                        ((_c = itm === null || itm === void 0 ? void 0 : itm.stockNos) === null || _c === void 0 ? void 0 : _c.some(s => s === null || s === void 0 ? void 0 : s.toLowerCase().includes(makeModelSearchText === null || makeModelSearchText === void 0 ? void 0 : makeModelSearchText.toLowerCase())));
                })) !== -1;
        });
        setSearchedVehicleNodes(searchResults);
    }, [makeModelSearchText]);
    const getVehicleNodes = () => {
        let nodes = [];
        const filteredMakes = Array
            .from(new Set(vehicles.map((v) => toTitleCase(v === null || v === void 0 ? void 0 : v.brand))))
            .sort();
        filteredMakes.forEach((make) => {
            const makeModels = Array
                .from(new Set(vehicles
                .filter((v) => { var _a; return ((_a = v === null || v === void 0 ? void 0 : v.brand) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === (make === null || make === void 0 ? void 0 : make.toUpperCase()); })
                .map((v) => { return { modelName: v === null || v === void 0 ? void 0 : v.model, stockNo: v === null || v === void 0 ? void 0 : v.stockNo }; })))
                .sort();
            let tmpModelsChildren = [];
            let uniqueModels = [];
            makeModels.forEach((model) => {
                var _a;
                let modelParts = (_a = model === null || model === void 0 ? void 0 : model.modelName) === null || _a === void 0 ? void 0 : _a.split(" ");
                let modelShortName = (modelParts === null || modelParts === void 0 ? void 0 : modelParts.length) > 0 ? modelParts[0] : null;
                if (modelShortName) {
                    if ((uniqueModels === null || uniqueModels === void 0 ? void 0 : uniqueModels.indexOf(modelShortName)) === -1) {
                        uniqueModels === null || uniqueModels === void 0 ? void 0 : uniqueModels.push(modelShortName);
                        let childModel = {
                            id: model === null || model === void 0 ? void 0 : model.modelName,
                            name: model === null || model === void 0 ? void 0 : model.modelName,
                            stockNos: [model === null || model === void 0 ? void 0 : model.stockNo],
                            displayName: `${make} ${model === null || model === void 0 ? void 0 : model.modelName}`,
                            isSelected: false,
                            expanded: false,
                            isChildSelected: false,
                            parentId: make,
                            children: []
                        };
                        tmpModelsChildren.push(childModel);
                    }
                    else {
                        let tempModelsChild = tmpModelsChildren.find(c => c.name.startsWith(modelShortName));
                        tempModelsChild === null || tempModelsChild === void 0 ? void 0 : tempModelsChild.stockNos.push(model === null || model === void 0 ? void 0 : model.stockNo);
                    }
                }
            });
            let tmpMake = {
                id: make,
                name: make,
                stockNos: [],
                displayName: make,
                isSelected: false,
                expanded: false,
                parentId: null,
                isChildSelected: false,
                children: tmpModelsChildren,
            };
            nodes.push(tmpMake);
        });
        setAllVehicleNodes(nodes);
        setSearchedVehicleNodes(nodes);
    };
    const getPriceRangeOptions = () => {
        const priceStart = Math.floor(Math.min(...vehicles.map((o) => o.price)) / priceRangeInterval) * priceRangeInterval;
        const priceEnd = Math.ceil(Math.max(...vehicles.map((o) => o.price)) / priceRangeInterval) * priceRangeInterval;
        const price = {
            interval: priceRangeInterval,
            start: isFinite(priceStart) ? priceStart : 0,
            end: isFinite(priceEnd) ? priceEnd : 0,
        };
        setPriceRanges(price);
        setSelectedPriceRange([price.start, price.end]);
    };
    const getYearRangeOptions = () => {
        const yearStart = Math.floor(Math.min(...vehicles.filter(v => v.year > 0).map((o) => o.year)) / yearRangeInterval) * yearRangeInterval;
        const yearEnd = Math.ceil(Math.max(...vehicles.map((o) => o.year)) / yearRangeInterval) * yearRangeInterval;
        const year = {
            interval: yearRangeInterval,
            start: isFinite(yearStart) ? yearStart : 0,
            end: isFinite(yearEnd) ? yearEnd : 0,
        };
        setYearRanges(year);
        setSelectedYearRange([year.start, year.end]);
    };
    const getInstalmentRangeOptions = () => {
        const instalStart = Math.floor(Math.min(...vehicles.map((o) => getInstallmentEstimate(o.price))) /
            instalmentRangeInterval) * instalmentRangeInterval;
        const instalEnd = Math.ceil(Math.max(...vehicles.map((o) => getInstallmentEstimate(o.price))) /
            instalmentRangeInterval) * instalmentRangeInterval;
        const instalment = {
            interval: instalmentRangeInterval,
            start: isFinite(instalStart) ? instalStart : 0,
            end: isFinite(instalEnd) ? instalEnd : 0,
        };
        setInstalmentRanges(instalment);
        setSelectedInstalmentRange([instalment.start, instalment.end]);
    };
    const getTransmissionOptions = () => {
        const allOptions = vehicles.map(v => { var _a, _b; return (_b = (_a = v.transmission) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.toLowerCase(); }).filter(o => o && o.length > 0);
        const sortedOptions = removeDuplicates(allOptions, (o) => o).sort((a, b) => a > b ? 1 : -1);
        setTransmissions(sortedOptions || []);
    };
    const getBodyTypeOptions = () => {
        const allOptions = vehicles.map(v => { var _a, _b; return (_b = (_a = v.bodyType) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.toLowerCase(); }).filter(o => o && o.length > 0);
        const sortedOptions = removeDuplicates(allOptions, (o) => o).sort((a, b) => a > b ? 1 : -1);
        setBodyTypes(sortedOptions || []);
    };
    const getMileageRangeOptions = () => {
        const allRanges = [
            { min: 0, max: 10000 },
            { min: 10000, max: 20000 },
            { min: 20000, max: 30000 },
            { min: 30000, max: 40000 },
            { min: 40000, max: 50000 },
            { min: 50000, max: 60000 },
            { min: 60000, max: 70000 },
            { min: 70000, max: 80000 },
            { min: 80000, max: 90000 },
            { min: 100000, max: 120000 },
            { min: 120000, max: 140000 },
            { min: 140000, max: 160000 },
            { min: 160000, max: 180000 },
            { min: 180000, max: 200000 },
            { min: 200000, max: 250000 },
            { min: 250000, max: 300000 },
            { min: 300000, max: 1000000 }
        ];
        const mileages = vehicles.map((v) => v.mileage ? Number(v.mileage) : 0);
        const filteredRanges = allRanges.filter(r => mileages.some(p => p >= r.min && p < r.max));
        setMileageRanges(filteredRanges || []);
    };
    const getFuelTypeOptions = () => {
        const allOptions = vehicles.map(v => { var _a, _b; return (_b = (_a = v.fuelType) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.toLowerCase(); }).filter(o => o && o.length > 0);
        const sortedOptions = removeDuplicates(allOptions, (o) => o).sort((a, b) => a > b ? 1 : -1);
        setFuelTypes(sortedOptions || []);
    };
    const selectPriceRange = (val) => { setSelectedPriceRange(val); };
    const selectYearRange = (val) => { setSelectedYearRange(val); };
    const selectInstalmentRange = (val) => { setSelectedInstalmentRange(val); };
    const selectTransmission = (e) => { var _a; setSelectedTransmission((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); };
    const selectBodyType = (e) => { var _a; setSelectedBodyType((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); };
    const selectMileageRange = (e) => { var _a; setSelectedMileageRange((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); };
    const selectFuelType = (e) => { var _a; setSelectedFuelType((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); };
    const onChangeMakeModelSearchText = (e) => { var _a; setMakeModelSearchText((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); };
    const onChangeKeywordSearchText = (e) => { var _a; setKeywordSearchText((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); };
    const onChangeStockNoSearchText = (e) => { var _a; setStockNoSearchText((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); };
    const toggleSearcOptions = () => {
        setIsOpen(!isOpen);
    };
    const toggleVehiclesTree = () => {
        setShowVehiclesTree(!showVehiclesTree);
    };
    const handleNodeSelected = (item, e) => {
        e.stopPropagation();
        const selectedListCopy = [...selectedVehicleNodes];
        const index = selectedListCopy.indexOf(item);
        let parentHasSelectedChild = false;
        if (index === -1) {
            selectedListCopy.push(item);
            // Check is selected is parent then remove all chindren
            if (isValidId(item === null || item === void 0 ? void 0 : item.parentId)) {
                const parentIndex = selectedListCopy.findIndex((v) => (v === null || v === void 0 ? void 0 : v.id) === (item === null || item === void 0 ? void 0 : item.parentId));
                if (parentIndex !== -1) {
                    selectedListCopy === null || selectedListCopy === void 0 ? void 0 : selectedListCopy.splice(parentIndex, 1);
                }
            }
        }
        else {
            selectedListCopy === null || selectedListCopy === void 0 ? void 0 : selectedListCopy.splice(index, 1);
        }
        // Check if item is child
        if (isValidId(item === null || item === void 0 ? void 0 : item.parentId)) {
            // Check if item's parent still has children in selected list
            const index = selectedListCopy.findIndex((itm) => itm.parentId === item.parentId);
            parentHasSelectedChild = index >= 0 ? true : false;
        }
        else {
            // If parent is selected then clear all child items
            if ((item === null || item === void 0 ? void 0 : item.children) && item.children.length > 0) {
                const parentChildren = [...item.children];
                parentChildren.forEach((parentChild) => {
                    const parentChildIndex = selectedListCopy.indexOf(parentChild);
                    if (parentChildIndex !== -1) {
                        selectedListCopy.splice(parentChildIndex, 1);
                    }
                });
            }
        }
        setSelectedVehicleNodes(selectedListCopy);
        const vehicleListCopy = [...allVehicleNodes];
        vehicleListCopy.forEach((listItem) => {
            if ((listItem === null || listItem === void 0 ? void 0 : listItem.id) === (item === null || item === void 0 ? void 0 : item.id)) {
                listItem.isSelected = !(item === null || item === void 0 ? void 0 : item.isSelected);
                if (!isValidId(item === null || item === void 0 ? void 0 : item.parentId) && (item === null || item === void 0 ? void 0 : item.isChildSelected)) {
                    listItem.isSelected = true;
                    listItem.isChildSelected = false;
                    if ((listItem === null || listItem === void 0 ? void 0 : listItem.children) && listItem.children.length > 0) {
                        const parentChildren = [...listItem.children];
                        parentChildren.forEach((child) => child.isSelected = false);
                    }
                }
            }
            // Update parent if item is child, current ListItem is not parent and current listItem is child's parent and parent does not have child in selectedList
            if (isValidId(item === null || item === void 0 ? void 0 : item.parentId) && !isValidId(listItem === null || listItem === void 0 ? void 0 : listItem.parentId) && listItem.id === (item === null || item === void 0 ? void 0 : item.parentId)) {
                if (parentHasSelectedChild) {
                    listItem.isSelected = false;
                }
                listItem.isChildSelected = parentHasSelectedChild ? true : false;
            }
            // Ensure child is updated
            if ((listItem === null || listItem === void 0 ? void 0 : listItem.children) && listItem.children.length > 0) {
                const childList = [...listItem === null || listItem === void 0 ? void 0 : listItem.children];
                childList === null || childList === void 0 ? void 0 : childList.forEach((child) => {
                    if ((child === null || child === void 0 ? void 0 : child.id) === (item === null || item === void 0 ? void 0 : item.id)) {
                        child.isSelected = !(item === null || item === void 0 ? void 0 : item.isSelected);
                    }
                });
            }
        });
        setAllVehicleNodes(vehicleListCopy);
    };
    const handleNodeExpand = (item, e) => {
        e.stopPropagation();
        const vehicleListCopy = [...allVehicleNodes];
        vehicleListCopy.forEach((listItem) => {
            if ((listItem === null || listItem === void 0 ? void 0 : listItem.id) === (item === null || item === void 0 ? void 0 : item.id)) {
                listItem.expanded = !(item === null || item === void 0 ? void 0 : item.expanded);
            }
        });
        setAllVehicleNodes(vehicleListCopy);
    };
    const renderVehicleNode = (item) => {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(ListItem, { key: item === null || item === void 0 ? void 0 : item.id, role: undefined, dense: true, button: true },
                React.createElement(ListItemIcon, { onClick: (e) => handleNodeSelected(item, e) },
                    React.createElement(Checkbox$1, { indeterminate: (item === null || item === void 0 ? void 0 : item.isChildSelected) ? true : false, edge: "start", className: classes.nodeCheckbox, checked: selectedVehicleNodes.indexOf(item) !== -1, tabIndex: -1, disableRipple: true, inputProps: { "aria-labelledby": item === null || item === void 0 ? void 0 : item.id } })),
                React.createElement(ListItemText, { id: item === null || item === void 0 ? void 0 : item.id, primary: `${item === null || item === void 0 ? void 0 : item.name}`, onClick: (e) => handleNodeSelected(item, e) }),
                React.createElement(ListItemSecondaryAction, null,
                    React.createElement(IconButton$1, { edge: "end", "aria-label": "comments", onClick: (e) => handleNodeExpand(item, e) }, (item === null || item === void 0 ? void 0 : item.expanded) ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null)))),
            React.createElement(Collapse, { in: item === null || item === void 0 ? void 0 : item.expanded, timeout: "auto", unmountOnExit: true },
                React.createElement(List, { component: "div", disablePadding: true }, (_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.map((child) => (React.createElement(ListItem, { button: true, className: classes.childNode, onClick: (e) => handleNodeSelected(child, e) },
                    React.createElement(ListItemIcon, null,
                        React.createElement(Checkbox$1, { edge: "start", checked: selectedVehicleNodes.indexOf(child) !== -1, tabIndex: -1, disableRipple: true, inputProps: { "aria-labelledby": child === null || child === void 0 ? void 0 : child.id } })),
                    React.createElement(ListItemText, { primary: child === null || child === void 0 ? void 0 : child.name }))))))));
    };
    function reset() {
        let resetNodes = [...allVehicleNodes];
        resetNodes.forEach(node => {
            node.isSelected = false;
            node.isChildSelected = false;
        });
        setAllVehicleNodes(resetNodes);
        setSearchedVehicleNodes(resetNodes);
        setSelectedVehicleNodes([]);
        setSelectedPriceRange([0, 0]);
        setSelectedYearRange([0, 0]);
        setSelectedInstalmentRange([0, 0]);
        setSelectedTransmission("");
        setSelectedBodyType("");
        setSelectedMileageRange("");
        setSelectedFuelType("");
        setMakeModelSearchText("");
        setKeywordSearchText("");
        setStockNoSearchText("");
        setIsFilterApplied(false);
        updateFilteredVehicles([...vehicles]);
    }
    function filter() {
        let filteredVehicles = [...vehicles];
        if (selectedVehicleNodes && selectedVehicleNodes.length > 0) {
            const selectedNodeKeys = Array.from(new Set(selectedVehicleNodes.map(node => node.id.toUpperCase())));
            filteredVehicles = filteredVehicles.filter(v => {
                var _a, _b;
                const modelParts = (_a = v === null || v === void 0 ? void 0 : v.model) === null || _a === void 0 ? void 0 : _a.split(" ");
                const modelShortName = (modelParts === null || modelParts === void 0 ? void 0 : modelParts.length) > 0 ? modelParts[0] : null;
                return ((((_b = v === null || v === void 0 ? void 0 : v.brand) === null || _b === void 0 ? void 0 : _b.length) > 0 && selectedNodeKeys.includes(v.brand.toUpperCase())) ||
                    (modelShortName && modelShortName.length > 0 &&
                        (selectedNodeKeys.includes(modelShortName.toUpperCase()) || selectedNodeKeys.includes(v.model.toUpperCase()))));
            });
        }
        filteredVehicles = filteredVehicles
            .filter((o) => o.price &&
            o.price >= selectedPriceRange[0] &&
            o.price <= selectedPriceRange[1])
            .filter((o) => o.price &&
            getInstallmentEstimate(o.price) >= selectedInstalmentRange[0] &&
            getInstallmentEstimate(o.price) <= selectedInstalmentRange[1])
            .filter((o) => o.year &&
            o.year >= selectedYearRange[0] &&
            o.year <= selectedYearRange[1])
            .filter((o) => selectedTransmission.length > 0
            ? o.transmission && selectedTransmission === o.transmission.trim().toLowerCase()
            : true)
            .filter((o) => selectedFuelType.length > 0
            ? o.fuelType && selectedFuelType === o.fuelType.trim().toLowerCase()
            : true)
            .filter((o) => selectedBodyType.length > 0
            ? o.bodyType && selectedBodyType === o.bodyType.trim().toLowerCase()
            : true)
            .filter((o) => selectedMileageRange && Object.keys(selectedMileageRange).length > 0
            //@ts-ignore
            ? o.mileage && Number(o.mileage) >= selectedMileageRange.min && Number(o.mileage) <= selectedMileageRange.max
            : true)
            .filter((o) => {
            var _a, _b, _c;
            return keywordSearchText.length > 0
                ? (((_a = o.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(keywordSearchText.trim().toLowerCase())) ||
                    ((_b = o.model) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(keywordSearchText.trim().toLowerCase())) ||
                    ((_c = o.modelRange) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(keywordSearchText.trim().toLowerCase())))
                : true;
        })
            .filter((o) => stockNoSearchText.length > 0
            ? o.stockNo && o.stockNo.toLowerCase().includes(stockNoSearchText.trim().toLowerCase())
            : true);
        setIsFilterApplied(true);
        updateFilteredVehicles([...filteredVehicles]);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.searchToggleContainer },
            React.createElement(Button$1, { className: `${classes.primaryButton} ${classes.searchToggleButton}`, onClick: toggleSearcOptions }, "Click here to search vehicles")),
        React.createElement("div", { className: classes.outerContainer },
            React.createElement("div", { className: classes.closeIconContainer, onClick: toggleSearcOptions },
                React.createElement(CloseIcon, { className: classes.closeIcon })),
            ((_a = (headerLabel || "")) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                React.createElement(Typography$1, { className: classes.header }, headerLabel),
            React.createElement("div", { className: classes.searchField },
                React.createElement(Typography$1, { className: classes.standardTextBold, gutterBottom: true, align: "left" }, "Search by:")),
            React.createElement("div", { className: classes.searchField },
                React.createElement(ClickAwayListener, { onClickAway: () => setShowVehiclesTree(false) },
                    React.createElement("div", { className: classes.searchFieldOutlineContainer },
                        React.createElement(Paper, { className: classes.searchBarContainer },
                            React.createElement(InputBase, { className: classes.searchInput, type: "search", placeholder: (selectedVehicleNodes === null || selectedVehicleNodes === void 0 ? void 0 : selectedVehicleNodes.length) > 0 ? "Add More" : "Search Make / Model", name: makeModelSearchText, value: makeModelSearchText, onChange: onChangeMakeModelSearchText, onFocus: () => setShowVehiclesTree(true), onClick: (e) => {
                                    e.stopPropagation();
                                    setShowVehiclesTree(true);
                                } }),
                            (selectedVehicleNodes === null || selectedVehicleNodes === void 0 ? void 0 : selectedVehicleNodes.length) > 0 &&
                                React.createElement("div", { className: classes.selectedMakeChipContainer }, selectedVehicleNodes.map((item) => (React.createElement(Chip, { className: classes.selectedMakeChip, label: item === null || item === void 0 ? void 0 : item.displayName, onDelete: (e) => handleNodeSelected(item, e) })))),
                            React.createElement("div", { className: classes.dropdownCaretContainer },
                                React.createElement(ArrowDropDown, { className: classes.dropdownCaret, onClick: toggleVehiclesTree, style: showVehiclesTree ? { transform: "rotate(180deg)" } : {} }))),
                        React.createElement(Collapse, { in: showVehiclesTree },
                            React.createElement("hr", { style: { width: "98%" } }),
                            (searchedVehicleNodes === null || searchedVehicleNodes === void 0 ? void 0 : searchedVehicleNodes.length) === 0 &&
                                React.createElement(Typography$1, { className: classes.searchResultsText }, "No results found"),
                            (searchedVehicleNodes === null || searchedVehicleNodes === void 0 ? void 0 : searchedVehicleNodes.length) > 0 &&
                                React.createElement("div", { className: classes.searchVehiclesTree },
                                    React.createElement(List, { className: classes.searchResultsVehiclesContainer }, searchedVehicleNodes.map((node) => (renderVehicleNode(node))))))))),
            React.createElement("div", { className: classes.searchField }, priceRanges &&
                React.createElement("div", { className: classes.searchFieldOutlineContainer },
                    React.createElement(RangeSlider, { id: "price_range", isCurrencyVal: true, reset: !isFilterApplied, label: "Price Range", 
                        //@ts-ignore
                        range: priceRanges, onChange: selectPriceRange, websiteColors: websiteColors }))),
            React.createElement("div", { className: classes.searchField }, yearRanges &&
                React.createElement("div", { className: classes.searchFieldOutlineContainer },
                    React.createElement(RangeSlider, { id: "year_range", isCurrencyVal: false, reset: !isFilterApplied, label: "Year", 
                        //@ts-ignore
                        range: yearRanges, onChange: selectYearRange, websiteColors: websiteColors }))),
            React.createElement("div", { className: classes.searchFieldGrouped },
                React.createElement("div", { className: classes.searchField },
                    React.createElement(TextField$1, { select: true, fullWidth: true, id: "selectedTransmission", variant: "outlined", label: "Manual / Auto", value: selectedTransmission, onChange: selectTransmission, SelectProps: {
                            //@ts-ignore
                            MenuProps: menuProps
                        }, InputProps: {
                            classes: {
                                root: customClasses.root,
                                focused: customClasses.focused,
                                notchedOutline: customClasses.notchedOutline,
                            }
                        }, className: classes.customDropDown }, transmissions.map((item, i) => (React.createElement(MenuItem$2, { key: i, value: item }, item))))),
                React.createElement("div", { className: classes.searchField },
                    React.createElement(TextField$1, { select: true, fullWidth: true, id: "selectedBodyType", variant: "outlined", label: "Body Type", value: selectedBodyType, onChange: selectBodyType, SelectProps: {
                            //@ts-ignore
                            MenuProps: menuProps
                        }, InputProps: {
                            classes: {
                                root: customClasses.root,
                                focused: customClasses.focused,
                                notchedOutline: customClasses.notchedOutline,
                            }
                        }, className: classes.customDropDown }, bodyTypes.map((item, i) => (React.createElement(MenuItem$2, { key: i, value: item }, item)))))),
            React.createElement("div", { className: classes.searchFieldGrouped },
                React.createElement("div", { className: classes.searchField },
                    React.createElement(TextField$1, { select: true, fullWidth: true, id: "selectedMileageRange", variant: "outlined", label: "Mileage", value: selectedMileageRange, onChange: selectMileageRange, SelectProps: {
                            //@ts-ignore
                            MenuProps: menuProps
                        }, InputProps: {
                            classes: {
                                root: customClasses.root,
                                focused: customClasses.focused,
                                notchedOutline: customClasses.notchedOutline,
                            }
                        }, className: classes.customDropDown }, mileageRanges.map((item, i) => (
                    // @ts-ignore
                    React.createElement(MenuItem$2, { key: i, value: item },
                        mileageFormatter.format((item === null || item === void 0 ? void 0 : item.min) || 0),
                        " - ",
                        mileageFormatter.format((item === null || item === void 0 ? void 0 : item.max) || 0)))))),
                React.createElement("div", { className: classes.searchField },
                    React.createElement(TextField$1, { select: true, fullWidth: true, id: "selectedFuelType", variant: "outlined", label: "Fuel Type", value: selectedFuelType, onChange: selectFuelType, SelectProps: {
                            //@ts-ignore
                            MenuProps: menuProps
                        }, InputProps: {
                            classes: {
                                root: customClasses.root,
                                focused: customClasses.focused,
                                notchedOutline: customClasses.notchedOutline,
                            }
                        }, className: classes.customDropDown }, fuelTypes.map((item, i) => (React.createElement(MenuItem$2, { key: i, value: item }, item)))))),
            React.createElement("div", { className: classes.searchField }, instalmentRanges &&
                React.createElement("div", { className: classes.searchFieldOutlineContainer },
                    React.createElement(RangeSlider, { id: "instalment_range", isCurrencyVal: true, reset: !isFilterApplied, label: "Instalment", 
                        //@ts-ignore
                        range: instalmentRanges, onChange: selectInstalmentRange, websiteColors: websiteColors }))),
            React.createElement("div", { className: classes.searchField },
                React.createElement(TextField$1, { fullWidth: true, variant: "outlined", label: "Keyword Search", placeholder: "Keyword, eg: GTI", value: keywordSearchText, onChange: onChangeKeywordSearchText, InputProps: {
                        classes: {
                            root: customClasses.root,
                            focused: customClasses.focused,
                            notchedOutline: customClasses.notchedOutline,
                        }
                    } })),
            React.createElement("div", { className: classes.searchField },
                React.createElement(TextField$1, { fullWidth: true, variant: "outlined", label: "Stock Number", placeholder: "Stock Number", value: stockNoSearchText, onChange: onChangeStockNoSearchText, InputProps: {
                        classes: {
                            root: customClasses.root,
                            focused: customClasses.focused,
                            notchedOutline: customClasses.notchedOutline,
                        }
                    } })),
            React.createElement("div", { className: classes.buttensContainer },
                React.createElement(Button$1, { className: `${classes.transparentButton} ${classes.resetButton}`, onClick: reset }, "Reset"),
                React.createElement(Button$1, { className: `${classes.primaryButton} ${classes.resultsButton}`, onClick: filter }, "Show Results")))));
};

const useStyles$4 = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    btn: {
        padding: "5px 30px",
        //@ts-ignore
        backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
        color: "white",
        "&:hover": {
            //@ts-ignore
            backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
            opacity: 0.8,
        },
    },
    input: {
        margin: "10px 0px"
    },
    inputDealer: {
        marginBottom: "10px"
    }
}));
const PersonalDetailsForm = ({ personalDetails, onSubmit, dealerList, defaultDealerId, setAtiveDealerId, rightSection, websiteColors, wePay4Cars_uri, includeAvailability, paper, paperColor, paperShadowColor, }) => {
    const classes = useStyles$4(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    useStyles$4();
    const isDealerListAvailable = (dealerList === null || dealerList === void 0 ? void 0 : dealerList.length) && dealerList.length > 0;
    const defaultDealer = isDealerListAvailable
        ? dealerList === null || dealerList === void 0 ? void 0 : dealerList.find((d) => {
            return (d === null || d === void 0 ? void 0 : d.dealerId) === defaultDealerId;
        })
        : null;
    const [loading, setLoading] = useState(true);
    const [locations, setLocations] = useState([]);
    const [dealer, setDealer] = useState(defaultDealer);
    const [openLocation, setOpenLocation] = React.useState(false);
    const initialFormValues = {
        firstName: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName) || "",
        lastName: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.lastName) || "",
        mobileNumber: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.mobileNumber) || "",
        emailAddress: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.emailAddress) || "",
        city: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.city) || "",
        province: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.province) || "",
        country: (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.country) || "",
        availability: undefined,
    };
    const availabilityOptions = [
        { id: 1, name: "Now" },
        { id: 2, name: "In a week" },
    ];
    const phoneRegExp = /^0(6|7|8){1}[0-9]{1}[0-9]{7}$/;
    const validationSchema = Yup.object({
        firstName: Yup.string().required("First name is required"),
        lastName: Yup.string().required("Last name is required"),
        emailAddress: Yup.string()
            .email("Enter a valid email")
            .required("Email is required"),
        mobileNumber: Yup.string()
            .required("Phone number is required")
            .matches(phoneRegExp, "Phone number is not valid"),
    });
    useEffect(() => {
        const getLocations = () => __awaiter(void 0, void 0, void 0, function* () {
            let tempLocations = [];
            try {
                // @ts-ignore
                let locationsResult = yield axios.get(`${wePay4Cars_uri}/dashboard/location`);
                tempLocations = locationsResult === null || locationsResult === void 0 ? void 0 : locationsResult.data;
                if (!tempLocations || tempLocations.length <= 0) {
                    throw new Error();
                }
            }
            catch (_a) {
                tempLocations = [
                    {
                        city: "None available",
                        province: "None available",
                        country: "None available",
                    },
                ];
            }
            setLocations(tempLocations);
            setLoading(false);
        });
        getLocations();
    }, [wePay4Cars_uri]);
    const submitForm = (values) => {
        onSubmit(values);
    };
    const dealers = dealerList ? dealerList : [];
    const handleLocationChange = (e, value, setFieldValue) => {
        setFieldValue("city", value.city);
        setFieldValue("province", value.province);
        setFieldValue("country", value.country);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.holder },
            React.createElement(CardHeader, { className: "p-4", title: "About you", subheader: "In order to load your car we need to know a bit about you. This process will take under 5mins from start to completion." }),
            React.createElement("div", { className: classes.holderInner },
                React.createElement(Formik, { isInitialValid: false, initialValues: initialFormValues, enableReinitialize: true, validationSchema: validationSchema, onSubmit: (values) => {
                        submitForm(values);
                    } }, (props) => {
                    const { values, touched, errors, isValid, handleBlur, handleChange, setFieldValue, } = props;
                    return (React.createElement(Form, null,
                        React.createElement(Grid$1, { item: true, xs: 12, md: 4 }, isDealerListAvailable === true && (React.createElement(TextField$1, { fullWidth: true, label: "Select a dealer", required: true, select: true, className: classes.inputDealer, value: dealer, onChange: (e) => {
                                handleChange(e);
                                const value = e.target.value;
                                //@ts-ignore
                                setAtiveDealerId(value === null || value === void 0 ? void 0 : value.dealerId);
                                setDealer(value);
                            }, onBlur: handleBlur, name: "activeDealer", id: "activeDealer" }, dealers.map((option, i) => (React.createElement(MenuItem, { key: i, value: option }, option.name)))))),
                        React.createElement(Grid$1, { container: true, spacing: 4 },
                            React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement(TextField$1, { id: "firstName", name: "firstName", label: "First Name", variant: "outlined", required: true, fullWidth: true, className: classes.input, value: values.firstName, 
                                    //@ts-ignore
                                    helperText: React.createElement(React.Fragment, null, touched.firstName ? errors.firstName : ""), error: touched.firstName && Boolean(errors.firstName), onBlur: handleBlur, onChange: handleChange }),
                                React.createElement(TextField$1, { id: "lastName", name: "lastName", label: "Last Name", variant: "outlined", required: true, fullWidth: true, className: classes.input, value: values.lastName, 
                                    //@ts-ignore
                                    helperText: React.createElement(React.Fragment, null, touched.lastName ? errors.lastName : ""), error: touched.lastName && Boolean(errors.lastName), onBlur: handleBlur, onChange: handleChange }),
                                React.createElement(TextField$1, { id: "mobileNumber", name: "mobileNumber", label: "Mobile Number", variant: "outlined", required: true, className: classes.input, fullWidth: true, value: values.mobileNumber, 
                                    //@ts-ignore
                                    helperText: React.createElement(React.Fragment, null, touched.mobileNumber ? errors.mobileNumber : ""), error: touched.mobileNumber && Boolean(errors.mobileNumber), onBlur: handleBlur, onChange: handleChange }),
                                React.createElement(TextField$1, { id: "emailAddress", name: "emailAddress", label: "Email Address", variant: "outlined", fullWidth: true, className: classes.input, required: true, value: values.emailAddress, 
                                    //@ts-ignore
                                    helperText: React.createElement(React.Fragment, null, touched.emailAddress ? errors.emailAddress : ""), error: touched.emailAddress && Boolean(errors.emailAddress), onBlur: handleBlur, onChange: handleChange }),
                                React.createElement(Autocomplete, { id: "location", open: openLocation, onOpen: () => {
                                        setOpenLocation(true);
                                    }, onClose: () => {
                                        setOpenLocation(false);
                                    }, getOptionSelected: (option, value) => option.city === value.city, getOptionLabel: (option) => option.city, options: locations, loading: loading, onBlur: handleBlur, onChange: (e, c) => handleLocationChange(e, c, setFieldValue), renderInput: (params) => (React.createElement(TextField$1, Object.assign({}, params, { label: "Location", variant: "outlined", fullWidth: true, className: classes.input, 
                                        //@ts-ignore
                                        helperText: React.createElement(React.Fragment, null, touched.city ? errors.city : "Please enter your location"), error: touched.city && Boolean(errors.city), InputProps: Object.assign(Object.assign({}, params.InputProps), { endAdornment: (React.createElement(React.Fragment, null, params.InputProps.endAdornment)) }) }))) }),
                                includeAvailability && (React.createElement(TextField$1, { id: "availability", name: "availability", label: "When would you like to sell your vehicle?", variant: "outlined", fullWidth: true, select: true, className: classes.input, required: true, value: values.availability, helperText: touched.availability ? errors.availability : "", error: touched.availability && Boolean(errors.availability), onBlur: handleBlur, onChange: handleChange }, availabilityOptions.map((option) => (React.createElement(MenuItem, { key: option.id, id: option.id, value: option.name }, option.name)))))),
                            rightSection && (React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 }, rightSection)),
                            React.createElement(Grid$1, { item: true, xs: 12, container: true, justify: "flex-end" },
                                React.createElement(Button$1, { className: classes.btn, variant: "contained", color: "primary", type: "submit" }, "Next")))));
                })))));
};

const useStyles$3 = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    flexHolder: {
        display: "flex",
        flexWrap: "wrap",
    },
    btn: {
        padding: "5px 30px",
        //@ts-ignore
        backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
        color: "white",
        "&:hover": {
            //@ts-ignore
            backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
            opacity: 0.8,
        },
    },
    legend: {},
    labels: {},
    radioButton: {},
}));
const VehicleSpecsForm = ({ base_uri, licenseDiskScanner, filterCat, wePay4Cars_uri, vehicle, onSubmit, websiteColors, paper, paperColor, paperShadowColor, }) => {
    const classes = useStyles$3(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    const localStyles = useStyles$3();
    const { enqueueSnackbar } = useSnackbar();
    const initialFormValues = {
        licenseDisk: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.licenseDisk) || "",
        category: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category) || "",
        categoryId: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categoryId) || -1,
        make: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.make) || "",
        makeId: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.makeId) || 0,
        model: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) || "",
        modelId: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelId) || 0,
        variant: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.variant) || "",
        variantId: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.variantId) || 0,
        variantCode: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.variantCode) || "",
        variantStartYear: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.variantStartYear) || 0,
        variantEndYear: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.variantEndYear) || 0,
        year: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.year) || "",
        odometer: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.odometer) || "",
        color: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.color) || "",
        vin: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin) || "",
        regNo: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.regNo) || "",
        transmission: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmission) || "",
        fuelType: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.fuelType) || "",
        spareKeys: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.spareKeys) || false,
        serviceBook: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.serviceBook) || false,
        maintenancePlan: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.maintenancePlan) || false,
        warranty: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.warranty) || false,
    };
    const [loading, setLoading] = useState(true);
    const [loadingOptions, setLoadingOptions] = useState(false);
    const [categories, setCategories] = useState([]);
    const [makes, setMakes] = useState([]);
    const [models, setModels] = useState([]);
    const [years, setYears] = useState([]);
    const [variants, setVariants] = useState([]);
    const validationSchema = Yup.object({
        make: Yup.string().required("Select a vehicle make"),
        model: Yup.string().required("Select a vehicle model"),
        variant: Yup.string().required("Select a model variant"),
        // year: Yup.number()
        //   .min(variantIntroYear, "Model year must be between variant introduction and discontinue years")
        //   .max(variantDiscYear, "Model year must be between variant introduction and discontinue years")
        //   .required("Model year is required"),
        odometer: Yup.number().required("Odometer reading is required"),
        regNo: Yup.string().required("Registration number is required"),
        transmission: Yup.string().required("Select a transmission"),
        fuelType: Yup.string().required("Select a fuel type"),
    });
    useEffect(() => {
        var _a;
        let errors = [];
        let allPromises = [];
        allPromises.push(new Promise((res) => {
            try {
                getCategories();
            }
            catch (error) {
                errors.push(`Failed to load the vehicle categories: ${error}`);
            }
            res(true);
        }));
        if ((vehicle === null || vehicle === void 0 ? void 0 : vehicle.categoryId) > 0) {
            allPromises.push(new Promise((res) => {
                try {
                    getMakes(vehicle.categoryId);
                }
                catch (error) {
                    errors.push(`Failed to load the makes: ${error}`);
                }
                res(true);
            }));
        }
        if ((vehicle === null || vehicle === void 0 ? void 0 : vehicle.makeId) > 0) {
            allPromises.push(new Promise((res) => {
                try {
                    getModels(vehicle.makeId);
                }
                catch (error) {
                    errors.push(`Failed to load the models: ${error}`);
                }
                res(true);
            }));
        }
        if ((vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelId) > 0) {
            allPromises.push(new Promise((res) => {
                try {
                    getYears(vehicle.modelId);
                }
                catch (error) {
                    errors.push(`Failed to load the years: ${error}`);
                }
                res(true);
            }));
        }
        if ((vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelId) > 0 && ((_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.year) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            allPromises.push(new Promise((res) => {
                try {
                    getVariants(vehicle.modelId, vehicle.year);
                }
                catch (error) {
                    errors.push(`Failed to load the variants: ${error}`);
                }
                res(true);
            }));
        }
        Promise.allSettled(allPromises)
            .then(() => {
            setLoading(false);
            if (errors.length > 0) {
                enqueueSnackbar(`Some errors occurred while loading the form data: ${errors.map(e => e)}`, { variant: 'error' });
            }
        }).catch((error) => {
            setLoading(false);
            enqueueSnackbar(`An unexpected error occurred while loading the form data: ${error}`, { variant: 'error' });
        });
    }, []);
    const getCategories = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        axios
            .get(`${wePay4Cars_uri}/vehicle/type`)
            .then((result) => {
            var _a;
            setLoadingOptions(false);
            setCategories(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.sort((a, b) => a.typeName > b.typeName ? 1 : -1)) || []);
        })
            .catch((error) => {
            setLoadingOptions(false);
            enqueueSnackbar(`Failed to load the makes: ${error}`, { variant: "error" });
        });
    });
    const getMakes = (categoryId) => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        axios // @ts-ignore
            .get(`${wePay4Cars_uri}/vehicle/Make`, {
            params: {
                vehicleTypeId: categoryId,
            }
        })
            .then((result) => {
            var _a;
            setLoadingOptions(false);
            setMakes(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.sort((a, b) => a.manufacturerName > b.manufacturerName ? 1 : -1)) || []);
        })
            .catch((error) => {
            setLoadingOptions(false);
            enqueueSnackbar(`Failed to load the makes: ${error}`, { variant: "error" });
        });
    });
    const getModels = (makeId) => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        axios // @ts-ignore
            .get(`${wePay4Cars_uri}/vehicle/Model`, {
            params: {
                vehicleMakeId: makeId,
            }
        })
            .then((result) => {
            var _a;
            setLoadingOptions(false);
            setModels(((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.sort((a, b) => a.modelName > b.modelName ? 1 : -1)) || []);
        })
            .catch((error) => {
            setLoadingOptions(false);
            enqueueSnackbar(`Failed to load the models: ${error}`, { variant: "error" });
        });
    });
    const getYears = (modelId) => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        fetchYears(modelId)
            .then((result) => {
            setLoadingOptions(false);
            setYears((result === null || result === void 0 ? void 0 : result.data) || []);
        })
            .catch((error) => {
            setLoadingOptions(false);
            enqueueSnackbar(`Failed to load the variants: ${error}`, { variant: "error" });
        });
    });
    const getVariants = (modelId, year) => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingOptions(true);
        fetchVariants(modelId, year)
            .then((result) => {
            setLoadingOptions(false);
            setVariants((result === null || result === void 0 ? void 0 : result.data) || []);
        })
            .catch((error) => {
            setLoadingOptions(false);
            enqueueSnackbar(`Failed to load the variants: ${error}`, { variant: "error" });
        });
    });
    const fetchYears = (modelId) => {
        // @ts-ignore
        return axios.get(`${wePay4Cars_uri}/vehicle/year`, {
            params: {
                modelId
            }
        });
    };
    const fetchVariants = (modelId, year) => {
        // @ts-ignore
        return axios.get(`${wePay4Cars_uri}/Vehicle/variant`, {
            params: {
                modelId: modelId,
                year: year,
            }
        });
    };
    const checkLicense = (base64VehicleLicense, values, setFieldValue) => {
        if (!wePay4Cars_uri) {
            return;
        }
        setLoading(true);
        axios
            .post(`${wePay4Cars_uri}/vehicle/contactable`, { base64VehicleLicense })
            .then((response) => {
            var _a, _b, _c, _d;
            if (!(response === null || response === void 0 ? void 0 : response.data)) {
                setLoading(false);
                enqueueSnackbar(`No information retrieved from reading the license disk`, { variant: "warning" });
                return;
            }
            setFieldValue("color", ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.color) || values.color);
            setFieldValue("regNo", ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.registration) || values.regNo);
            setFieldValue("vin", ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.vin) || values.vin);
            axios
                // @ts-ignore
                .get(`${wePay4Cars_uri}/vehicle/modelByName`, {
                params: {
                    modelName: (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.model,
                }
            })
                .then((result) => {
                var _a, _b, _c, _d, _e, _f;
                let category = categories.find((c) => { var _a; return c.id == ((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.category); });
                let make = {
                    id: (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.manufacturer) === null || _b === void 0 ? void 0 : _b.id,
                    manufacturerName: (_d = (_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.manufacturer) === null || _d === void 0 ? void 0 : _d.name
                };
                let model = {
                    id: (_e = result === null || result === void 0 ? void 0 : result.data) === null || _e === void 0 ? void 0 : _e.id,
                    modelName: (_f = result === null || result === void 0 ? void 0 : result.data) === null || _f === void 0 ? void 0 : _f.name
                };
                if (!make.manufacturerName || !model.modelName) {
                    setLoading(false);
                    enqueueSnackbar(`Could not determine the make or model from the license disk`, { variant: "warning" });
                    return;
                }
                setMakes([make]);
                setModels([model]);
                setFieldValue("category", category.typeName);
                setFieldValue("categoryId", category.id);
                setFieldValue("make", make.manufacturerName);
                setFieldValue("makeId", make.id);
                setFieldValue("model", model.modelName);
                setFieldValue("modelId", model.id);
                getYears(model.id)
                    .then(() => setLoading(false))
                    .catch(() => setLoading(false));
            })
                .catch((error) => {
                setLoading(false);
                enqueueSnackbar(`Failed to get all the models: ${error}`, { variant: "warning" });
            });
        })
            .catch((error) => {
            setLoading(false);
            enqueueSnackbar(`Failed to read the license disk: ${error}`, { variant: "warning" });
        });
    };
    const handleSelectChange = (e, value, setFieldValue, fieldName, fieldId) => {
        var _a, _b;
        setFieldValue(fieldName, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        setFieldValue(fieldId, (_b = value === null || value === void 0 ? void 0 : value.props) === null || _b === void 0 ? void 0 : _b.id);
    };
    const handleResetCustom = (setFieldValue) => {
        setFieldValue("category", "");
        setFieldValue("categoryId", -1);
        setFieldValue("make", "");
        setFieldValue("makeId", 0);
        setFieldValue("model", "");
        setFieldValue("modelId", 0);
        setFieldValue("variant", "");
        setFieldValue("variantId", 0);
        setFieldValue("variantCode", "");
        setFieldValue("variantStartYear", 0);
        setFieldValue("variantEndYear", 0);
        setFieldValue("year", "");
        setFieldValue("odometer", "");
        setFieldValue("color", "");
        setFieldValue("vin", "");
        setFieldValue("regNo", "");
        setFieldValue("transmission", "");
        setFieldValue("fuelType", "");
        setFieldValue("spareKeys", false);
        setFieldValue("serviceBook", false);
        setFieldValue("maintenancePlan", false);
        setFieldValue("warranty", false);
    };
    const submitForm = (values) => {
        onSubmit(values);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.holder },
            React.createElement(CardHeader, { className: "p-4", title: "About your vehicle" }),
            React.createElement("div", { className: classes.holderInner },
                React.createElement(Formik, { isInitialValid: false, initialValues: initialFormValues, enableReinitialize: true, validationSchema: validationSchema, onSubmit: (values) => {
                        submitForm(values);
                    } }, (props) => {
                    const { values, touched, errors, isValid, handleReset, handleBlur, handleChange, setFieldValue } = props;
                    return (React.createElement(Form, null,
                        React.createElement(Grid$1, { container: true, spacing: 4, direction: "row" },
                            licenseDiskScanner &&
                                React.createElement(Grid$1, { item: true, xs: 12, container: true, justifyContent: "flex-start" },
                                    React.createElement(ImageUploaderInput, { title: "South African License Disk", fieldName: "licenseDisk", onChange: (uri) => {
                                            handleResetCustom(setFieldValue);
                                            checkLicense(uri, values, setFieldValue);
                                        }, error: errors.licenseDisk && touched.licenseDisk })),
                            loading
                                &&
                                    React.createElement(Grid$1, { container: true, justifyContent: "center" },
                                        React.createElement(CircularProgress$1, null)),
                            !loading &&
                                React.createElement(React.Fragment, null,
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "category", label: "Category", variant: "outlined", fullWidth: true, select: true, disabled: !(values === null || values === void 0 ? void 0 : values.categoryId) && loadingOptions, value: values.category, 
                                            //@ts-ignore
                                            helperText: React.createElement(React.Fragment, null, errors.category && touched.category ? errors.category : ""), error: touched.category && Boolean(errors.category), onBlur: handleBlur, 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "category", "categoryId");
                                                // Load the makes for the selected category
                                                setTimeout(() => {
                                                    var _a;
                                                    getMakes((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id);
                                                }, 100);
                                            } }, filterCat ?
                                            categories.filter((o) => o.typeName !== "Motorcycle").map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.typeName }, option.typeName)))
                                            : categories.map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.typeName }, option.typeName))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "make", label: "Make", variant: "outlined", fullWidth: true, required: true, select: true, disabled: (!(values === null || values === void 0 ? void 0 : values.makeId) && loadingOptions) || values.categoryId < 0, value: values.make, helperText: React.createElement(React.Fragment, null, errors.make && touched.make ? errors.make : ""), error: touched.make && Boolean(errors.make), onBlur: handleBlur, 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "make", "makeId");
                                                // Load the models for the selected make
                                                setTimeout(() => {
                                                    var _a;
                                                    getModels((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id);
                                                }, 100);
                                            } }, makes.map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.manufacturerName }, option.manufacturerName))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "model", label: "Model", variant: "outlined", fullWidth: true, required: true, select: true, disabled: (!(values === null || values === void 0 ? void 0 : values.modelId) && loadingOptions) || !(values === null || values === void 0 ? void 0 : values.makeId), value: values.model, helperText: React.createElement(React.Fragment, null, errors.model && touched.model ? errors.model : ""), error: touched.model && Boolean(errors.model), onBlur: handleBlur, 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "model", "modelId");
                                                // Load the model years for the selected model
                                                setTimeout(() => {
                                                    var _a;
                                                    getYears((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id);
                                                }, 100);
                                            } }, models.map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.modelName }, option.modelName))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "year", label: "Model Year", variant: "outlined", fullWidth: true, select: true, disabled: (!(values === null || values === void 0 ? void 0 : values.year) && loadingOptions) || !(values === null || values === void 0 ? void 0 : values.modelId), value: values.year, helperText: React.createElement(React.Fragment, null, errors.year && touched.year ? errors.year : ""), error: touched.year && Boolean(errors.year), onBlur: handleBlur, 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "year", "year");
                                                // Load the variants for the selected model & year
                                                setTimeout(() => {
                                                    var _a;
                                                    getVariants(values.modelId, (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.value);
                                                }, 100);
                                            } }, years.map((option) => (React.createElement(MenuItem$2, { key: option, id: option, value: option }, option))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "variant", label: "Variant", variant: "outlined", fullWidth: true, required: true, select: true, disabled: (!(values === null || values === void 0 ? void 0 : values.variantId) && loadingOptions) || !(values === null || values === void 0 ? void 0 : values.modelId) || !(values === null || values === void 0 ? void 0 : values.year), value: values.variant, helperText: React.createElement(React.Fragment, null, errors.variant && touched.variant ? errors.variant : ""), error: touched.variant && Boolean(errors.variant), onBlur: handleBlur, 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "variant", "variantId");
                                                // Set the variant introduction & discontinue years to validate the Year field
                                                let variant = variants.find((v) => { var _a; return v.id == ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id); });
                                                // Set the field values to be used in the final form
                                                setFieldValue("variantCode", variant === null || variant === void 0 ? void 0 : variant.mmcode);
                                                setFieldValue("variantStartYear", variant === null || variant === void 0 ? void 0 : variant.startYear);
                                                setFieldValue("variantEndYear", variant === null || variant === void 0 ? void 0 : variant.endYear);
                                            } }, variants.map((option) => (React.createElement(MenuItem$2, { key: option.id, id: option.id, value: option.name }, option.name))))),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "odometer", name: "odometer", label: "Odometer Reading", variant: "outlined", required: true, type: "number", fullWidth: true, value: values.odometer, helperText: React.createElement(React.Fragment, null, touched.odometer ? errors.odometer : ""), error: touched.odometer && Boolean(errors.odometer), onBlur: handleBlur, onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "color", name: "color", label: "Color (Optional)", variant: "outlined", fullWidth: true, value: values.color, helperText: React.createElement(React.Fragment, null, touched.color ? errors.color : ""), error: touched.color && Boolean(errors.color), onBlur: handleBlur, onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "vin", name: "vin", label: "VIN Number", variant: "outlined", fullWidth: true, value: values.vin, helperText: React.createElement(React.Fragment, null, touched.vin ? errors.vin : ""), error: touched.vin && Boolean(errors.vin), onBlur: handleBlur, onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "regNo", name: "regNo", label: "Registration Number", variant: "outlined", required: true, fullWidth: true, value: values.regNo, helperText: React.createElement(React.Fragment, null, touched.regNo ? errors.regNo : ""), error: touched.regNo && Boolean(errors.regNo), onBlur: handleBlur, onChange: handleChange })),
                                    React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                        React.createElement(TextField$1, { id: "transmission", label: "Transmission", variant: "outlined", fullWidth: true, required: true, select: true, value: values.transmission, helperText: React.createElement(React.Fragment, null, errors.transmission && touched.transmission ? errors.transmission : ""), error: touched.transmission && Boolean(errors.transmission), onBlur: handleBlur, 
                                            //@ts-ignore
                                            onChange: (e, child) => {
                                                handleSelectChange(e, child, setFieldValue, "transmission", "transmissionId");
                                            } }, ["Automatic", "Manual"].map((option, index) => (React.createElement(MenuItem$2, { key: index, id: index, value: option }, option))))),
                                    React.createElement(Container$1, { item: true, xs: 12, sm: 6, md: 4, className: localStyles.flexHolder },
                                        React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                            React.createElement(FormControl, { component: "fieldset" },
                                                React.createElement(FormLabel, { component: "legend", className: localStyles.legend }, "Fuel Type *"),
                                                React.createElement(RadioGroup, { "aria-label": "fuelType", name: "fuelType", value: values.fuelType, onChange: handleChange },
                                                    React.createElement(FormControlLabel$1, { value: "Petrol", classes: { label: localStyles.labels }, control: React.createElement(Radio, { classes: { checked: localStyles.radioButton } }), label: "Petrol" }),
                                                    React.createElement(FormControlLabel$1, { value: "Diesel", classes: { label: localStyles.labels }, control: React.createElement(Radio, { classes: { checked: localStyles.radioButton } }), label: "Diesel" }),
                                                    React.createElement(FormControlLabel$1, { value: "Hybrid", classes: { label: localStyles.labels }, control: React.createElement(Radio, { classes: { checked: localStyles.radioButton } }), label: "Hybrid" }),
                                                    React.createElement(FormControlLabel$1, { value: "Electric", classes: { label: localStyles.labels }, control: React.createElement(Radio, { classes: { checked: localStyles.radioButton } }), label: "Electric" })),
                                                errors.fuelType && (React.createElement(FormHelperText, { className: "mt-0 mb-2", error: true }, "Fuel Type is required")))),
                                        React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                            React.createElement(FormControl, { component: "fieldset" },
                                                React.createElement(FormLabel, { component: "legend", className: localStyles.legend }, "Miscellaneous"),
                                                React.createElement(FormControlLabel$1, { label: "Spare Keys", control: React.createElement(Checkbox$1, { id: "spareKeys", value: values.spareKeys, defaultChecked: values.spareKeys, onBlur: handleBlur, onChange: handleChange }) }),
                                                React.createElement(FormControlLabel$1, { label: "Service Book", control: React.createElement(Checkbox$1, { id: "serviceBook", value: values.serviceBook, defaultChecked: values.serviceBook, onBlur: handleBlur, onChange: handleChange }) }),
                                                React.createElement(FormControlLabel$1, { label: "Maintenance Plan", control: React.createElement(Checkbox$1, { id: "maintenancePlan", value: values.maintenancePlan, defaultChecked: values.maintenancePlan, onBlur: handleBlur, onChange: handleChange }) }),
                                                React.createElement(FormControlLabel$1, { label: "Warranty", control: React.createElement(Checkbox$1, { id: "warranty", value: values.warranty, defaultChecked: values.warranty, onBlur: handleBlur, onChange: handleChange }) }))))),
                            React.createElement(Grid$1, { item: true, xs: 12, container: true, justify: "flex-end" },
                                React.createElement(Button$1, { className: classes.btn, variant: "contained", color: "primary", type: "submit" }, "Next")))));
                })))));
};

const useStyles$2 = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    btn: {
        padding: '5px 30px',
    }
}));
const VehicleImageForm = ({ images, onSubmit, websiteColors, paper, paperColor, paperShadowColor, }) => {
    const classes = useStyles$2(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    useStyles$2();
    const initialFormValues = {
        front: (images === null || images === void 0 ? void 0 : images.front) || '',
        rear: (images === null || images === void 0 ? void 0 : images.rear) || '',
        leftSide: (images === null || images === void 0 ? void 0 : images.leftSide) || '',
        rightSide: (images === null || images === void 0 ? void 0 : images.rightSide) || ''
    };
    const validationSchema = Yup.object({
        front: Yup.string().required("Front image is required"),
        rear: Yup.string().required("Rear image is required"),
        leftSide: Yup.string().required("Left-side image is required"),
        rightSide: Yup.string().required("Right-side image is required")
    });
    const submitForm = (values) => {
        onSubmit(values);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.holder },
            React.createElement(CardHeader, { className: "p-4", title: 'Submit images / photos of your vehicle' }),
            React.createElement("div", { className: classes.holderInner },
                React.createElement(Formik, { isInitialValid: false, initialValues: initialFormValues, enableReinitialize: true, validationSchema: validationSchema, onSubmit: (values) => {
                        submitForm(values);
                    } }, (props) => {
                    const { values, touched, errors, isValid, handleBlur, handleChange, setFieldValue } = props;
                    return (React.createElement(Form, null,
                        React.createElement(Grid$1, { container: true, spacing: 2, direction: "row" },
                            React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement(ImageUploaderInput, { title: 'Front', fieldName: 'front', required: true, error: errors.front && touched.front })),
                            React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement(ImageUploaderInput, { title: 'Rear', fieldName: 'rear', required: true, error: errors.rear && touched.rear })),
                            React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement(ImageUploaderInput, { title: 'Left Side', fieldName: 'leftSide', required: true, error: errors.leftSide && touched.leftSide })),
                            React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement(ImageUploaderInput, { title: 'Right Side', fieldName: 'rightSide', required: true, error: errors.rightSide && touched.rightSide })),
                            React.createElement(Grid$1, { item: true, xs: 12, container: true, justify: "flex-end" },
                                React.createElement(Button$1, { className: classes.btn, variant: 'contained', color: "primary", type: "submit" }, "Next")))));
                })))));
};

const useStyles$1 = makeStyles((theme) => ({
    holder: {
        borderRadius: "5px !important",
        //@ts-ignore
        backgroundColor: ({ paperColor }) => `${paperColor} !important`,
        //@ts-ignore
        boxShadow: ({ paperShadowColor }) => `1px 2px 8px -1px  ${paperShadowColor}!important`,
        //@ts-ignore
        marginTop: ({ paper }) => `${paper ? "2px" : "0px"} !important`,
    },
    holderInner: {
        //@ts-ignore
        padding: ({ paper }) => `${paper ? "20px" : "0px"} !important`,
    },
    btn: {
        minWidth: 'fit-content',
        padding: "5px 30px",
        //@ts-ignore
        backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
        color: "white",
        "&:hover": {
            //@ts-ignore
            backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
            opacity: 0.8,
        },
    },
    modalBtn: {
        minWidth: '271px',
        Width: 'fit-content',
        padding: "5px 30px",
        //@ts-ignore
        backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
        color: "white",
        "&:hover": {
            //@ts-ignore
            backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
            opacity: 0.8,
        },
    },
    img: {
        width: "100%",
        height: "fit-content",
        maxHeight: "185px",
    },
    dropDownText: {
        padding: "10px",
        background: "#e8e7e7",
    },
    options: {
        "&:hover": {
            //@ts-ignore
            backgroundColor: ({ secondaryColor }) => `${secondaryColor} !important`,
            opacity: 0.8,
        },
    },
    newUsedModal: {
        textAlign: 'center',
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        margin: "auto",
    },
    newUsedContent: {
        width: "fit-content",
        minWidth: "300px",
        height: 'fit-content',
        padding: '5%',
        background: 'white',
        borderRadius: '20px',
        alignSelf: 'center',
    },
}));
const ConfirmationContainer = ({ base_uri, personalDetails, vehicleSpecs, vehicleImages, onSubmit, dealerId, newCarLink, usedCarLink, leadSourceId, websiteColors, resetForm, setFocus, onSubmitForm, wePay4Cars_uri, isRedirectOnConfirm, paper, paperColor, paperShadowColor, }) => {
    const classes = useStyles$1(Object.assign(Object.assign({}, websiteColors), { paper, paperColor, paperShadowColor }));
    useStyles$1();
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [showNewUsedModal, setShowNewUsedModal] = useState(false);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const redirect = (link) => {
        if (link &&
            (link.toLowerCase().includes("http") ||
                link.toLowerCase().includes("www"))) {
            window.location.href = `${link}`;
        }
        else {
            history.push(`${link}`);
        }
    };
    const handleClose = (option) => {
        setShowNewUsedModal(false);
        switch (option) {
            case 1:
                redirect(`${newCarLink}`);
                break;
            case 2:
                redirect(`${usedCarLink}`);
                break;
            default:
                onSubmit(true);
                break;
        }
        //confirmDetails(option);
    };
    const confirmDetails = () => {
        if (!Object.keys(personalDetails).length ||
            !Object.keys(vehicleSpecs).length ||
            !Object.keys(vehicleImages).length) {
            enqueueSnackbar("Some required details are missing", {
                variant: "warning",
            });
            return;
        }
        if (onSubmitForm) {
            let formValues = Object.assign(Object.assign(Object.assign({}, personalDetails), vehicleSpecs), vehicleImages);
            onSubmitForm(formValues);
        }
        scroll();
        setLoading(true);
        saveDetails();
    };
    const resetPersonalDetailsFormValues = () => {
        personalDetails.firstName = "";
        personalDetails.lastName = "";
        personalDetails.mobileNumber = "";
        personalDetails.emailAddress = "";
        personalDetails.city = "";
        personalDetails.province = "";
        personalDetails.country = "";
    };
    const resetVehicleDetailsFormValues = () => {
        vehicleSpecs.licenseDisk = "";
        vehicleSpecs.category = "";
        vehicleSpecs.categoryId = -1;
        vehicleSpecs.make = "";
        vehicleSpecs.makeId = 0;
        vehicleSpecs.model = "";
        vehicleSpecs.modelId = 0;
        vehicleSpecs.variant = "";
        vehicleSpecs.variantId = 0;
        vehicleSpecs.variantCode = "";
        vehicleSpecs.variantStartYear = 0;
        vehicleSpecs.variantEndYear = 0;
        vehicleSpecs.year = "";
        vehicleSpecs.odometer = "";
        vehicleSpecs.color = "";
        vehicleSpecs.vin = "";
        vehicleSpecs.regNo = "";
        vehicleSpecs.transmission = "";
        vehicleSpecs.fuelType = "";
        vehicleSpecs.spareKeys = false;
        vehicleSpecs.serviceBook = false;
        vehicleSpecs.maintenancePlan = false;
        vehicleSpecs.warranty = false;
    };
    const resetVehicleImagesFormValues = () => {
        vehicleImages.front = "";
        vehicleImages.rear = "";
        vehicleImages.leftSide = "";
        vehicleImages.rightSide = "";
    };
    const resetFormValues = () => {
        resetPersonalDetailsFormValues();
        resetVehicleDetailsFormValues();
        resetVehicleImagesFormValues();
    };
    const scroll = () => {
        if (setFocus && !!setFocus) {
            var element = document.getElementById(setFocus);
            //@ts-ignore
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    };
    const saveDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        // Save the various details to WePay4Cars database first, then the lead details & then process the new lead
        try {
            let userResult = yield createWp4cUser();
            let user = userResult === null || userResult === void 0 ? void 0 : userResult.data;
            if (!user) {
                setLoading(false);
                enqueueSnackbar(`Failed to create the user: response is null`, {
                    variant: "error",
                });
                return;
            }
            let vehicleResult = yield createWp4cVehicle(user.token);
            let listingId = vehicleResult === null || vehicleResult === void 0 ? void 0 : vehicleResult.data;
            if (!listingId) {
                setLoading(false);
                enqueueSnackbar(`Failed to create the vehicle: response is null`, {
                    variant: "error",
                });
                return;
            }
            let vehicleImagesResult = yield saveWp4cVehicleImages(user.token, listingId);
            if (!(vehicleImagesResult === null || vehicleImagesResult === void 0 ? void 0 : vehicleImagesResult.data)) {
                setLoading(false);
                enqueueSnackbar(`Failed to save the vehicle images: response is null`, {
                    variant: "error",
                });
                return;
            }
            let confirmedListingResult = yield confirmTrade(user.token, listingId);
            let confirmedListing = confirmedListingResult === null || confirmedListingResult === void 0 ? void 0 : confirmedListingResult.data;
            if (!confirmedListing) {
                setLoading(false);
                enqueueSnackbar(`Failed to confirm the trade: response is null`, {
                    variant: "error",
                });
                return;
            }
            let leadResult = yield createLead();
            let lead = leadResult === null || leadResult === void 0 ? void 0 : leadResult.data;
            if (!lead) {
                setLoading(false);
                enqueueSnackbar(`Failed to create the lead: response is null`, {
                    variant: "error",
                });
                return;
            }
            let tradeInResult = yield createTradeIn(lead.id, confirmedListing);
            let tradeIn = tradeInResult === null || tradeInResult === void 0 ? void 0 : tradeInResult.data;
            if (!tradeIn) {
                setLoading(false);
                enqueueSnackbar(`Failed to save the trade-in details: response is null`, { variant: "error" });
                return;
            }
            processLead(lead.id);
        }
        catch (error) {
            setLoading(false);
            enqueueSnackbar(`Failed to save the details: ${error}`, {
                variant: "error",
            });
        }
    });
    const createWp4cUser = () => {
        let data = Object.assign(Object.assign({}, personalDetails), { idNumber: "1234567890123", isExternal: true, driversLicense: "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z/C/HgAGgwJ/lK3Q6wAAAABJRU5ErkJggg==", profilePicture: "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z/C/HgAGgwJ/lK3Q6wAAAABJRU5ErkJggg==" });
        // @ts-ignore
        return axios.post(`${wePay4Cars_uri}/User`, data);
    };
    const createWp4cVehicle = (token) => {
        let licenseDiskBase64 = !vehicleSpecs.licenseDisk || vehicleSpecs.licenseDisk.length <= 0
            ? "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z/C/HgAGgwJ/lK3Q6wAAAABJRU5ErkJggg=="
            : vehicleSpecs.licenseDisk.split(",")[1];
        let data = Object.assign(Object.assign({}, vehicleSpecs), { vehicleVariantId: vehicleSpecs.variantId, licenseDisk: licenseDiskBase64, registration: vehicleSpecs.regNo, transmissionType: vehicleSpecs.transmission });
        // @ts-ignore
        return axios.post(`${wePay4Cars_uri}/vehicle`, data, {
            headers: {
                authorization: `Bearer ${token}`,
            },
        });
    };
    const saveWp4cVehicleImages = (token, listingId) => {
        let images = [];
        Object.keys(vehicleImages).map((key, value) => {
            images.push({
                image: vehicleImages[key].split(",")[1],
                imageType: key,
            });
        });
        // @ts-ignore
        return axios.put(`${wePay4Cars_uri}/vehicle/image`, images, {
            headers: {
                authorization: `Bearer ${token}`,
            },
            params: {
                vehicleListingId: listingId,
            },
        });
    };
    const confirmTrade = (token, listingId) => {
        // @ts-ignore
        return axios.post(`${wePay4Cars_uri}/vehicle/confirmTrade`, null, {
            headers: {
                authorization: `Bearer ${token}`,
            },
            params: {
                vehicleListingId: listingId,
            },
        });
    };
    const createLead = () => {
        let data = {
            name: `${personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName} ${personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.lastName}`,
            firstName: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName,
            lastName: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.lastName,
            phoneNumber: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.mobileNumber,
            emailAddress: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.emailAddress,
            location: `${personalDetails.city}, ${personalDetails.province}, ${personalDetails.country}`,
            availability: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.availability,
            dealerId: dealerId,
            leadSourceId: leadSourceId,
            leadTypeId: 11, //tradein
            TypeCode: "TRADEIN",
            notes: "",
            dateUpdated: new Date().toISOString(),
        };
        // @ts-ignore
        return axios.post(`${base_uri}/leads`, data);
    };
    const createTradeIn = (leadId, confirmedListing) => {
        var _a, _b, _c, _d, _e, _f;
        const { vehicle } = confirmedListing;
        const { variant, uploads } = vehicle;
        const { model } = variant;
        let images = [];
        if (uploads && (uploads === null || uploads === void 0 ? void 0 : uploads.length) > 0) {
            for (let i = 0; i < (uploads === null || uploads === void 0 ? void 0 : uploads.length); i++) {
                let image = {
                    imageUrl: `${wePay4Cars_uri === null || wePay4Cars_uri === void 0 ? void 0 : wePay4Cars_uri.replace("/api", "")}/${(_a = uploads[i]) === null || _a === void 0 ? void 0 : _a.imageUrl}`,
                    imageOrientation: (_c = (_b = uploads[i]) === null || _b === void 0 ? void 0 : _b.type) === null || _c === void 0 ? void 0 : _c.id,
                };
                images.push(image);
            }
        }
        let data = {
            leadId: leadId,
            wePay4CarsListingId: confirmedListing === null || confirmedListing === void 0 ? void 0 : confirmedListing.id,
            vinNumber: vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin,
            year: parseInt(vehicle === null || vehicle === void 0 ? void 0 : vehicle.year),
            transmission: (_d = vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmission) === null || _d === void 0 ? void 0 : _d.toString(),
            fuelType: (_e = vehicle === null || vehicle === void 0 ? void 0 : vehicle.fuelType) === null || _e === void 0 ? void 0 : _e.toString(),
            odometer: vehicle === null || vehicle === void 0 ? void 0 : vehicle.odometer,
            color: vehicle === null || vehicle === void 0 ? void 0 : vehicle.color,
            hasSpareKeys: vehicle === null || vehicle === void 0 ? void 0 : vehicle.hasSpareKeys,
            hasServiceBook: vehicle === null || vehicle === void 0 ? void 0 : vehicle.hasServiceBook,
            hasWarranty: vehicle === null || vehicle === void 0 ? void 0 : vehicle.hasWarranty,
            hasMaintenancePlan: vehicle === null || vehicle === void 0 ? void 0 : vehicle.hasMaintenancePlan,
            registration: vehicle === null || vehicle === void 0 ? void 0 : vehicle.registration,
            variant: {
                name: variant === null || variant === void 0 ? void 0 : variant.name,
                mmCode: variant === null || variant === void 0 ? void 0 : variant.mmCode,
                introYear: variant === null || variant === void 0 ? void 0 : variant.startYear,
                discontinueYear: variant === null || variant === void 0 ? void 0 : variant.endYear,
            },
            model: {
                name: model === null || model === void 0 ? void 0 : model.name,
            },
            make: {
                name: (_f = model === null || model === void 0 ? void 0 : model.manufacturer) === null || _f === void 0 ? void 0 : _f.name,
            },
            tradeInVehicleImages: images,
        };
        // @ts-ignore
        return axios.post(`${base_uri}/TradeInVehicle`, data);
    };
    const processLead = (leadId) => {
        // @ts-ignore
        axios.post(`${base_uri}/Leads/ProcessLead/${leadId}`, {})
            .then((response) => {
            setLoading(false);
            enqueueSnackbar("Successfully saved and submitted the captured details", { variant: "success" });
            if (resetForm && resetForm == true) {
                resetFormValues();
            }
            if (isRedirectOnConfirm) {
                setShowNewUsedModal(true);
            }
            else {
                setTimeout(() => {
                    onSubmit(true);
                }, 500);
            }
        })
            .catch((error) => {
            setLoading(false);
            enqueueSnackbar("Failed to save the vehicle details", {
                variant: "error",
            });
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.holder },
            React.createElement(Modal, { open: showNewUsedModal, onClose: handleClose, "aria-labelledby": "parent-modal-title", "aria-describedby": "parent-modal-description" },
                React.createElement(Box$1, { className: classes.newUsedModal },
                    React.createElement(Box$1, { className: classes.newUsedContent },
                        React.createElement("h2", { id: "parent-modal-title" }, "Sell Vehicle Process Complete"),
                        React.createElement("p", { id: "parent-modal-description" }, "We have Successfully saved and submitted the captured details."),
                        React.createElement(Grid$1, { item: true, xs: 12, container: true, justify: "center" },
                            React.createElement("div", null,
                                React.createElement(Button$1, { variant: "contained", color: "primary", type: "submit", className: classes.modalBtn, ref: anchorRef, id: "composition-button", "aria-controls": open ? "composition-menu" : undefined, "aria-expanded": open ? "true" : undefined, "aria-haspopup": "true", onClick: handleToggle }, "Done"),
                                React.createElement(Popper, { open: open, anchorEl: anchorRef.current, role: undefined, placement: "bottom-start", transition: true, disablePortal: true }, ({ TransitionProps, placement }) => (React.createElement(Grow, Object.assign({}, TransitionProps, { style: {
                                        transformOrigin: placement === "bottom-start"
                                            ? "left top"
                                            : "left bottom",
                                    } }),
                                    React.createElement(Paper, null,
                                        React.createElement(MenuList, { autoFocusItem: open, id: "composition-menu", "aria-labelledby": "composition-button" },
                                            React.createElement("div", { className: classes.dropDownText }, "Are you looking for a new or used car?"),
                                            React.createElement(MenuItem$2, { onClick: () => handleClose(1), className: classes.options }, "New Car"),
                                            React.createElement(MenuItem$2, { onClick: () => handleClose(2), className: classes.options }, "Used Car"),
                                            React.createElement(MenuItem$2, { onClick: () => handleClose(0), className: classes.options }, "Not Interested"))))))))))),
            loading && (React.createElement(React.Fragment, null,
                React.createElement(CardHeader, { className: "p-4", title: "Submitting the captured details" }),
                React.createElement("div", { className: classes.holderInner },
                    React.createElement(Grid$1, { container: true, justifyContent: "center" },
                        React.createElement(CircularProgress$1, null))))),
            !loading && (React.createElement(React.Fragment, null,
                React.createElement(CardHeader, { className: "p-4", title: "Please confirm your details are correct" }),
                React.createElement("div", { className: classes.holderInner },
                    React.createElement(Grid$1, { container: true, spacing: 4 },
                        React.createElement(Grid$1, { item: true, xs: 12, container: true, spacing: 1, direction: "row" },
                            !Object.keys(personalDetails).length && (React.createElement(Grid$1, { item: true, xs: 12 },
                                React.createElement(Typography$1, { variant: "h6", color: "textSecondary" }, "No personal information available"))),
                            Object.keys(personalDetails).length > 0 && (React.createElement(React.Fragment, null,
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Full Name"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null,
                                            personalDetails.firstName,
                                            " ",
                                            personalDetails.lastName))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Mobile Number"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, personalDetails.mobileNumber))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Email Address"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, personalDetails.emailAddress))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "When would you like to sell your vehicle?"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, personalDetails.availability)))))),
                        React.createElement(Divider$1, null),
                        React.createElement(Grid$1, { item: true, xs: 12, container: true, spacing: 1 },
                            !Object.keys(vehicleSpecs).length && (React.createElement(Grid$1, { item: true, xs: 12 },
                                React.createElement(Typography$1, { variant: "h6", color: "textSecondary" }, "No vehicle information available"))),
                            Object.keys(vehicleSpecs).length > 0 && (React.createElement(React.Fragment, null,
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Make"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.make))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Model"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.model))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Year"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.year))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Variant"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.variant))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Odometer Reading"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.odometer))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Color"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.color))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "VIN Number"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.vin))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Registration Number"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.regNo))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Transmission"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.transmission))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Fuel Type"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.fuelType))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Spare Keys"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.spareKeys ? "Yes" : "No"))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Service Book"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.serviceBook ? "Yes" : "No"))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Maintenance Plan"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.maintenancePlan ? "Yes" : "No"))),
                                React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4, className: "pb-5" },
                                    React.createElement(Typography$1, { variant: "caption", color: "textSecondary", component: "p" }, "Warranty"),
                                    React.createElement(Typography$1, { variant: "body2", component: "p" },
                                        React.createElement("strong", null, vehicleSpecs.warranty ? "Yes" : "No")))))),
                        React.createElement(Divider$1, null),
                        React.createElement(Grid$1, { item: true, xs: 12, container: true, spacing: 1 },
                            !Object.keys(vehicleImages).length && (React.createElement(Grid$1, { item: true, xs: 12 },
                                React.createElement(Typography$1, { variant: "h6", color: "textSecondary" }, "No vehicle photos available"))),
                            Object.keys(vehicleImages).length > 0 && (React.createElement(Grid$1, { item: true, xs: 12, container: true, spacing: 2, justifyContent: "space-between", direction: "row" }, Object.keys(vehicleImages).map((key) => (React.createElement(Grid$1, { item: true, xs: 12, sm: 6, md: 4 },
                                React.createElement("img", { alt: `Vehicle ${key} image`, src: vehicleImages[key], className: classes.img }))))))),
                        React.createElement(Divider$1, null),
                        React.createElement(Grid$1, { item: true, xs: 12, container: true, justify: "flex-end" },
                            React.createElement(Button$1, { className: classes.btn, variant: "contained", color: "primary", type: "submit", onClick: () => confirmDetails() }, "Confirm")))))))));
};

const useStyles = makeStyles((theme) => ({
    tradeContainer: {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        padding: theme.spacing(4, 0, 10),
    },
    contents: {
        maxWidth: "1280px",
        paddingLeft: "24px",
        paddingRight: "24px",
        color: "white",
    },
    btn: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "2%",
        width: "100%",
        background: "#e30011",
        color: "white",
        fontWeight: "bold",
        fontSize: "20px",
        cursor: "pointer",
        padding: "15px 20px",
    },
    flex: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-around",
        padding: "40px 0px",
    },
    red: {
        color: "#e30011",
        //, color:'#ed0000'
    },
    text: {
        textAlign: "center",
        padding: theme.spacing(2, 25, 6),
        fontSize: "1.0rem",
        display: "block",
        margin: "0 auto",
        color: "white",
        "@media (max-width: 426px)": {
            padding: theme.spacing(2, 5, 6),
        },
    },
    heading: {
        textAlign: "center",
        padding: theme.spacing(2, 0, 0),
        fontSize: "2.8rem",
    },
    btnHolder: {
        display: 'flex',
    },
    cta: {
        //@ts-ignore
        background: ({ primaryColor }) => `${primaryColor} !important`,
        padding: '10px',
        margin: '10px'
    },
    anchor: {
        color: 'white',
        padding: '10px 20px',
        textDecoration: 'none',
        border: 'none',
    },
    primary: {
        //@ts-ignore
        background: ({ primaryColor }) => `${primaryColor} !important`,
    },
}));
const SellYourVehicleWePay4Cars = ({ base_uri, wePay4Cars_uri, dealerId, leadSourceId = 15, licenseDiskScanner, filterCat, newCarLink, usedCarLink, websiteColors, dealerList, personalDetailsRightSection, resetForm, setFocus, onSubmitForm, includeAvailability, isRedirectOnConfirm, paper, paperColor, paperShadowColor, }) => {
    const classes = useStyles(Object.assign({}, websiteColors));
    const [tabIndex, setTabIndex] = useState(0);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [personalDetailsFormData, setPersonalDetailsFormData] = useState({});
    const [vehicleSpecsFormData, setVehicleDetailsFormData] = useState({});
    const [vehicleImageFormData, setVehicleImageFormData] = useState({});
    const [activeDealerId, setActiveDealerId] = useState(dealerId);
    const submitPersonalDetails = (personalDetails) => {
        setPersonalDetailsFormData(personalDetails);
        setTabIndex(tabIndex + 1);
        scroll();
    };
    const submitVehicleSpecs = (vehicleSpecs) => {
        setVehicleDetailsFormData(vehicleSpecs);
        setTabIndex(tabIndex + 1);
        scroll();
    };
    const submitVehicleImages = (vehicleImages) => {
        setVehicleImageFormData(vehicleImages);
        setTabIndex(tabIndex + 1);
        scroll();
    };
    const submitForms = () => {
        if (resetForm && resetForm == true) {
            setTabIndex(0);
        }
        else {
            setIsSubmitted(true);
        }
        scroll();
    };
    const handleTabChange = (event, newTab) => {
        if (newTab != tabIndex) {
            setTabIndex(newTab);
        }
    };
    const scroll = () => {
        if (setFocus && !!setFocus) {
            setTimeout(() => {
                var element = document.getElementById(setFocus);
                //@ts-ignore
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            }, 500);
        }
    };
    const tabs = [
        {
            id: 0,
            label: "About you",
            comp: (React.createElement(PersonalDetailsForm, { personalDetails: personalDetailsFormData, onSubmit: submitPersonalDetails, websiteColors: websiteColors, defaultDealerId: activeDealerId ? activeDealerId : dealerId, rightSection: personalDetailsRightSection, setAtiveDealerId: setActiveDealerId, dealerList: dealerList, wePay4Cars_uri: wePay4Cars_uri, includeAvailability: includeAvailability, paper: paper, paperColor: paperColor, paperShadowColor: paperShadowColor })),
        },
        {
            id: 1,
            label: "Vehicle Specs",
            comp: (React.createElement(VehicleSpecsForm, { vehicle: vehicleSpecsFormData, onSubmit: submitVehicleSpecs, base_uri: base_uri, wePay4Cars_uri: wePay4Cars_uri, websiteColors: websiteColors, licenseDiskScanner: licenseDiskScanner, filterCat: filterCat, paper: paper, paperColor: paperColor, paperShadowColor: paperShadowColor })),
        },
        {
            id: 2,
            label: "Photos",
            comp: (React.createElement(VehicleImageForm, { images: vehicleImageFormData, onSubmit: submitVehicleImages, paper: paper, paperColor: paperColor, paperShadowColor: paperShadowColor }))
        },
        {
            id: 3,
            label: "Vehicle Summary",
            comp: (React.createElement(ConfirmationContainer, { onSubmit: submitForms, base_uri: base_uri, dealerId: activeDealerId ? activeDealerId : dealerId, leadSourceId: leadSourceId, personalDetails: personalDetailsFormData, vehicleSpecs: vehicleSpecsFormData, vehicleImages: vehicleImageFormData, websiteColors: websiteColors, resetForm: resetForm, setFocus: setFocus, onSubmitForm: onSubmitForm, wePay4Cars_uri: wePay4Cars_uri, newCarLink: newCarLink, usedCarLink: usedCarLink, isRedirectOnConfirm: isRedirectOnConfirm, paper: paper, paperColor: paperColor, paperShadowColor: paperShadowColor })),
        },
    ];
    return (React.createElement(Container$1, { maxWidth: "lg", className: classes.tradeContainer },
        React.createElement(Grid$1, { container: true, spacing: 0 },
            React.createElement(Grid$1, { item: true, xs: 12 },
                React.createElement("div", { className: "mb-4" },
                    React.createElement(Tabs, { variant: "scrollable", scrollButtons: "on", value: tabIndex, classes: { indicator: classes.primary } }, tabs.map((step, index) => (React.createElement(Tab, { key: step.id, label: `Step ${index + 1} - ${step.label}`, onClick: (e) => handleTabChange(e, index) })))))),
            isSubmitted && React.createElement(React.Fragment, null,
                React.createElement(Grid$1, { item: true, xs: 12, container: true, justifyContent: "center" },
                    React.createElement("div", null,
                        React.createElement(Typography$1, { variant: "h6", color: "textSecondary" }, "Information successfully captured and submitted"))),
                React.createElement(Grid$1, { item: true, xs: 12, container: true, justifyContent: "center" },
                    React.createElement("div", { className: classes.btnHolder },
                        React.createElement("button", { className: classes.cta },
                            React.createElement("a", { className: classes.anchor, href: newCarLink }, "New Cars")),
                        React.createElement("button", { className: classes.cta },
                            React.createElement("a", { className: classes.anchor, href: usedCarLink }, "Used Cars"))))),
            !isSubmitted && (React.createElement(Grid$1, { item: true, xs: 12 }, tabs.map((step, index) => (React.createElement(React.Fragment, { key: step.id }, tabIndex === index ? step.comp : null))))))));
};

const MetaTagsContext = createContext({ tags: {}, updateTags: (newTags) => { } });
const MetaTagsProvider = ({ children }) => {
    const [tags, setTags] = useState({});
    const updateTags = (newTags) => {
        setTags(newTags);
    };
    return (React.createElement(MetaTagsContext.Provider, { value: { tags, updateTags } }, children));
};

const MetaTags = ({ dealer, pathname, canonical = undefined }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState('');
    const [canon, setCanon] = useState('');
    // Contexts
    const { tags } = useContext(MetaTagsContext);
    const camelCase = (str) => {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word) => {
            if (typeof word !== "string" || word === undefined || word === null) {
                return '';
            }
            return word.toUpperCase();
        }).replace(/\s+/g, ' ');
    };
    const formatText = (parts) => {
        const result = [];
        return parts.reduce((ac, item) => {
            // Remove null and undefined items
            if (item != null || item !== undefined || item !== '') {
                ac.push(item);
            }
            return ac;
            // Join title parts by a |
        }, result).join(' | ');
    };
    useEffect(() => {
        // Dealer Name
        const dealerName = (dealer === null || dealer === void 0 ? void 0 : dealer.name) && typeof dealer.name === 'string' ? dealer.name.replace('Master', '') : '';
        // Title
        const page = pathname === null || pathname === void 0 ? void 0 : pathname.split('/')[1];
        const pageName = page === null || page === void 0 ? void 0 : page.replace(/-/g, ' ');
        const defaultTitle = camelCase(formatText([pageName || 'Home', dealerName]));
        // Canonical URL
        const defaultCanonical = `https://${pathname}/`;
        // Description
        const defaultDescription = defaultTitle;
        // Image
        const defaultImage = (dealer === null || dealer === void 0 ? void 0 : dealer.makes) && (dealer === null || dealer === void 0 ? void 0 : dealer.makes.length) > 0 ? dealer === null || dealer === void 0 ? void 0 : dealer.makes[0].logo : '';
        // If current page manages its own tag context
        if ((tags === null || tags === void 0 ? void 0 : tags.pathname) === pathname) {
            setTitle((tags === null || tags === void 0 ? void 0 : tags.title) ? formatText(tags.title) : defaultTitle);
            setDescription((tags === null || tags === void 0 ? void 0 : tags.description) ? formatText(tags.description) : defaultDescription);
            setImage((tags === null || tags === void 0 ? void 0 : tags.image) ? tags.image : defaultImage);
            setCanon((tags === null || tags === void 0 ? void 0 : tags.pathname) ? tags.canonical : defaultCanonical);
        }
        else {
            setTitle(defaultTitle);
            setDescription(defaultDescription);
            setImage(defaultImage);
            setCanon(defaultCanonical);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dealer, tags, pathname]);
    return (React.createElement("div", { className: "application" },
        React.createElement(Helmet, null,
            React.createElement("meta", { charSet: "utf-8" }),
            React.createElement("title", null, title),
            React.createElement("meta", { name: "description", content: description }),
            React.createElement("link", { rel: "canonical", href: canon }),
            React.createElement("meta", { property: "og:title", content: title }),
            React.createElement("meta", { property: "og:description", content: description }),
            React.createElement("meta", { property: "og:image", content: image }),
            React.createElement("meta", { property: "twitter:title", content: title }),
            React.createElement("meta", { property: "twitter:description", content: description }),
            React.createElement("meta", { property: "twitter:image", content: image }))));
};

// Meta Tags Hook
const useMetaTags = (initialTags) => {
    const [metaTags, setMetaTags] = useState(initialTags || {});
    const { updateTags } = useContext(MetaTagsContext);
    const updateMetaTags = (t) => setMetaTags(t);
    useEffect(() => {
        updateTags(metaTags);
    }, [updateTags, metaTags]);
    return { updateMetaTags };
};

export { ContactUs, DealerNetwork, Finance, GAEvent, GAInit, GAPageView, MetaTags, MetaTagsProvider, Parts, SellYourVehicle, SellYourVehicleWePay4Cars, Service, SideBarsContainer, UsedVehiclesFilter, VehiclesFilterV2, VehiclesFilterV3, useMetaTags };
//# sourceMappingURL=index.es.js.map
